/*!
* FitVids 1.1
*
* Copyright 2013, Chris Coyier - http://css-tricks.com + Dave Rupert - http://daverupert.com
* Credit to Thierry Koblentz - http://www.alistapart.com/articles/creating-intrinsic-ratios-for-video/
* Released under the WTFPL license - http://sam.zoy.org/wtfpl/
*
*/
(function (a) {
    a.fn.fitVids = function (b) {
        var e = {customSelector: null, ignore: null};
        if (!document.getElementById("fit-vids-style")) {
            var d = document.head || document.getElementsByTagName("head")[0];
            var c = ".fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}";
            var f = document.createElement("div");
            f.innerHTML = '<p>x</p><style id="fit-vids-style">' + c + "</style>";
            d.appendChild(f.childNodes[1])
        }
        if (b) {
            a.extend(e, b)
        }
        return this.each(function () {
            var g = ['iframe[src*="player.vimeo.com"]', 'iframe[src*="youtube.com"]', 'iframe[src*="youtube-nocookie.com"]', 'iframe[src*="kickstarter.com"][src*="video.html"]', "object", "embed"];
            if (e.customSelector) {
                g.push(e.customSelector)
            }
            var h = ".fitvidsignore";
            if (e.ignore) {
                h = h + ", " + e.ignore
            }
            var i = a(this).find(g.join(","));
            i = i.not("object object");
            i = i.not(h);
            i.each(function () {
                var n = a(this);
                if (n.parents(h).length > 0) {
                    return
                }
                if (this.tagName.toLowerCase() === "embed" && n.parent("object").length || n.parent(".fluid-width-video-wrapper").length) {
                    return
                }
                if ((!n.css("height") && !n.css("width")) && (isNaN(n.attr("height")) || isNaN(n.attr("width")))) {
                    n.attr("height", 9);
                    n.attr("width", 16)
                }
                var j = (this.tagName.toLowerCase() === "object" || (n.attr("height") && !isNaN(parseInt(n.attr("height"), 10)))) ? parseInt(n.attr("height"), 10) : n.height(),
                    k = !isNaN(parseInt(n.attr("width"), 10)) ? parseInt(n.attr("width"), 10) : n.width(), l = j / k;
                if (!n.attr("id")) {
                    var m = "fitvid" + Math.floor(Math.random() * 999999);
                    n.attr("id", m)
                }
                n.wrap('<div class="fluid-width-video-wrapper"></div>').parent(".fluid-width-video-wrapper").css("padding-top", (l * 100) + "%");
                n.removeAttr("height").removeAttr("width")
            })
        })
    }
})(window.jQuery || window.Zepto);

/*!
 * imagesLoaded PACKAGED v3.1.8
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

(function () {
    function e() {
    }

    function t(e, t) {
        for (var n = e.length; n--;) if (e[n].listener === t) return n;
        return -1
    }

    function n(e) {
        return function () {
            return this[e].apply(this, arguments)
        }
    }

    var i = e.prototype, r = this, o = r.EventEmitter;
    i.getListeners = function (e) {
        var t, n, i = this._getEvents();
        if ("object" == typeof e) {
            t = {};
            for (n in i) i.hasOwnProperty(n) && e.test(n) && (t[n] = i[n])
        } else t = i[e] || (i[e] = []);
        return t
    }, i.flattenListeners = function (e) {
        var t, n = [];
        for (t = 0; e.length > t; t += 1) n.push(e[t].listener);
        return n
    }, i.getListenersAsObject = function (e) {
        var t, n = this.getListeners(e);
        return n instanceof Array && (t = {}, t[e] = n), t || n
    }, i.addListener = function (e, n) {
        var i, r = this.getListenersAsObject(e), o = "object" == typeof n;
        for (i in r) r.hasOwnProperty(i) && -1 === t(r[i], n) && r[i].push(o ? n : {listener: n, once: !1});
        return this
    }, i.on = n("addListener"), i.addOnceListener = function (e, t) {
        return this.addListener(e, {listener: t, once: !0})
    }, i.once = n("addOnceListener"), i.defineEvent = function (e) {
        return this.getListeners(e), this
    }, i.defineEvents = function (e) {
        for (var t = 0; e.length > t; t += 1) this.defineEvent(e[t]);
        return this
    }, i.removeListener = function (e, n) {
        var i, r, o = this.getListenersAsObject(e);
        for (r in o) o.hasOwnProperty(r) && (i = t(o[r], n), -1 !== i && o[r].splice(i, 1));
        return this
    }, i.off = n("removeListener"), i.addListeners = function (e, t) {
        return this.manipulateListeners(!1, e, t)
    }, i.removeListeners = function (e, t) {
        return this.manipulateListeners(!0, e, t)
    }, i.manipulateListeners = function (e, t, n) {
        var i, r, o = e ? this.removeListener : this.addListener, s = e ? this.removeListeners : this.addListeners;
        if ("object" != typeof t || t instanceof RegExp) for (i = n.length; i--;) o.call(this, t, n[i]); else for (i in t) t.hasOwnProperty(i) && (r = t[i]) && ("function" == typeof r ? o.call(this, i, r) : s.call(this, i, r));
        return this
    }, i.removeEvent = function (e) {
        var t, n = typeof e, i = this._getEvents();
        if ("string" === n) delete i[e]; else if ("object" === n) for (t in i) i.hasOwnProperty(t) && e.test(t) && delete i[t]; else delete this._events;
        return this
    }, i.removeAllListeners = n("removeEvent"), i.emitEvent = function (e, t) {
        var n, i, r, o, s = this.getListenersAsObject(e);
        for (r in s) if (s.hasOwnProperty(r)) for (i = s[r].length; i--;) n = s[r][i], n.once === !0 && this.removeListener(e, n.listener), o = n.listener.apply(this, t || []), o === this._getOnceReturnValue() && this.removeListener(e, n.listener);
        return this
    }, i.trigger = n("emitEvent"), i.emit = function (e) {
        var t = Array.prototype.slice.call(arguments, 1);
        return this.emitEvent(e, t)
    }, i.setOnceReturnValue = function (e) {
        return this._onceReturnValue = e, this
    }, i._getOnceReturnValue = function () {
        return this.hasOwnProperty("_onceReturnValue") ? this._onceReturnValue : !0
    }, i._getEvents = function () {
        return this._events || (this._events = {})
    }, e.noConflict = function () {
        return r.EventEmitter = o, e
    }, "function" == typeof define && define.amd ? define("eventEmitter/EventEmitter", [], function () {
        return e
    }) : "object" == typeof module && module.exports ? module.exports = e : this.EventEmitter = e
}).call(this), function (e) {
    function t(t) {
        var n = e.event;
        return n.target = n.target || n.srcElement || t, n
    }

    var n = document.documentElement, i = function () {
    };
    n.addEventListener ? i = function (e, t, n) {
        e.addEventListener(t, n, !1)
    } : n.attachEvent && (i = function (e, n, i) {
        e[n + i] = i.handleEvent ? function () {
            var n = t(e);
            i.handleEvent.call(i, n)
        } : function () {
            var n = t(e);
            i.call(e, n)
        }, e.attachEvent("on" + n, e[n + i])
    });
    var r = function () {
    };
    n.removeEventListener ? r = function (e, t, n) {
        e.removeEventListener(t, n, !1)
    } : n.detachEvent && (r = function (e, t, n) {
        e.detachEvent("on" + t, e[t + n]);
        try {
            delete e[t + n]
        } catch (i) {
            e[t + n] = void 0
        }
    });
    var o = {bind: i, unbind: r};
    "function" == typeof define && define.amd ? define("eventie/eventie", o) : e.eventie = o
}(this), function (e, t) {
    "function" == typeof define && define.amd ? define(["eventEmitter/EventEmitter", "eventie/eventie"], function (n, i) {
        return t(e, n, i)
    }) : "object" == typeof exports ? module.exports = t(e, require("wolfy87-eventemitter"), require("eventie")) : e.imagesLoaded = t(e, e.EventEmitter, e.eventie)
}(window, function (e, t, n) {
    function i(e, t) {
        for (var n in t) e[n] = t[n];
        return e
    }

    function r(e) {
        return "[object Array]" === d.call(e)
    }

    function o(e) {
        var t = [];
        if (r(e)) t = e; else if ("number" == typeof e.length) for (var n = 0, i = e.length; i > n; n++) t.push(e[n]); else t.push(e);
        return t
    }

    function s(e, t, n) {
        if (!(this instanceof s)) return new s(e, t);
        "string" == typeof e && (e = document.querySelectorAll(e)), this.elements = o(e), this.options = i({}, this.options), "function" == typeof t ? n = t : i(this.options, t), n && this.on("always", n), this.getImages(), a && (this.jqDeferred = new a.Deferred);
        var r = this;
        setTimeout(function () {
            r.check()
        })
    }

    function f(e) {
        this.img = e
    }

    function c(e) {
        this.src = e, v[e] = this
    }

    var a = e.jQuery, u = e.console, h = u !== void 0, d = Object.prototype.toString;
    s.prototype = new t, s.prototype.options = {}, s.prototype.getImages = function () {
        this.images = [];
        for (var e = 0, t = this.elements.length; t > e; e++) {
            var n = this.elements[e];
            "IMG" === n.nodeName && this.addImage(n);
            var i = n.nodeType;
            if (i && (1 === i || 9 === i || 11 === i)) for (var r = n.querySelectorAll("img"), o = 0, s = r.length; s > o; o++) {
                var f = r[o];
                this.addImage(f)
            }
        }
    }, s.prototype.addImage = function (e) {
        var t = new f(e);
        this.images.push(t)
    }, s.prototype.check = function () {
        function e(e, r) {
            return t.options.debug && h && u.log("confirm", e, r), t.progress(e), n++, n === i && t.complete(), !0
        }

        var t = this, n = 0, i = this.images.length;
        if (this.hasAnyBroken = !1, !i) return this.complete(), void 0;
        for (var r = 0; i > r; r++) {
            var o = this.images[r];
            o.on("confirm", e), o.check()
        }
    }, s.prototype.progress = function (e) {
        this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded;
        var t = this;
        setTimeout(function () {
            t.emit("progress", t, e), t.jqDeferred && t.jqDeferred.notify && t.jqDeferred.notify(t, e)
        })
    }, s.prototype.complete = function () {
        var e = this.hasAnyBroken ? "fail" : "done";
        this.isComplete = !0;
        var t = this;
        setTimeout(function () {
            if (t.emit(e, t), t.emit("always", t), t.jqDeferred) {
                var n = t.hasAnyBroken ? "reject" : "resolve";
                t.jqDeferred[n](t)
            }
        })
    }, a && (a.fn.imagesLoaded = function (e, t) {
        var n = new s(this, e, t);
        return n.jqDeferred.promise(a(this))
    }), f.prototype = new t, f.prototype.check = function () {
        var e = v[this.img.src] || new c(this.img.src);
        if (e.isConfirmed) return this.confirm(e.isLoaded, "cached was confirmed"), void 0;
        if (this.img.complete && void 0 !== this.img.naturalWidth) return this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), void 0;
        var t = this;
        e.on("confirm", function (e, n) {
            return t.confirm(e.isLoaded, n), !0
        }), e.check()
    }, f.prototype.confirm = function (e, t) {
        this.isLoaded = e, this.emit("confirm", this, t)
    };
    var v = {};
    return c.prototype = new t, c.prototype.check = function () {
        if (!this.isChecked) {
            var e = new Image;
            n.bind(e, "load", this), n.bind(e, "error", this), e.src = this.src, this.isChecked = !0
        }
    }, c.prototype.handleEvent = function (e) {
        var t = "on" + e.type;
        this[t] && this[t](e)
    }, c.prototype.onload = function (e) {
        this.confirm(!0, "onload"), this.unbindProxyEvents(e)
    }, c.prototype.onerror = function (e) {
        this.confirm(!1, "onerror"), this.unbindProxyEvents(e)
    }, c.prototype.confirm = function (e, t) {
        this.isConfirmed = !0, this.isLoaded = e, this.emit("confirm", this, t)
    }, c.prototype.unbindProxyEvents = function (e) {
        n.unbind(e.target, "load", this), n.unbind(e.target, "error", this)
    }, s
});

/**
 * Module to add a shipping rates calculator to cart page.
 *
 * Copyright (c) 2011-2012 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

if (typeof Countries === "object") {
    Countries.updateProvinceLabel = function (d, a) {
        if (typeof d === "string" && Countries[d] && Countries[d].provinces) {
            if (typeof a !== "object") {
                a = document.getElementById("address_province_label");
                if (a === null) {
                    return
                }
            }
            a.innerHTML = Countries[d].label;
            var c = $(a).parent();
            var b = c.find("select");
            c.find(".custom-style-select-box-inner").html(Countries[d].provinces[0])
        }
    }
}
if (typeof Shopify.Cart === "undefined") {
    Shopify.Cart = {}
}
Shopify.Cart.ShippingCalculator = (function () {
    var _config = {
        submitButton: "Calculate shipping",
        submitButtonDisabled: "Calculating...",
        templateId: "shipping-calculator-response-template",
        wrapperId: "wrapper-response",
        customerIsLoggedIn: false,
        moneyFormat: "$ {{amount}}"
    };
    var _render = function (response) {
        var template = jQuery("#" + _config.templateId);
        var wrapper = jQuery("#" + _config.wrapperId);
        if (template.length && wrapper.length) {
            template.tmpl(response).appendTo(wrapper);
            if (typeof Currency !== "undefined" && typeof Currency.convertAll === "function") {
                var newCurrency = "";
                if (jQuery("[name=currencies]").size()) {
                    newCurrency = jQuery("[name=currencies]").val()
                } else {
                    if (jQuery("#currencies span.selected").size()) {
                        newCurrency = jQuery("#currencies span.selected").attr("data-currency")
                    }
                }
                if (newCurrency !== "") {
                    Currency.convertAll(shopCurrency, newCurrency, "#wrapper-response span.money, #estimated-shipping em span.money")
                }
            }
        }
    };
    var _enableButtons = function () {
    };
    var _disableButtons = function () {
    };
    var _getCartShippingRatesForDestination = function (shipping_address) {
        var params = {
            type: "GET",
            url: "/cart/shipping_rates.json",
            data: jQuery.param({shipping_address: shipping_address}),
            dataType: "json",
            success: function (response) {
                rates = response.shipping_rates;
                _onCartShippingRatesUpdate(rates, shipping_address)
            },
            error: function (XMLHttpRequest, textStatus) {
                _onError(XMLHttpRequest, textStatus)
            }
        };
        jQuery.ajax(params)
    };
    var _fullMessagesFromErrors = function (errors) {
        var fullMessages = [];
        jQuery.each(errors, function (attribute, messages) {
            jQuery.each(messages, function (index, message) {
                fullMessages.push(attribute + " " + message)
            })
        });
        return fullMessages
    };
    var _onError = function (XMLHttpRequest, textStatus) {
        jQuery("#estimated-shipping").hide();
        jQuery("#estimated-shipping em").empty();
        _enableButtons();
        var feedback = "";
        var data = eval("(" + XMLHttpRequest.responseText + ")");
        if (!!data.message) {
            feedback = data.message + "(" + data.status + "): " + data.description
        } else {
            feedback = "Error : " + _fullMessagesFromErrors(data).join("; ")
        }
        if (feedback === "Error : country is not supported.") {
            feedback = "We do not ship to this destination."
        }
        _render({rates: [], errorFeedback: feedback, success: false});
        jQuery("#" + _config.wrapperId).show()
    };
    var _onCartShippingRatesUpdate = function (rates, shipping_address) {
        _enableButtons();
        var readable_address = "";
        if (shipping_address.zip) {
            readable_address += shipping_address.zip + ", "
        }
        if (shipping_address.province) {
            readable_address += shipping_address.province + ", "
        }
        readable_address += shipping_address.country;
        if (rates.length) {
            if (rates[0].price == "0.00") {
                jQuery("#estimated-shipping em").html("FREE")
            } else {
                jQuery("#estimated-shipping em").html(_formatRate(rates[0].price))
            }
        }
        _render({rates: rates, address: readable_address, success: true});
        jQuery("#" + _config.wrapperId + ", #estimated-shipping").fadeIn()
    };
    var _formatRate = function (cents) {
        if (typeof cents == "string") {
            cents = cents.replace(".", "")
        }
        var value = "";
        var patt = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = _config.moneyFormat;

        function addCommas(moneyString) {
            return moneyString.replace(/(\d+)(\d{3}[\.,]?)/, "$1,$2")
        }

        function floatToString(numeric, decimals) {
            var amount = numeric.toFixed(decimals).toString();
            if (amount.match(/^\.\d+/)) {
                return "0" + amount
            } else {
                return amount
            }
        }

        switch (formatString.match(patt)[1]) {
            case"amount":
                value = addCommas(floatToString(cents / 100, 2));
                break;
            case"amount_no_decimals":
                value = addCommas(floatToString(cents / 100, 0));
                break;
            case"amount_with_comma_separator":
                value = floatToString(cents / 100, 2).replace(/\./, ",");
                break;
            case"amount_no_decimals_with_comma_separator":
                value = addCommas(floatToString(cents / 100, 0)).replace(/\./, ",");
                break
        }
        return formatString.replace(patt, value)
    };
    _init = function () {
        new Shopify.CountryProvinceSelector("address_country", "address_province", {hideElement: "address_province_container"});
        var countriesSelect = jQuery("#address_country");
        var addressProvinceLabelEl = jQuery("#address_province_label").get(0);
        if (typeof Countries !== "undefined") {
            Countries.updateProvinceLabel(countriesSelect.val(), addressProvinceLabelEl);
            countriesSelect.change(function () {
                Countries.updateProvinceLabel(countriesSelect.val(), addressProvinceLabelEl)
            })
        }
        jQuery(".get-rates").click(function () {
            _disableButtons();
            jQuery("#" + _config.wrapperId).empty().hide();
            var shippingAddress = {};
            shippingAddress.zip = jQuery("#address_zip").val() || "";
            shippingAddress.country = jQuery("#address_country").val() || "";
            shippingAddress.province = jQuery("#address_province").val() || "";
            _getCartShippingRatesForDestination(shippingAddress)
        });
    };
    return {
        show: function (params) {
            params = params || {};
            jQuery.extend(_config, params);
            jQuery(function () {
                _init()
            })
        }, getConfig: function () {
            return _config
        }, formatRate: function (cents) {
            return _formatRate(cents)
        }
    }
})();
/*
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

jQuery.cookie = function (b, j, m) {
    if (typeof j != "undefined") {
        m = m || {};
        if (j === null) {
            j = "";
            m.expires = -1
        }
        var e = "";
        if (m.expires && (typeof m.expires == "number" || m.expires.toUTCString)) {
            var f;
            if (typeof m.expires == "number") {
                f = new Date();
                f.setTime(f.getTime() + (m.expires * 24 * 60 * 60 * 1000))
            } else {
                f = m.expires
            }
            e = "; expires=" + f.toUTCString()
        }
        var l = m.path ? "; path=" + (m.path) : "";
        var g = m.domain ? "; domain=" + (m.domain) : "";
        var a = m.secure ? "; secure" : "";
        document.cookie = [b, "=", encodeURIComponent(j), e, l, g, a].join("")
    } else {
        var d = null;
        if (document.cookie && document.cookie != "") {
            var k = document.cookie.split(";");
            for (var h = 0; h < k.length; h++) {
                var c = jQuery.trim(k[h]);
                if (c.substring(0, b.length + 1) == (b + "=")) {
                    d = decodeURIComponent(c.substring(b.length + 1));
                    break
                }
            }
        }
        return d
    }
};

/*
 * Currency tools
 *
 * Copyright (c) 2015 Caroline Schnapp (mllegeorgesand@gmail.com)
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/mit-license.php
 *
 */

if (typeof Currency === 'undefined') {
    var Currency = {};
}

Currency.cookie = {
    configuration: {
        expires: 365,
        path: '/',
        domain: window.location.hostname
    },
    name: 'currency',
    write: function (currency) {
        jQuery.cookie(this.name, currency, this.configuration);
    },
    read: function () {
        return jQuery.cookie(this.name);
    },
    destroy: function () {
        jQuery.cookie(this.name, null, this.configuration);
    }
};

Currency.moneyFormats = {
    "USD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} USD"
    },
    "EUR": {
        "money_format": "&euro;{{amount}}",
        "money_with_currency_format": "&euro;{{amount}} EUR"
    },
    "GBP": {
        "money_format": "&pound;{{amount}}",
        "money_with_currency_format": "&pound;{{amount}} GBP"
    },
    "CAD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} CAD"
    },
    "ALL": {
        "money_format": "Lek {{amount}}",
        "money_with_currency_format": "Lek {{amount}} ALL"
    },
    "DZD": {
        "money_format": "DA {{amount}}",
        "money_with_currency_format": "DA {{amount}} DZD"
    },
    "AOA": {
        "money_format": "Kz{{amount}}",
        "money_with_currency_format": "Kz{{amount}} AOA"
    },
    "ARS": {
        "money_format": "${{amount_with_comma_separator}}",
        "money_with_currency_format": "${{amount_with_comma_separator}} ARS"
    },
    "AMD": {
        "money_format": "{{amount}} AMD",
        "money_with_currency_format": "{{amount}} AMD"
    },
    "AWG": {
        "money_format": "Afl{{amount}}",
        "money_with_currency_format": "Afl{{amount}} AWG"
    },
    "AUD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} AUD"
    },
    "BBD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} Bds"
    },
    "AZN": {
        "money_format": "m.{{amount}}",
        "money_with_currency_format": "m.{{amount}} AZN"
    },
    "BDT": {
        "money_format": "Tk {{amount}}",
        "money_with_currency_format": "Tk {{amount}} BDT"
    },
    "BSD": {
        "money_format": "BS${{amount}}",
        "money_with_currency_format": "BS${{amount}} BSD"
    },
    "BHD": {
        "money_format": "{{amount}}0 BD",
        "money_with_currency_format": "{{amount}}0 BHD"
    },
    "BYR": {
        "money_format": "Br {{amount}}",
        "money_with_currency_format": "Br {{amount}} BYR"
    },
    "BZD": {
        "money_format": "BZ${{amount}}",
        "money_with_currency_format": "BZ${{amount}} BZD"
    },
    "BTN": {
        "money_format": "Nu {{amount}}",
        "money_with_currency_format": "Nu {{amount}} BTN"
    },
    "BAM": {
        "money_format": "KM {{amount_with_comma_separator}}",
        "money_with_currency_format": "KM {{amount_with_comma_separator}} BAM"
    },
    "BRL": {
        "money_format": "R$ {{amount_with_comma_separator}}",
        "money_with_currency_format": "R$ {{amount_with_comma_separator}} BRL"
    },
    "BOB": {
        "money_format": "Bs{{amount_with_comma_separator}}",
        "money_with_currency_format": "Bs{{amount_with_comma_separator}} BOB"
    },
    "BWP": {
        "money_format": "P{{amount}}",
        "money_with_currency_format": "P{{amount}} BWP"
    },
    "BND": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} BND"
    },
    "BGN": {
        "money_format": "{{amount}} лв",
        "money_with_currency_format": "{{amount}} лв BGN"
    },
    "MMK": {
        "money_format": "K{{amount}}",
        "money_with_currency_format": "K{{amount}} MMK"
    },
    "KHR": {
        "money_format": "KHR{{amount}}",
        "money_with_currency_format": "KHR{{amount}}"
    },
    "KYD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} KYD"
    },
    "XAF": {
        "money_format": "FCFA{{amount}}",
        "money_with_currency_format": "FCFA{{amount}} XAF"
    },
    "CLP": {
        "money_format": "${{amount_no_decimals}}",
        "money_with_currency_format": "${{amount_no_decimals}} CLP"
    },
    "CNY": {
        "money_format": "&#165;{{amount}}",
        "money_with_currency_format": "&#165;{{amount}} CNY"
    },
    "COP": {
        "money_format": "${{amount_with_comma_separator}}",
        "money_with_currency_format": "${{amount_with_comma_separator}} COP"
    },
    "CRC": {
        "money_format": "&#8353; {{amount_with_comma_separator}}",
        "money_with_currency_format": "&#8353; {{amount_with_comma_separator}} CRC"
    },
    "HRK": {
        "money_format": "{{amount_with_comma_separator}} kn",
        "money_with_currency_format": "{{amount_with_comma_separator}} kn HRK"
    },
    "CZK": {
        "money_format": "{{amount_with_comma_separator}} K&#269;",
        "money_with_currency_format": "{{amount_with_comma_separator}} K&#269;"
    },
    "DKK": {
        "money_format": "{{amount_with_comma_separator}}",
        "money_with_currency_format": "kr.{{amount_with_comma_separator}}"
    },
    "DOP": {
        "money_format": "RD$ {{amount}}",
        "money_with_currency_format": "RD$ {{amount}}"
    },
    "XCD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "EC${{amount}}"
    },
    "EGP": {
        "money_format": "LE {{amount}}",
        "money_with_currency_format": "LE {{amount}} EGP"
    },
    "ETB": {
        "money_format": "Br{{amount}}",
        "money_with_currency_format": "Br{{amount}} ETB"
    },
    "XPF": {
        "money_format": "{{amount_no_decimals_with_comma_separator}} XPF",
        "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} XPF"
    },
    "FJD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "FJ${{amount}}"
    },
    "GMD": {
        "money_format": "D {{amount}}",
        "money_with_currency_format": "D {{amount}} GMD"
    },
    "GHS": {
        "money_format": "GH&#8373;{{amount}}",
        "money_with_currency_format": "GH&#8373;{{amount}}"
    },
    "GTQ": {
        "money_format": "Q{{amount}}",
        "money_with_currency_format": "{{amount}} GTQ"
    },
    "GYD": {
        "money_format": "G${{amount}}",
        "money_with_currency_format": "${{amount}} GYD"
    },
    "GEL": {
        "money_format": "{{amount}} GEL",
        "money_with_currency_format": "{{amount}} GEL"
    },
    "HNL": {
        "money_format": "L {{amount}}",
        "money_with_currency_format": "L {{amount}} HNL"
    },
    "HKD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "HK${{amount}}"
    },
    "HUF": {
        "money_format": "{{amount_no_decimals_with_comma_separator}}",
        "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} Ft"
    },
    "ISK": {
        "money_format": "{{amount_no_decimals}} kr",
        "money_with_currency_format": "{{amount_no_decimals}} kr ISK"
    },
    "INR": {
        "money_format": "Rs. {{amount}}",
        "money_with_currency_format": "Rs. {{amount}}"
    },
    "IDR": {
        "money_format": "{{amount_with_comma_separator}}",
        "money_with_currency_format": "Rp {{amount_with_comma_separator}}"
    },
    "ILS": {
        "money_format": "{{amount}} NIS",
        "money_with_currency_format": "{{amount}} NIS"
    },
    "JMD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} JMD"
    },
    "JPY": {
        "money_format": "&#165;{{amount_no_decimals}}",
        "money_with_currency_format": "&#165;{{amount_no_decimals}} JPY"
    },
    "JEP": {
        "money_format": "&pound;{{amount}}",
        "money_with_currency_format": "&pound;{{amount}} JEP"
    },
    "JOD": {
        "money_format": "{{amount}}0 JD",
        "money_with_currency_format": "{{amount}}0 JOD"
    },
    "KZT": {
        "money_format": "{{amount}} KZT",
        "money_with_currency_format": "{{amount}} KZT"
    },
    "KES": {
        "money_format": "KSh{{amount}}",
        "money_with_currency_format": "KSh{{amount}}"
    },
    "KWD": {
        "money_format": "{{amount}}0 KD",
        "money_with_currency_format": "{{amount}}0 KWD"
    },
    "KGS": {
        "money_format": "лв{{amount}}",
        "money_with_currency_format": "лв{{amount}}"
    },
    "LVL": {
        "money_format": "Ls {{amount}}",
        "money_with_currency_format": "Ls {{amount}} LVL"
    },
    "LBP": {
        "money_format": "L&pound;{{amount}}",
        "money_with_currency_format": "L&pound;{{amount}} LBP"
    },
    "LTL": {
        "money_format": "{{amount}} Lt",
        "money_with_currency_format": "{{amount}} Lt"
    },
    "MGA": {
        "money_format": "Ar {{amount}}",
        "money_with_currency_format": "Ar {{amount}} MGA"
    },
    "MKD": {
        "money_format": "ден {{amount}}",
        "money_with_currency_format": "ден {{amount}} MKD"
    },
    "MOP": {
        "money_format": "MOP${{amount}}",
        "money_with_currency_format": "MOP${{amount}}"
    },
    "MVR": {
        "money_format": "Rf{{amount}}",
        "money_with_currency_format": "Rf{{amount}} MRf"
    },
    "MXN": {
        "money_format": "$ {{amount}}",
        "money_with_currency_format": "$ {{amount}} MXN"
    },
    "MYR": {
        "money_format": "RM{{amount}} MYR",
        "money_with_currency_format": "RM{{amount}} MYR"
    },
    "MUR": {
        "money_format": "Rs {{amount}}",
        "money_with_currency_format": "Rs {{amount}} MUR"
    },
    "MDL": {
        "money_format": "{{amount}} MDL",
        "money_with_currency_format": "{{amount}} MDL"
    },
    "MAD": {
        "money_format": "{{amount}} dh",
        "money_with_currency_format": "Dh {{amount}} MAD"
    },
    "MNT": {
        "money_format": "{{amount_no_decimals}} &#8366",
        "money_with_currency_format": "{{amount_no_decimals}} MNT"
    },
    "MZN": {
        "money_format": "{{amount}} Mt",
        "money_with_currency_format": "Mt {{amount}} MZN"
    },
    "NAD": {
        "money_format": "N${{amount}}",
        "money_with_currency_format": "N${{amount}} NAD"
    },
    "NPR": {
        "money_format": "Rs{{amount}}",
        "money_with_currency_format": "Rs{{amount}} NPR"
    },
    "ANG": {
        "money_format": "&fnof;{{amount}}",
        "money_with_currency_format": "{{amount}} NA&fnof;"
    },
    "NZD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} NZD"
    },
    "NIO": {
        "money_format": "C${{amount}}",
        "money_with_currency_format": "C${{amount}} NIO"
    },
    "NGN": {
        "money_format": "&#8358;{{amount}}",
        "money_with_currency_format": "&#8358;{{amount}} NGN"
    },
    "NOK": {
        "money_format": "kr {{amount_with_comma_separator}}",
        "money_with_currency_format": "kr {{amount_with_comma_separator}} NOK"
    },
    "OMR": {
        "money_format": "{{amount_with_comma_separator}} OMR",
        "money_with_currency_format": "{{amount_with_comma_separator}} OMR"
    },
    "PKR": {
        "money_format": "Rs.{{amount}}",
        "money_with_currency_format": "Rs.{{amount}} PKR"
    },
    "PGK": {
        "money_format": "K {{amount}}",
        "money_with_currency_format": "K {{amount}} PGK"
    },
    "PYG": {
        "money_format": "Gs. {{amount_no_decimals_with_comma_separator}}",
        "money_with_currency_format": "Gs. {{amount_no_decimals_with_comma_separator}} PYG"
    },
    "PEN": {
        "money_format": "S/. {{amount}}",
        "money_with_currency_format": "S/. {{amount}} PEN"
    },
    "PHP": {
        "money_format": "&#8369;{{amount}}",
        "money_with_currency_format": "&#8369;{{amount}} PHP"
    },
    "PLN": {
        "money_format": "{{amount_with_comma_separator}} zl",
        "money_with_currency_format": "{{amount_with_comma_separator}} zl PLN"
    },
    "QAR": {
        "money_format": "QAR {{amount_with_comma_separator}}",
        "money_with_currency_format": "QAR {{amount_with_comma_separator}}"
    },
    "RON": {
        "money_format": "{{amount_with_comma_separator}} lei",
        "money_with_currency_format": "{{amount_with_comma_separator}} lei RON"
    },
    "RUB": {
        "money_format": "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
        "money_with_currency_format": "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"
    },
    "RWF": {
        "money_format": "{{amount_no_decimals}} RF",
        "money_with_currency_format": "{{amount_no_decimals}} RWF"
    },
    "WST": {
        "money_format": "WS$ {{amount}}",
        "money_with_currency_format": "WS$ {{amount}} WST"
    },
    "SAR": {
        "money_format": "{{amount}} SR",
        "money_with_currency_format": "{{amount}} SAR"
    },
    "STD": {
        "money_format": "Db {{amount}}",
        "money_with_currency_format": "Db {{amount}} STD"
    },
    "RSD": {
        "money_format": "{{amount}} RSD",
        "money_with_currency_format": "{{amount}} RSD"
    },
    "SCR": {
        "money_format": "Rs {{amount}}",
        "money_with_currency_format": "Rs {{amount}} SCR"
    },
    "SGD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} SGD"
    },
    "SYP": {
        "money_format": "S&pound;{{amount}}",
        "money_with_currency_format": "S&pound;{{amount}} SYP"
    },
    "ZAR": {
        "money_format": "R {{amount}}",
        "money_with_currency_format": "R {{amount}} ZAR"
    },
    "KRW": {
        "money_format": "&#8361;{{amount_no_decimals}}",
        "money_with_currency_format": "&#8361;{{amount_no_decimals}} KRW"
    },
    "LKR": {
        "money_format": "Rs {{amount}}",
        "money_with_currency_format": "Rs {{amount}} LKR"
    },
    "SEK": {
        "money_format": "{{amount_no_decimals}} kr",
        "money_with_currency_format": "{{amount_no_decimals}} kr SEK"
    },
    "CHF": {
        "money_format": "SFr. {{amount}}",
        "money_with_currency_format": "SFr. {{amount}} CHF"
    },
    "TWD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} TWD"
    },
    "THB": {
        "money_format": "{{amount}} &#xe3f;",
        "money_with_currency_format": "{{amount}} &#xe3f; THB"
    },
    "TZS": {
        "money_format": "{{amount}} TZS",
        "money_with_currency_format": "{{amount}} TZS"
    },
    "TTD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} TTD"
    },
    "TND": {
        "money_format": "{{amount}}",
        "money_with_currency_format": "{{amount}} DT"
    },
    "TRY": {
        "money_format": "{{amount}}TL",
        "money_with_currency_format": "{{amount}}TL"
    },
    "UGX": {
        "money_format": "Ush {{amount_no_decimals}}",
        "money_with_currency_format": "Ush {{amount_no_decimals}} UGX"
    },
    "UAH": {
        "money_format": "₴{{amount}}",
        "money_with_currency_format": "₴{{amount}} UAH"
    },
    "AED": {
        "money_format": "Dhs. {{amount}}",
        "money_with_currency_format": "Dhs. {{amount}} AED"
    },
    "UYU": {
        "money_format": "${{amount_with_comma_separator}}",
        "money_with_currency_format": "${{amount_with_comma_separator}} UYU"
    },
    "VUV": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}}VT"
    },
    "VEF": {
        "money_format": "Bs. {{amount_with_comma_separator}}",
        "money_with_currency_format": "Bs. {{amount_with_comma_separator}} VEF"
    },
    "VND": {
        "money_format": "{{amount_no_decimals_with_comma_separator}}&#8363;",
        "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} VND"
    },
    "XBT": {
        "money_format": "{{amount_no_decimals}} BTC",
        "money_with_currency_format": "{{amount_no_decimals}} BTC"
    },
    "XOF": {
        "money_format": "CFA{{amount}}",
        "money_with_currency_format": "CFA{{amount}} XOF"
    },
    "ZMW": {
        "money_format": "K{{amount_no_decimals_with_comma_separator}}",
        "money_with_currency_format": "ZMW{{amount_no_decimals_with_comma_separator}}"
    }
};

Currency.formatMoney = function (cents, format) {
    if (typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, format);
    }
    if (typeof cents == 'string') {
        cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');
        if (isNaN(number) || number == null) {
            return 0;
        }
        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';
        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }
    return formatString.replace(placeholderRegex, value);
};

Currency.currentCurrency = '';

Currency.format = 'money_with_currency_format';

Currency.convertAll = function (oldCurrency, newCurrency, selector, format) {
    jQuery(selector || 'span.money').each(function () {
        // If the amount has already been converted, we leave it alone.
        if (jQuery(this).attr('data-currency') === newCurrency) return;
        // If we are converting to a currency that we have saved, we will use the saved amount.
        if (jQuery(this).attr('data-currency-' + newCurrency)) {
            jQuery(this).html(jQuery(this).attr('data-currency-' + newCurrency));
        } else {
            // Converting to Y for the first time? Let's get to it!
            var cents = 0.0;
            var oldFormat = Currency.moneyFormats[oldCurrency][format || Currency.format] || '{{amount}}';
            var newFormat = Currency.moneyFormats[newCurrency][format || Currency.format] || '{{amount}}';
            if (oldFormat.indexOf('amount_no_decimals') !== -1) {
                cents = Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g, ''), 10) * 100, oldCurrency, newCurrency);
            } else if (oldCurrency === 'JOD' || oldCurrency == 'KWD' || oldCurrency == 'BHD') {
                cents = Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g, ''), 10) / 10, oldCurrency, newCurrency);
            } else {
                cents = Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g, ''), 10), oldCurrency, newCurrency);
            }
            var newFormattedAmount = Currency.formatMoney(cents, newFormat);
            jQuery(this).html(newFormattedAmount);
            jQuery(this).attr('data-currency-' + newCurrency, newFormattedAmount);
        }
        // We record the new currency locally.
        jQuery(this).attr('data-currency', newCurrency);
    });
    this.currentCurrency = newCurrency;
    this.cookie.write(newCurrency);
};

/*!
 * Revealer 2.0.0
 *
 * Copyright 2015, Pixel Union - http://pixelunion.net
 * Released under the MIT license
 */
(function ($) {
    // Simple requestAnimationFrame polyfill
    var raf = window.requestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        function (fn) {
            window.setTimeout(fn, 1000 / 60);
        }


    // Public API
    var methods = {
        isVisible: function (el) {
            return !!el.data("revealer-visible");
        },

        show: function (el, force) {
            // Check state
            if (methods.isVisible(el)) {
                el.removeClass("animating animating-in");
                el.off("revealer-animating revealer-show");
                return;
            }

            // Remove previous event listeners
            el.data("revealer-visible", true);
            el.off("trend");

            if (force) {
                el.addClass("visible");
                el.trigger("revealer-show");
                return;
            }

            raf(function () {
                // Start animation state transition
                el.addClass("animating animating-in");
                el.trigger("revealer-animating");

                raf(function () {
                    el.addClass("visible");

                    el.one("trend", function () {
                        el.removeClass("animating animating-in");
                        el.trigger("revealer-show");
                    });
                });
            });
        },

        hide: function (el, force) {
            // Check state
            if (!methods.isVisible(el)) {
                el.removeClass("animating animating-out visible");
                el.off("revealer-animating revealer-hide");
                return;
            }

            // Remove previous event listeners
            el.data("revealer-visible", false);
            el.off("trend");

            if (force) {
                el.removeClass("visible");
                el.trigger("revealer-hide");
                return;
            }

            raf(function () {
                el.addClass("animating animating-out");
                el.trigger("revealer-animating");

                raf(function () {
                    el.removeClass("visible");

                    el.one("trend", function () {
                        el.removeClass("animating animating-in animating-out");
                        el.trigger("revealer-hide");
                    });
                });
            });
        },

        toggle: function (el, force) {
            if (methods.isVisible(el)) {
                methods.hide(el, force);
            } else {
                methods.show(el, force);
            }
        }
    };

    // jQuery plugin
    $.fn.revealer = function (method, force) {
        // Get action
        var action = methods[method || "toggle"];
        if (!action) return this;

        // Run action
        if (method === "isVisible") {
            return action(this);
        }

        return this.each(function () {
            action($(this), force);
        });
    };
})(jQuery);

/*!
 * Trend 0.2.0
 *
 * Fail-safe TransitionEnd event for jQuery.
 *
 * Adds a new "trend" event that can be used in browsers that don't
 * support "transitionend".
 *
 * NOTE: Only supports being bound with "jQuery.one".
 *
 * Copyright 2014, Pixel Union - http://pixelunion.net
 * Released under the MIT license
 */
;(function ($) {

    // Prefixed transitionend event names
    var transitionEndEvents =
        "webkitTransitionEnd " +
        "otransitionend " +
        "oTransitionEnd " +
        "msTransitionEnd " +
        "transitionend";

    // Prefixed transition duration property names
    var transitionDurationProperties = [
        "transition-duration",
        "-moz-transition-duration",
        "-webkit-transition-duration",
        "-ms-transition-duration",
        "-o-transition-duration",
        "-khtml-transition-duration"
    ];

    // Prefixed transition delay property names
    var transitionDelayProperties = [
        "transition-delay",
        "-moz-transition-delay",
        "-webkit-transition-delay",
        "-ms-transition-delay",
        "-o-transition-delay",
        "-khtml-transition-delay"
    ];

    // Parses a CSS time value into milliseconds.
    var parseTime = function (s) {
        s = s.replace(/\s/, "");
        var v = window.parseFloat(s);

        return s.match(/[^m]s$/i)
            ? v * 1000
            : v;
    };

    // Parses the longest time unit found in a series of CSS properties.
    // Returns a value in milliseconds.
    var parseProperties = function (el, properties) {
        var duration = 0;

        for (var i = 0; i < properties.length; i++) {
            // Get raw CSS value
            var value = el.css(properties[i]);
            if (!value) continue;

            // Multiple transitions--pick the longest
            if (value.indexOf(",") !== -1) {
                var values = value.split(",");
                var durations = (function () {
                    var results = [];
                    for (var i = 0; i < values.length; i++) {
                        var duration = parseTime(values[i]);
                        results.push(duration);
                    }
                    return results;
                })();

                duration = Math.max.apply(Math, durations);
            }

            // Single transition
            else {
                duration = parseTime(value);
            }

            // Accept first vaue
            break;
        }

        return duration;
    };

    $.event.special.trend = {
        // Triggers an event handler when an element is done transitioning.
        //
        // Handles browsers that don't support transitionend by adding a
        // timeout with the transition duration.
        add: function (handleObj) {
            var el = $(this);
            var fired = false;

            // Mark element as being in transition
            el.data("trend", true);

            // Calculate a fallback duration. + 20 because some browsers fire
            // timeouts faster than transitionend.
            var time =
                parseProperties(el, transitionDurationProperties) +
                parseProperties(el, transitionDelayProperties) +
                20;

            var cb = function (e) {
                // transitionend events can be sent for each property. Let's just
                // skip all but the first. Also handles the timeout callback.
                if (fired) return;

                // Child elements that also have transitions can be fired before we
                // complete. This will catch and ignore those. Unfortunately, we'll
                // have to rely on the timeout in these cases.
                if (e && e.srcElement !== el[0]) return;

                // Mark element has not being in transition
                el.data("trend", false);

                // Callback
                fired = true;
                if (handleObj.handler) handleObj.handler();
            };

            el.one(transitionEndEvents, cb);
            el.data("trend-timeout", window.setTimeout(cb, time));
        },

        remove: function (handleObj) {
            var el = $(this);
            el.off(transitionEndEvents);
            window.clearTimeout(el.data("trend-timeout"));
        }
    };

})(jQuery);
/**
 * Executes a function (fn)  if all lazySizes images are loaded and trigger an event called `containerlazyloaded`
 *
 * @param [fn] {function}
 * @return {jQuery}
 *
 * @example
 *
 *   $('.scroll-view').allLazyLoaded(function(){
 *    console.log(this)
 *  });
 * @example
 *
 *   $('.scroll-view').allLazyLoaded().on('containerlazyloaded', function(){
 *    console.log(this)
 *  });
 */
jQuery.fn.allLazyLoaded = function (fn) {
    if (this.length) {
        var loadingClass = '.' + lazySizes.cfg.loadingClass;
        var toLoadClass = '.' + lazySizes.cfg.lazyClass;
        var isComplete = function () {
            return !('complete' in this) || this.complete;
        };

        this.each(function () {
            var container = this;
            var testLoad = function () {
                if (!$(toLoadClass, container).length && !$(loadingClass, container).not(isComplete).length) {
                    container.removeEventListener('load', rAFedTestLoad, true);
                    if (fn) {
                        fn.call(container, container);
                    }
                    $(container).trigger('containerlazyloaded');
                }
            };
            var rAFedTestLoad = function () {
                requestAnimationFrame(testLoad);
            };

            container.addEventListener('load', rAFedTestLoad, true);
            rAFedTestLoad();
        });
    }
    return this;
};
/*! lazysizes (bgset) - v4.0.1 */
(function (window, factory) {
    var globalInstall = function () {
        factory(window.lazySizes);
        window.removeEventListener('lazyunveilread', globalInstall, true);
    };

    factory = factory.bind(null, window, window.document);

    if (typeof module == 'object' && module.exports) {
        factory(require('lazysizes'));
    } else if (window.lazySizes) {
        globalInstall();
    } else {
        window.addEventListener('lazyunveilread', globalInstall, true);
    }
}(window, function (window, document, lazySizes) {
    'use strict';
    if (!window.addEventListener) {
        return;
    }

    var regWhite = /\s+/g;
    var regSplitSet = /\s*\|\s+|\s+\|\s*/g;
    var regSource = /^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/;
    var regType = /^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/;
    var regBgUrlEscape = /\(|\)|'/;
    var allowedBackgroundSize = {contain: 1, cover: 1};
    var proxyWidth = function (elem) {
        var width = lazySizes.gW(elem, elem.parentNode);

        if (!elem._lazysizesWidth || width > elem._lazysizesWidth) {
            elem._lazysizesWidth = width;
        }
        return elem._lazysizesWidth;
    };
    var getBgSize = function (elem) {
        var bgSize;

        bgSize = (getComputedStyle(elem) || {
            getPropertyValue: function () {
            }
        }).getPropertyValue('background-size');

        if (!allowedBackgroundSize[bgSize] && allowedBackgroundSize[elem.style.backgroundSize]) {
            bgSize = elem.style.backgroundSize;
        }

        return bgSize;
    };
    var setTypeOrMedia = function (source, match) {
        if (match) {
            var typeMatch = match.match(regType);
            if (typeMatch && typeMatch[1]) {
                source.setAttribute('type', typeMatch[1]);
            } else {
                source.setAttribute('media', lazySizesConfig.customMedia[match] || match);
            }
        }
    };
    var createPicture = function (sets, elem, img) {
        var picture = document.createElement('picture');
        var sizes = elem.getAttribute(lazySizesConfig.sizesAttr);
        var ratio = elem.getAttribute('data-ratio');
        var optimumx = elem.getAttribute('data-optimumx');

        if (elem._lazybgset && elem._lazybgset.parentNode == elem) {
            elem.removeChild(elem._lazybgset);
        }

        Object.defineProperty(img, '_lazybgset', {
            value: elem,
            writable: true
        });
        Object.defineProperty(elem, '_lazybgset', {
            value: picture,
            writable: true
        });

        sets = sets.replace(regWhite, ' ').split(regSplitSet);

        picture.style.display = 'none';
        img.className = lazySizesConfig.lazyClass;

        if (sets.length == 1 && !sizes) {
            sizes = 'auto';
        }

        sets.forEach(function (set) {
            var match;
            var source = document.createElement('source');

            if (sizes && sizes != 'auto') {
                source.setAttribute('sizes', sizes);
            }

            if ((match = set.match(regSource))) {
                source.setAttribute(lazySizesConfig.srcsetAttr, match[1]);

                setTypeOrMedia(source, match[2]);
                setTypeOrMedia(source, match[3]);
            } else {
                source.setAttribute(lazySizesConfig.srcsetAttr, set);
            }

            picture.appendChild(source);
        });

        if (sizes) {
            img.setAttribute(lazySizesConfig.sizesAttr, sizes);
            elem.removeAttribute(lazySizesConfig.sizesAttr);
            elem.removeAttribute('sizes');
        }
        if (optimumx) {
            img.setAttribute('data-optimumx', optimumx);
        }
        if (ratio) {
            img.setAttribute('data-ratio', ratio);
        }

        picture.appendChild(img);

        elem.appendChild(picture);
    };

    var proxyLoad = function (e) {
        if (!e.target._lazybgset) {
            return;
        }

        var image = e.target;
        var elem = image._lazybgset;
        var bg = image.currentSrc || image.src;

        if (bg) {
            elem.style.backgroundImage = 'url(' + (regBgUrlEscape.test(bg) ? JSON.stringify(bg) : bg) + ')';
        } else if (window.navigator.userAgent.indexOf("Edge") > -1) {
            elem.style.backgroundImage = 'url(' + elem.dataset.backup + ')';
        }

        if (image._lazybgsetLoading) {
            lazySizes.fire(elem, '_lazyloaded', {}, false, true);
            delete image._lazybgsetLoading;
        }
    };

    addEventListener('lazybeforeunveil', function (e) {
        var set, image, elem;

        if (e.defaultPrevented || !(set = e.target.getAttribute('data-bgset'))) {
            return;
        }

        elem = e.target;
        image = document.createElement('img');

        image.alt = '';

        image._lazybgsetLoading = true;
        e.detail.firesLoad = true;

        createPicture(set, elem, image);

        setTimeout(function () {
            lazySizes.loader.unveil(image);

            lazySizes.rAF(function () {
                lazySizes.fire(image, '_lazyloaded', {}, true, true);
                if (image.complete) {
                    proxyLoad({target: image});
                }
            });
        });

    });

    document.addEventListener('load', proxyLoad, true);

    window.addEventListener('lazybeforesizes', function (e) {
        if (e.detail.instance != lazySizes) {
            return;
        }
        if (e.target._lazybgset && e.detail.dataAttr) {
            var elem = e.target._lazybgset;
            var bgSize = getBgSize(elem);

            if (allowedBackgroundSize[bgSize]) {
                e.target._lazysizesParentFit = bgSize;

                lazySizes.rAF(function () {
                    e.target.setAttribute('data-parent-fit', bgSize);
                    if (e.target._lazysizesParentFit) {
                        delete e.target._lazysizesParentFit;
                    }
                });
            }
        }
    }, true);

    document.documentElement.addEventListener('lazybeforesizes', function (e) {
        if (e.defaultPrevented || !e.target._lazybgset || e.detail.instance != lazySizes) {
            return;
        }
        e.detail.width = proxyWidth(e.target._lazybgset);
    });
}));

/*! lazysizes - v4.0.1 */
!function (a, b) {
    var c = b(a, a.document);
    a.lazySizes = c, "object" == typeof module && module.exports && (module.exports = c)
}(window, function (a, b) {
    "use strict";
    if (b.getElementsByClassName) {
        var c, d, e = b.documentElement, f = a.Date, g = a.HTMLPictureElement, h = "addEventListener",
            i = "getAttribute", j = a[h], k = a.setTimeout, l = a.requestAnimationFrame || k, m = a.requestIdleCallback,
            n = /^picture$/i, o = ["load", "error", "lazyincluded", "_lazyloaded"], p = {}, q = Array.prototype.forEach,
            r = function (a, b) {
                return p[b] || (p[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")), p[b].test(a[i]("class") || "") && p[b]
            }, s = function (a, b) {
                r(a, b) || a.setAttribute("class", (a[i]("class") || "").trim() + " " + b)
            }, t = function (a, b) {
                var c;
                (c = r(a, b)) && a.setAttribute("class", (a[i]("class") || "").replace(c, " "))
            }, u = function (a, b, c) {
                var d = c ? h : "removeEventListener";
                c && u(a, b), o.forEach(function (c) {
                    a[d](c, b)
                })
            }, v = function (a, d, e, f, g) {
                var h = b.createEvent("CustomEvent");
                return e || (e = {}), e.instance = c, h.initCustomEvent(d, !f, !g, e), a.dispatchEvent(h), h
            }, w = function (b, c) {
                var e;
                !g && (e = a.picturefill || d.pf) ? e({reevaluate: !0, elements: [b]}) : c && c.src && (b.src = c.src)
            }, x = function (a, b) {
                return (getComputedStyle(a, null) || {})[b]
            }, y = function (a, b, c) {
                for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth;) c = b.offsetWidth, b = b.parentNode;
                return c
            }, z = function () {
                var a, c, d = [], e = [], f = d, g = function () {
                    var b = f;
                    for (f = d.length ? e : d, a = !0, c = !1; b.length;) b.shift()();
                    a = !1
                }, h = function (d, e) {
                    a && !e ? d.apply(this, arguments) : (f.push(d), c || (c = !0, (b.hidden ? k : l)(g)))
                };
                return h._lsFlush = g, h
            }(), A = function (a, b) {
                return b ? function () {
                    z(a)
                } : function () {
                    var b = this, c = arguments;
                    z(function () {
                        a.apply(b, c)
                    })
                }
            }, B = function (a) {
                var b, c = 0, e = 125, g = d.ricTimeout, h = function () {
                    b = !1, c = f.now(), a()
                }, i = m && d.ricTimeout ? function () {
                    m(h, {timeout: g}), g !== d.ricTimeout && (g = d.ricTimeout)
                } : A(function () {
                    k(h)
                }, !0);
                return function (a) {
                    var d;
                    (a = a === !0) && (g = 33), b || (b = !0, d = e - (f.now() - c), 0 > d && (d = 0), a || 9 > d && m ? i() : k(i, d))
                }
            }, C = function (a) {
                var b, c, d = 99, e = function () {
                    b = null, a()
                }, g = function () {
                    var a = f.now() - c;
                    d > a ? k(g, d - a) : (m || e)(e)
                };
                return function () {
                    c = f.now(), b || (b = k(g, d))
                }
            };
        !function () {
            var b, c = {
                lazyClass: "lazyload",
                loadedClass: "lazyloaded",
                loadingClass: "lazyloading",
                preloadClass: "lazypreload",
                errorClass: "lazyerror",
                autosizesClass: "lazyautosizes",
                srcAttr: "data-src",
                srcsetAttr: "data-srcset",
                sizesAttr: "data-sizes",
                minSize: 40,
                customMedia: {},
                init: !0,
                expFactor: 1.5,
                hFac: .8,
                loadMode: 2,
                loadHidden: !0,
                ricTimeout: 300
            };
            d = a.lazySizesConfig || a.lazysizesConfig || {};
            for (b in c) b in d || (d[b] = c[b]);
            a.lazySizesConfig = d, k(function () {
                d.init && F()
            })
        }();
        var D = function () {
            var g, l, m, o, p, y, D, F, G, H, I, J, K, L, M = /^img$/i, N = /^iframe$/i,
                O = "onscroll" in a && !/glebot/.test(navigator.userAgent), P = 0, Q = 0, R = 0, S = -1,
                T = function (a) {
                    R--, a && a.target && u(a.target, T), (!a || 0 > R || !a.target) && (R = 0)
                }, U = function (a, c) {
                    var d, f = a, g = "hidden" == x(b.body, "visibility") || "hidden" != x(a, "visibility");
                    for (F -= c, I += c, G -= c, H += c; g && (f = f.offsetParent) && f != b.body && f != e;) g = (x(f, "opacity") || 1) > 0, g && "visible" != x(f, "overflow") && (d = f.getBoundingClientRect(), g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1);
                    return g
                }, V = function () {
                    var a, f, h, j, k, m, n, p, q, r = c.elements;
                    if ((o = d.loadMode) && 8 > R && (a = r.length)) {
                        f = 0, S++, null == K && ("expand" in d || (d.expand = e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370), J = d.expand, K = J * d.expFactor), K > Q && 1 > R && S > 2 && o > 2 && !b.hidden ? (Q = K, S = 0) : Q = o > 1 && S > 1 && 6 > R ? J : P;
                        for (; a > f; f++) if (r[f] && !r[f]._lazyRace) if (O) if ((p = r[f][i]("data-expand")) && (m = 1 * p) || (m = Q), q !== m && (y = innerWidth + m * L, D = innerHeight + m, n = -1 * m, q = m), h = r[f].getBoundingClientRect(), (I = h.bottom) >= n && (F = h.top) <= D && (H = h.right) >= n * L && (G = h.left) <= y && (I || H || G || F) && (d.loadHidden || "hidden" != x(r[f], "visibility")) && (l && 3 > R && !p && (3 > o || 4 > S) || U(r[f], m))) {
                            if (ba(r[f]), k = !0, R > 9) break
                        } else !k && l && !j && 4 > R && 4 > S && o > 2 && (g[0] || d.preloadAfterLoad) && (g[0] || !p && (I || H || G || F || "auto" != r[f][i](d.sizesAttr))) && (j = g[0] || r[f]); else ba(r[f]);
                        j && !k && ba(j)
                    }
                }, W = B(V), X = function (a) {
                    s(a.target, d.loadedClass), t(a.target, d.loadingClass), u(a.target, Z), v(a.target, "lazyloaded")
                }, Y = A(X), Z = function (a) {
                    Y({target: a.target})
                }, $ = function (a, b) {
                    try {
                        a.contentWindow.location.replace(b)
                    } catch (c) {
                        a.src = b
                    }
                }, _ = function (a) {
                    var b, c = a[i](d.srcsetAttr);
                    (b = d.customMedia[a[i]("data-media") || a[i]("media")]) && a.setAttribute("media", b), c && a.setAttribute("srcset", c)
                }, aa = A(function (a, b, c, e, f) {
                    var g, h, j, l, o, p;
                    (o = v(a, "lazybeforeunveil", b)).defaultPrevented || (e && (c ? s(a, d.autosizesClass) : a.setAttribute("sizes", e)), h = a[i](d.srcsetAttr), g = a[i](d.srcAttr), f && (j = a.parentNode, l = j && n.test(j.nodeName || "")), p = b.firesLoad || "src" in a && (h || g || l), o = {target: a}, p && (u(a, T, !0), clearTimeout(m), m = k(T, 2500), s(a, d.loadingClass), u(a, Z, !0)), l && q.call(j.getElementsByTagName("source"), _), h ? a.setAttribute("srcset", h) : g && !l && (N.test(a.nodeName) ? $(a, g) : a.src = g), f && (h || l) && w(a, {src: g})), a._lazyRace && delete a._lazyRace, t(a, d.lazyClass), z(function () {
                        (!p || a.complete && a.naturalWidth > 1) && (p ? T(o) : R--, X(o))
                    }, !0)
                }), ba = function (a) {
                    var b, c = M.test(a.nodeName), e = c && (a[i](d.sizesAttr) || a[i]("sizes")), f = "auto" == e;
                    (!f && l || !c || !a[i]("src") && !a.srcset || a.complete || r(a, d.errorClass) || !r(a, d.lazyClass)) && (b = v(a, "lazyunveilread").detail, f && E.updateElem(a, !0, a.offsetWidth), a._lazyRace = !0, R++, aa(a, b, f, e, c))
                }, ca = function () {
                    if (!l) {
                        if (f.now() - p < 999) return void k(ca, 999);
                        var a = C(function () {
                            d.loadMode = 3, W()
                        });
                        l = !0, d.loadMode = 3, W(), j("scroll", function () {
                            3 == d.loadMode && (d.loadMode = 2), a()
                        }, !0)
                    }
                };
            return {
                _: function () {
                    p = f.now(), c.elements = b.getElementsByClassName(d.lazyClass), g = b.getElementsByClassName(d.lazyClass + " " + d.preloadClass), L = d.hFac, j("scroll", W, !0), j("resize", W, !0), a.MutationObserver ? new MutationObserver(W).observe(e, {
                        childList: !0,
                        subtree: !0,
                        attributes: !0
                    }) : (e[h]("DOMNodeInserted", W, !0), e[h]("DOMAttrModified", W, !0), setInterval(W, 999)), j("hashchange", W, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function (a) {
                        b[h](a, W, !0)
                    }), /d$|^c/.test(b.readyState) ? ca() : (j("load", ca), b[h]("DOMContentLoaded", W), k(ca, 2e4)), c.elements.length ? (V(), z._lsFlush()) : W()
                }, checkElems: W, unveil: ba
            }
        }(), E = function () {
            var a, c = A(function (a, b, c, d) {
                var e, f, g;
                if (a._lazysizesWidth = d, d += "px", a.setAttribute("sizes", d), n.test(b.nodeName || "")) for (e = b.getElementsByTagName("source"), f = 0, g = e.length; g > f; f++) e[f].setAttribute("sizes", d);
                c.detail.dataAttr || w(a, c.detail)
            }), e = function (a, b, d) {
                var e, f = a.parentNode;
                f && (d = y(a, f, d), e = v(a, "lazybeforesizes", {
                    width: d,
                    dataAttr: !!b
                }), e.defaultPrevented || (d = e.detail.width, d && d !== a._lazysizesWidth && c(a, f, e, d)))
            }, f = function () {
                var b, c = a.length;
                if (c) for (b = 0; c > b; b++) e(a[b])
            }, g = C(f);
            return {
                _: function () {
                    a = b.getElementsByClassName(d.autosizesClass), j("resize", g)
                }, checkElems: g, updateElem: e
            }
        }(), F = function () {
            F.i || (F.i = !0, E._(), D._())
        };
        return c = {cfg: d, autoSizer: E, loader: D, init: F, uP: w, aC: s, rC: t, hC: r, fire: v, gW: y, rAF: z}
    }
});
/*! lazysizes (parent-fit) - v4.0.1 */
!function (a, b) {
    var c = function () {
        b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0)
    };
    b = b.bind(null, a, a.document), "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0)
}(window, function (a, b, c) {
    "use strict";
    if (a.addEventListener) {
        var d = /\s+(\d+)(w|h)\s+(\d+)(w|h)/, e = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/,
            f = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/, g = /^picture$/i, h = function (a) {
                return getComputedStyle(a, null) || {}
            }, i = {
                getParent: function (b, c) {
                    var d = b, e = b.parentNode;
                    return c && "prev" != c || !e || !g.test(e.nodeName || "") || (e = e.parentNode), "self" != c && (d = "prev" == c ? b.previousElementSibling : c && (e.closest || a.jQuery) ? (e.closest ? e.closest(c) : jQuery(e).closest(c)[0]) || e : e), d
                }, getFit: function (a) {
                    var b, c, d = h(a), g = d.content || d.fontFamily,
                        j = {fit: a._lazysizesParentFit || a.getAttribute("data-parent-fit")};
                    return !j.fit && g && (b = g.match(e)) && (j.fit = b[1]), j.fit ? (c = a._lazysizesParentContainer || a.getAttribute("data-parent-container"), !c && g && (b = g.match(f)) && (c = b[1]), j.parent = i.getParent(a, c)) : j.fit = d.objectFit, j
                }, getImageRatio: function (b) {
                    var c, e, f, h, i = b.parentNode,
                        j = i && g.test(i.nodeName || "") ? i.querySelectorAll("source, img") : [b];
                    for (c = 0; c < j.length; c++) if (b = j[c], e = b.getAttribute(lazySizesConfig.srcsetAttr) || b.getAttribute("srcset") || b.getAttribute("data-pfsrcset") || b.getAttribute("data-risrcset") || "", f = b._lsMedia || b.getAttribute("media"), f = lazySizesConfig.customMedia[b.getAttribute("data-media") || f] || f, e && (!f || (a.matchMedia && matchMedia(f) || {}).matches)) {
                        h = parseFloat(b.getAttribute("data-aspectratio")), !h && e.match(d) && (h = "w" == RegExp.$2 ? RegExp.$1 / RegExp.$3 : RegExp.$3 / RegExp.$1);
                        break
                    }
                    return h
                }, calculateSize: function (a, b) {
                    var c, d, e, f, g = this.getFit(a), h = g.fit, i = g.parent;
                    return "width" == h || ("contain" == h || "cover" == h) && (e = this.getImageRatio(a)) ? (i ? b = i.clientWidth : i = a, f = b, "width" == h ? f = b : (d = i.clientHeight, d > 40 && (c = b / d) && ("cover" == h && e > c || "contain" == h && c > e) && (f = b * (e / c))), f) : b
                }
            };
        c.parentFit = i, b.addEventListener("lazybeforesizes", function (a) {
            if (!a.defaultPrevented && a.detail.instance == c) {
                var b = a.target;
                a.detail.width = i.calculateSize(b, a.detail.width)
            }
        })
    }
});
/*! lazysizes (rias) - v4.0.1 */
!function (a, b) {
    var c = function () {
        b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0)
    };
    b = b.bind(null, a, a.document), "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0)
}(window, function (a, b, c) {
    "use strict";

    function d(b, c) {
        var d, e, f, g, h = a.getComputedStyle(b);
        e = b.parentNode, g = {isPicture: !(!e || !m.test(e.nodeName || ""))}, f = function (a, c) {
            var d = b.getAttribute("data-" + a);
            if (!d) {
                var e = h.getPropertyValue("--ls-" + a);
                e && (d = e.trim())
            }
            if (d) {
                if ("true" == d) d = !0; else if ("false" == d) d = !1; else if (l.test(d)) d = parseFloat(d); else if ("function" == typeof j[a]) d = j[a](b, d); else if (q.test(d)) try {
                    d = JSON.parse(d)
                } catch (f) {
                }
                g[a] = d
            } else a in j && "function" != typeof j[a] ? g[a] = j[a] : c && "function" == typeof j[a] && (g[a] = j[a](b, d))
        };
        for (d in j) f(d);
        return c.replace(p, function (a, b) {
            b in g || f(b, !0)
        }), g
    }

    function e(a, b) {
        var c = [], d = function (a, c) {
            return k[typeof b[c]] ? b[c] : a
        };
        return c.srcset = [], b.absUrl && (s.setAttribute("href", a), a = s.href), a = ((b.prefix || "") + a + (b.postfix || "")).replace(p, d), b.widths.forEach(function (d) {
            var e = b.widthmap[d] || d,
                f = {u: a.replace(n, e).replace(o, b.ratio ? Math.round(d * b.ratio) : ""), w: d};
            c.push(f), c.srcset.push(f.c = f.u + " " + d + "w")
        }), c
    }

    function f(a, c, d) {
        var f = 0, g = 0, h = d;
        if (a) {
            if ("container" === c.ratio) {
                for (f = h.scrollWidth, g = h.scrollHeight; !(f && g || h === b);) h = h.parentNode, f = h.scrollWidth, g = h.scrollHeight;
                f && g && (c.ratio = g / f)
            }
            a = e(a, c), a.isPicture = c.isPicture, u && "IMG" == d.nodeName.toUpperCase() ? d.removeAttribute(i.srcsetAttr) : d.setAttribute(i.srcsetAttr, a.srcset.join(", ")), Object.defineProperty(d, "_lazyrias", {
                value: a,
                writable: !0
            })
        }
    }

    function g(a, b) {
        var e = d(a, b);
        return j.modifyOptions.call(a, {target: a, details: e, detail: e}), c.fire(a, "lazyriasmodifyoptions", e), e
    }

    function h(a) {
        return a.getAttribute(a.getAttribute("data-srcattr") || j.srcAttr) || a.getAttribute(i.srcsetAttr) || a.getAttribute(i.srcAttr) || a.getAttribute("data-pfsrcset") || ""
    }

    var i, j, k = {string: 1, number: 1}, l = /^\-*\+*\d+\.*\d*$/, m = /^picture$/i, n = /\s*\{\s*width\s*\}\s*/i,
        o = /\s*\{\s*height\s*\}\s*/i, p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi, q = /^\[.*\]|\{.*\}$/,
        r = /^(?:auto|\d+(px)?)$/, s = b.createElement("a"), t = b.createElement("img"),
        u = "srcset" in t && !("sizes" in t), v = !!a.HTMLPictureElement && !u;
    !function () {
        var b, d = function () {
        }, e = {prefix: "", postfix: "", srcAttr: "data-src", absUrl: !1, modifyOptions: d, widthmap: {}, ratio: !1};
        i = c && c.cfg || a.lazySizesConfig, i || (i = {}, a.lazySizesConfig = i), i.supportsType || (i.supportsType = function (a) {
            return !a
        }), i.rias || (i.rias = {}), j = i.rias, "widths" in j || (j.widths = [], function (a) {
            for (var b, c = 0; !b || 3e3 > b;) c += 5, c > 30 && (c += 1), b = 36 * c, a.push(b)
        }(j.widths));
        for (b in e) b in j || (j[b] = e[b])
    }(), addEventListener("lazybeforesizes", function (a) {
        if (a.detail.instance == c) {
            var b, d, e, k, l, m, o, p, q, s, t, u, x;
            if (b = a.target, a.detail.dataAttr && !a.defaultPrevented && !j.disabled && (q = b.getAttribute(i.sizesAttr) || b.getAttribute("sizes")) && r.test(q)) {
                if (d = h(b), e = g(b, d), t = n.test(e.prefix) || n.test(e.postfix), e.isPicture && (k = b.parentNode)) for (l = k.getElementsByTagName("source"), m = 0, o = l.length; o > m; m++) (t || n.test(p = h(l[m]))) && (f(p, e, l[m]), u = !0);
                t || n.test(d) ? (f(d, e, b), u = !0) : u && (x = [], x.srcset = [], x.isPicture = !0, Object.defineProperty(b, "_lazyrias", {
                    value: x,
                    writable: !0
                })), u && (v ? b.removeAttribute(i.srcAttr) : "auto" != q && (s = {width: parseInt(q, 10)}, w({
                    target: b,
                    detail: s
                })))
            }
        }
    }, !0);
    var w = function () {
        var d = function (a, b) {
            return a.w - b.w
        }, e = function (a) {
            var b, c, d = a.length, e = a[d - 1], f = 0;
            for (f; d > f; f++) if (e = a[f], e.d = e.w / a.w, e.d >= a.d) {
                !e.cached && (b = a[f - 1]) && b.d > a.d - .13 * Math.pow(a.d, 2.2) && (c = Math.pow(b.d - .6, 1.6), b.cached && (b.d += .15 * c), b.d + (e.d - a.d) * c > a.d && (e = b));
                break
            }
            return e
        }, f = function (a, b) {
            var d;
            return !a._lazyrias && c.pWS && (d = c.pWS(a.getAttribute(i.srcsetAttr || ""))).length && (Object.defineProperty(a, "_lazyrias", {
                value: d,
                writable: !0
            }), b && a.parentNode && (d.isPicture = "PICTURE" == a.parentNode.nodeName.toUpperCase())), a._lazyrias
        }, g = function (b) {
            var d = a.devicePixelRatio || 1, e = c.getX && c.getX(b);
            return Math.min(e || d, 2.4, d)
        }, h = function (b, c) {
            var h, i, j, k, l, m;
            if (l = b._lazyrias, l.isPicture && a.matchMedia) for (i = 0, h = b.parentNode.getElementsByTagName("source"), j = h.length; j > i; i++) if (f(h[i]) && !h[i].getAttribute("type") && (!(k = h[i].getAttribute("media")) || (matchMedia(k) || {}).matches)) {
                l = h[i]._lazyrias;
                break
            }
            return (!l.w || l.w < c) && (l.w = c, l.d = g(b), m = e(l.sort(d))), m
        }, j = function (d) {
            if (d.detail.instance == c) {
                var e, g = d.target;
                return !u && (a.respimage || a.picturefill || lazySizesConfig.pf) ? void b.removeEventListener("lazybeforesizes", j) : void (("_lazyrias" in g || d.detail.dataAttr && f(g, !0)) && (e = h(g, d.detail.width), e && e.u && g._lazyrias.cur != e.u && (g._lazyrias.cur = e.u, e.cached = !0, c.rAF(function () {
                    g.setAttribute(i.srcAttr, e.u), g.setAttribute("src", e.u)
                }))))
            }
        };
        return v ? j = function () {
        } : addEventListener("lazybeforesizes", j), j
    }()
});
// (c) Copyright 2014 Caroline Schnapp. All Rights Reserved. Contact: mllegeorgesand@gmail.com
// See http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
// Edited by Connor Munro

var Shopify = Shopify || {};

Shopify.optionsMap = {};

Shopify.escapeString = function (string) {
    return string.replace(/'/g, "\\'");
};

Shopify.updateOptionsInSelector = function (selectorIndex, context, optionsMap) {

    switch (selectorIndex) {
        case 0:
            var key = 'root';
            var selector = jQuery("#product_form_" + context + " [data-product-swatch='0']");
            break;
        case 1:
            var key = jQuery("#product_form_" + context + " [data-product-swatch='0'] input:checked").val();
            var selector = jQuery("#product_form_" + context + " [data-product-swatch='1']");
            break;
        case 2:
            var key = jQuery("#product_form_" + context + " [data-product-swatch='0'] input:checked").val();
            key += ' / ' + jQuery("#product_form_" + context + " [data-product-swatch='1'] input:checked").val();
            var selector = jQuery("#product_form_" + context + " [data-product-swatch='2']");
    }

    var initialValue = selector.find("input:checked").val();
    var availableOptions = optionsMap[key];
    var optionsWrapper = selector.find("[data-product-swatch-value]");
    var options = selector.find("input");

    optionsWrapper.removeClass("active");
    options.prop("disabled", true);

    if (availableOptions) {
        for (var i = 0; i < availableOptions.length; i++) {
            var option = Shopify.escapeString(availableOptions[i]);
            selector
                .find("[data-product-swatch-value='" + option + "']")
                .addClass("available")
                .find("input")
                .prop("disabled", false);
        }
    }

    for (var i = 0; i < options.length; i++) {
        var option = options.eq(i),
            optionWrapper = option.closest("[data-product-swatch-value]");

        if (optionWrapper.hasClass("available")) {
            if (option.is(":checked")) {
                option.closest("[data-product-swatch-value]").addClass("active");
            }
        } else if (option.is(":checked")) {
            option.prop("checked", false);

            if (availableOptions) {
                selector
                    .find("[data-product-swatch-value='" + availableOptions[0] + "']")
                    .addClass("active")
                    .find("input")
                    .prop("checked", true);
            }
        }
    }

    // Reset "Available" class for next round.
    optionsWrapper.removeClass("available");

    jQuery('[data-product-swatch="' + selectorIndex + '"] [data-product-swatch-value]').each(function () {
        if (jQuery.inArray($(this).attr('data-product-swatch-value'), availableOptions) !== -1) {
            $(this).removeClass('soldout');
        } else {
            $(this).addClass('soldout');
        }
    });
};

Shopify.linkOptionSelectors = function (product, context) {

    Shopify.optionsMap[context] = {};
    // Building our mapping object.
    for (var i = 0; i < product.variants.length; i++) {
        var variant = product.variants[i];
        // Gathering values for the 1st drop-down.
        if (variant.available) {
            Shopify.optionsMap[context]['root'] = Shopify.optionsMap[context]['root'] || [];
            Shopify.optionsMap[context]['root'].push(variant.option1);
            Shopify.optionsMap[context]['root'] = Shopify.uniq(Shopify.optionsMap[context]['root']);
            // Gathering values for the 2nd drop-down.
            if (product.options.length > 1) {
                var key = variant.option1;
                Shopify.optionsMap[context][key] = Shopify.optionsMap[context][key] || [];
                Shopify.optionsMap[context][key].push(variant.option2);
                Shopify.optionsMap[context][key] = Shopify.uniq(Shopify.optionsMap[context][key]);
            }
            // Gathering values for the 3rd drop-down.
            if (product.options.length === 3) {
                var key = variant.option1 + ' / ' + variant.option2;
                Shopify.optionsMap[context][key] = Shopify.optionsMap[context][key] || [];
                Shopify.optionsMap[context][key].push(variant.option3);
                Shopify.optionsMap[context][key] = Shopify.uniq(Shopify.optionsMap[context][key]);
            }
        }
    }

    // Update options right away.
    Shopify.updateOptionsInSelector(0, context, Shopify.optionsMap[context]);
    if (product.options.length > 1) Shopify.updateOptionsInSelector(1, context, Shopify.optionsMap[context]);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2, context, Shopify.optionsMap[context]);
    // When there is an update in the first dropdown.
    jQuery("#product_form_" + context + " input[name='option-0']").change(function () {
        $(this).closest("[data-product-swatch-value]").addClass("active").siblings().removeClass("active");
        if (product.options.length > 1) Shopify.updateOptionsInSelector(1, context, Shopify.optionsMap[context]);
        if (product.options.length === 3) Shopify.updateOptionsInSelector(2, context, Shopify.optionsMap[context]);
        return true;
    });
    // When there is an update in the second dropdown.
    jQuery("#product_form_" + context + " input[name='option-1']").change(function () {
        $(this).closest("[data-product-swatch-value]").addClass("active").siblings().removeClass("active");
        if (product.options.length === 3) Shopify.updateOptionsInSelector(2, context, Shopify.optionsMap[context]);
        return true;
    });

};
/**
 * @license
 * lodash (Custom Build) /license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 * Build: `lodash include="debounce,throttle,template"`
 */
;(function () {
    function t(t, r, n) {
        switch (n.length) {
            case 0:
                return t.call(r);
            case 1:
                return t.call(r, n[0]);
            case 2:
                return t.call(r, n[0], n[1]);
            case 3:
                return t.call(r, n[0], n[1], n[2])
        }
        return t.apply(r, n)
    }

    function r(t, r) {
        for (var n = -1, e = t ? t.length : 0, o = Array(e); ++n < e;) o[n] = r(t[n], n, t);
        return o
    }

    function n(t) {
        return function (r) {
            return null == t ? X : t[r]
        }
    }

    function e(t, r) {
        for (var n = -1, e = Array(t); ++n < t;) e[n] = r(n);
        return e
    }

    function o(t) {
        return function (r) {
            return t(r)
        }
    }

    function u(t, n) {
        return r(n, function (r) {
            return t[r]
        });
    }

    function c(t) {
        return "\\" + It[t]
    }

    function i(t, r) {
        return null == t ? X : t[r]
    }

    function a(t, r) {
        return function (n) {
            return t(r(n))
        }
    }

    function f() {
    }

    function l(t, r) {
        var n = pr(t), o = !n && sr(t), u = !n && !o && br(t), c = !n && !o && !u && yr(t), i = n || o || u || c,
            a = i ? e(t.length, String) : [], f = a.length;
        for (var l in t) !r && !Jt.call(t, l) || i && ("length" == l || u && ("offset" == l || "parent" == l) || c && ("buffer" == l || "byteLength" == l || "byteOffset" == l) || x(l, f)) || a.push(l);
        return a
    }

    function s(t, r, n, e) {
        return t === X || L(t, Vt[n]) && !Jt.call(e, n) ? r : t
    }

    function p(t, r, n) {
        var e = t[r];
        Jt.call(t, r) && L(e, n) && (n !== X || r in t) || b(t, r, n)
    }

    function b(t, r, n) {
        "__proto__" == r && tr ? tr(t, r, {configurable: true, enumerable: true, value: n, writable: true}) : t[r] = n
    }

    function y(t) {
        return D(t) && Kt.call(t) == ut
    }

    function g(t) {
        return !(!P(t) || $(t)) && (B(t) ? Qt : xt).test(I(t))
    }

    function j(t) {
        return D(t) && N(t.length) && !!Tt[Kt.call(t)]
    }

    function v(t) {
        if (!w(t)) return nr(t);
        var r = [];
        for (var n in Object(t)) Jt.call(t, n) && "constructor" != n && r.push(n);
        return r
    }

    function _(t) {
        if (!P(t)) return E(t);
        var r = w(t), n = [];
        for (var e in t) ("constructor" != e || !r && Jt.call(t, e)) && n.push(e);
        return n
    }

    function m(t, r) {
        return fr(T(t, r, K), t + "")
    }

    function h(t) {
        if (typeof t == "string") return t;
        if (pr(t)) return r(t, h) + "";
        if (M(t)) return ir ? ir.call(t) : "";
        var n = t + "";
        return "0" == n && 1 / t == -nt ? "-0" : n
    }

    function d(t, r, n, e) {
        var o = !n;
        n || (n = {});
        for (var u = -1, c = r.length; ++u < c;) {
            var i = r[u], a = e ? e(n[i], t[i], i, n, t) : X;
            a === X && (a = t[i]), o ? b(n, i, a) : p(n, i, a)
        }
        return n
    }

    function A(t) {
        return m(function (r, n) {
            var e = -1, o = n.length, u = o > 1 ? n[o - 1] : X, c = o > 2 ? n[2] : X;
            for (u = t.length > 3 && typeof u == "function" ? (o--, u) : X, c && S(n[0], n[1], c) && (u = o < 3 ? X : u,
                o = 1), r = Object(r); ++e < o;) {
                var i = n[e];
                i && t(r, i, e, u)
            }
            return r
        })
    }

    function O(t, r) {
        var n = i(t, r);
        return g(n) ? n : X
    }

    function x(t, r) {
        return r = null == r ? et : r, !!r && (typeof t == "number" || $t.test(t)) && t > -1 && t % 1 == 0 && t < r
    }

    function S(t, r, n) {
        if (!P(n)) return false;
        var e = typeof r;
        return !!("number" == e ? U(n) && x(r, n.length) : "string" == e && r in n) && L(n[r], t)
    }

    function $(t) {
        return !!zt && zt in t
    }

    function w(t) {
        var r = t && t.constructor;
        return t === (typeof r == "function" && r.prototype || Vt)
    }

    function E(t) {
        var r = [];
        if (null != t) for (var n in Object(t)) r.push(n);
        return r
    }

    function T(r, n, e) {
        return n = er(n === X ? r.length - 1 : n, 0), function () {
            for (var o = arguments, u = -1, c = er(o.length - n, 0), i = Array(c); ++u < c;) i[u] = o[n + u];
            u = -1;
            for (var a = Array(n + 1); ++u < n;) a[u] = o[u];
            return a[n] = e(i), t(r, this, a)
        }
    }

    function F(t) {
        var r = 0, n = 0;
        return function () {
            var e = ur(), o = rt - (e - n);
            if (n = e, o > 0) {
                if (++r >= tt) return arguments[0]
            } else r = 0;
            return t.apply(X, arguments)
        }
    }

    function I(t) {
        if (null != t) {
            try {
                return Ht.call(t)
            } catch (t) {
            }
            try {
                return t + ""
            } catch (t) {
            }
        }
        return ""
    }

    function R(t, r, n) {
        function e(r) {
            var n = p, e = b;
            return p = b = X, _ = r, g = t.apply(e, n)
        }

        function o(t) {
            return _ = t, j = setTimeout(i, r), m ? e(t) : g
        }

        function u(t) {
            var n = t - v, e = t - _, o = r - n;
            return h ? or(o, y - e) : o
        }

        function c(t) {
            var n = t - v, e = t - _;
            return v === X || n >= r || n < 0 || h && e >= y
        }

        function i() {
            var t = lr();
            return c(t) ? a(t) : (j = setTimeout(i, u(t)), X)
        }

        function a(t) {
            return j = X, d && p ? e(t) : (p = b = X, g)
        }

        function f() {
            j !== X && clearTimeout(j), _ = 0, p = v = b = j = X
        }

        function l() {
            return j === X ? g : a(lr())
        }

        function s() {
            var t = lr(), n = c(t);
            if (p = arguments, b = this, v = t, n) {
                if (j === X) return o(v);
                if (h) return j = setTimeout(i, r),
                    e(v)
            }
            return j === X && (j = setTimeout(i, r)), g
        }

        var p, b, y, g, j, v, _ = 0, m = false, h = false, d = true;
        if (typeof t != "function") throw new TypeError(Z);
        return r = q(r) || 0, P(n) && (m = !!n.leading, h = "maxWait" in n, y = h ? er(q(n.maxWait) || 0, r) : y, d = "trailing" in n ? !!n.trailing : d), s.cancel = f, s.flush = l, s
    }

    function k(t, r, n) {
        var e = true, o = true;
        if (typeof t != "function") throw new TypeError(Z);
        return P(n) && (e = "leading" in n ? !!n.leading : e, o = "trailing" in n ? !!n.trailing : o), R(t, r, {
            leading: e,
            maxWait: r,
            trailing: o
        })
    }

    function L(t, r) {
        return t === r || t !== t && r !== r
    }

    function U(t) {
        return null != t && N(t.length) && !B(t)
    }

    function W(t) {
        return !!D(t) && (Kt.call(t) == ct || typeof t.message == "string" && typeof t.name == "string")
    }

    function B(t) {
        var r = P(t) ? Kt.call(t) : "";
        return r == it || r == at || r == ft
    }

    function N(t) {
        return typeof t == "number" && t > -1 && t % 1 == 0 && t <= et
    }

    function P(t) {
        var r = typeof t;
        return null != t && ("object" == r || "function" == r)
    }

    function D(t) {
        return null != t && typeof t == "object"
    }

    function M(t) {
        return typeof t == "symbol" || D(t) && Kt.call(t) == lt
    }

    function q(t) {
        if (typeof t == "number") return t;
        if (M(t)) return ot;
        if (P(t)) {
            var r = typeof t.valueOf == "function" ? t.valueOf() : t;
            t = P(r) ? r + "" : r
        }
        if (typeof t != "string") return 0 === t ? t : +t;
        t = t.replace(ht, "");
        var n = Ot.test(t);
        return n || St.test(t) ? Rt(t.slice(2), n ? 2 : 8) : At.test(t) ? ot : +t
    }

    function C(t) {
        return null == t ? "" : h(t)
    }

    function V(t) {
        return U(t) ? l(t) : v(t)
    }

    function G(t) {
        return U(t) ? l(t, true) : _(t)
    }

    function z(t) {
        return t = C(t), t && gt.test(t) ? t.replace(yt, qt) : t
    }

    function H(t, r, n) {
        var e = f.templateSettings;
        n && S(t, r, n) && (r = X), t = C(t), r = gr({}, r, e, s);
        var o, i, a = gr({}, r.imports, e.imports, s), l = V(a), p = u(a, l), b = 0, y = r.interpolate || wt,
            g = "__p+='", j = "sourceURL" in r ? "//# sourceURL=" + r.sourceURL + "\n" : "";
        t.replace(RegExp((r.escape || wt).source + "|" + y.source + "|" + (y === _t ? dt : wt).source + "|" + (r.evaluate || wt).source + "|$", "g"), function (r, n, e, u, a, f) {
            return e || (e = u), g += t.slice(b, f).replace(Et, c), n && (o = true, g += "'+__e(" + n + ")+'"), a && (i = true, g += "';" + a + ";\n__p+='"), e && (g += "'+((__t=(" + e + "))==null?'':__t)+'"), b = f + r.length, r
        }), g += "';";
        var v = r.variable;
        v || (g = "with(obj){" + g + "}"), g = (i ? g.replace(st, "") : g).replace(pt, "$1").replace(bt, "$1;"), g = "function(" + (v || "obj") + "){" + (v ? "" : "obj||(obj={});") + "var __t,__p=''" + (o ? ",__e=_.escape" : "") + (i ? ",__j=Array.prototype.join;function print(){__p+=__j.call(arguments,'')}" : ";") + g + "return __p}";
        var _ = jr(function () {
            return Function(l, j + "return " + g).apply(X, p)
        });
        if (_.source = g, W(_)) throw _;
        return _
    }

    function J(t) {
        return function () {
            return t
        }
    }

    function K(t) {
        return t
    }

    function Q() {
        return false
    }

    var X, Y = "4.16.4", Z = "Expected a function", tt = 500, rt = 16, nt = 1 / 0, et = 9007199254740991, ot = NaN,
        ut = "[object Arguments]", ct = "[object Error]", it = "[object Function]", at = "[object GeneratorFunction]",
        ft = "[object Proxy]", lt = "[object Symbol]", st = /\b__p\+='';/g, pt = /\b(__p\+=)''\+/g,
        bt = /(__e\(.*?\)|\b__t\))\+'';/g, yt = /[&<>"']/g, gt = RegExp(yt.source), jt = /<%-([\s\S]+?)%>/g,
        vt = /<%([\s\S]+?)%>/g, _t = /<%=([\s\S]+?)%>/g, mt = /[\\^$.*+?()[\]{}|]/g, ht = /^\s+|\s+$/g,
        dt = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, At = /^[-+]0x[0-9a-f]+$/i, Ot = /^0b[01]+$/i,
        xt = /^\[object .+?Constructor\]$/, St = /^0o[0-7]+$/i, $t = /^(?:0|[1-9]\d*)$/, wt = /($^)/,
        Et = /['\n\r\u2028\u2029\\]/g, Tt = {};
    Tt["[object Float32Array]"] = Tt["[object Float64Array]"] = Tt["[object Int8Array]"] = Tt["[object Int16Array]"] = Tt["[object Int32Array]"] = Tt["[object Uint8Array]"] = Tt["[object Uint8ClampedArray]"] = Tt["[object Uint16Array]"] = Tt["[object Uint32Array]"] = true, Tt[ut] = Tt["[object Array]"] = Tt["[object ArrayBuffer]"] = Tt["[object Boolean]"] = Tt["[object DataView]"] = Tt["[object Date]"] = Tt[ct] = Tt[it] = Tt["[object Map]"] = Tt["[object Number]"] = Tt["[object Object]"] = Tt["[object RegExp]"] = Tt["[object Set]"] = Tt["[object String]"] = Tt["[object WeakMap]"] = false;
    var Ft = {"&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;"},
        It = {"\\": "\\", "'": "'", "\n": "n", "\r": "r", "\u2028": "u2028", "\u2029": "u2029"}, Rt = parseInt,
        kt = typeof global == "object" && global && global.Object === Object && global,
        Lt = typeof self == "object" && self && self.Object === Object && self,
        Ut = kt || Lt || Function("return this")(),
        Wt = typeof exports == "object" && exports && !exports.nodeType && exports,
        Bt = Wt && typeof module == "object" && module && !module.nodeType && module, Nt = Bt && Bt.exports === Wt,
        Pt = Nt && kt.process, Dt = function () {
            try {
                return Pt && Pt.binding("util")
            } catch (t) {
            }
        }(), Mt = Dt && Dt.isTypedArray, qt = n(Ft), Ct = Function.prototype, Vt = Object.prototype,
        Gt = Ut["__core-js_shared__"], zt = function () {
            var t = /[^.]+$/.exec(Gt && Gt.keys && Gt.keys.IE_PROTO || "");
            return t ? "Symbol(src)_1." + t : ""
        }(), Ht = Ct.toString, Jt = Vt.hasOwnProperty, Kt = Vt.toString,
        Qt = RegExp("^" + Ht.call(Jt).replace(mt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
        Xt = Nt ? Ut.Buffer : X, Yt = Ut.Symbol, Zt = Vt.propertyIsEnumerable, tr = function () {
            try {
                var t = O(Object, "defineProperty");
                return t({}, "", {}), t
            } catch (t) {
            }
        }(), rr = Xt ? Xt.isBuffer : X, nr = a(Object.keys, Object), er = Math.max, or = Math.min, ur = Date.now,
        cr = Yt ? Yt.prototype : X, ir = cr ? cr.toString : X;
    f.templateSettings = {escape: jt, evaluate: vt, interpolate: _t, variable: "", imports: {_: f}};
    var ar = tr ? function (t, r) {
        return tr(t, "toString", {configurable: true, enumerable: false, value: J(r), writable: true})
    } : K, fr = F(ar), lr = function () {
        return Ut.Date.now()
    }, sr = y(function () {
        return arguments
    }()) ? y : function (t) {
        return D(t) && Jt.call(t, "callee") && !Zt.call(t, "callee");
    }, pr = Array.isArray, br = rr || Q, yr = Mt ? o(Mt) : j, gr = A(function (t, r, n, e) {
        d(r, G(r), t, e)
    }), jr = m(function (r, n) {
        try {
            return t(r, X, n)
        } catch (t) {
            return W(t) ? t : Error(t)
        }
    });
    f.assignInWith = gr, f.constant = J, f.debounce = R, f.keys = V, f.keysIn = G, f.throttle = k, f.extendWith = gr, f.attempt = jr, f.eq = L, f.escape = z, f.identity = K, f.isArguments = sr, f.isArray = pr, f.isArrayLike = U, f.isBuffer = br, f.isError = W, f.isFunction = B, f.isLength = N, f.isObject = P, f.isObjectLike = D, f.isSymbol = M, f.isTypedArray = yr, f.stubFalse = Q, f.now = lr, f.template = H, f.toNumber = q,
        f.toString = C, f.VERSION = Y, typeof define == "function" && typeof define.amd == "object" && define.amd ? (Ut._ = f, define(function () {
        return f
    })) : Bt ? ((Bt.exports = f)._ = f, Wt._ = f) : Ut._ = f
}).call(this);
/*!
 * Masonry PACKAGED v4.1.1
 * Cascading grid layout library
 * http://masonry.desandro.com
 * MIT License
 * by David DeSandro
 */

!function (t, e) {
    "function" == typeof define && define.amd ? define("jquery-bridget/jquery-bridget", ["jquery"], function (i) {
        return e(t, i)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("jquery")) : t.jQueryBridget = e(t, t.jQuery)
}(window, function (t, e) {
    "use strict";

    function i(i, r, a) {
        function h(t, e, n) {
            var o, r = "$()." + i + '("' + e + '")';
            return t.each(function (t, h) {
                var u = a.data(h, i);
                if (!u) return void s(i + " not initialized. Cannot call methods, i.e. " + r);
                var d = u[e];
                if (!d || "_" == e.charAt(0)) return void s(r + " is not a valid method");
                var l = d.apply(u, n);
                o = void 0 === o ? l : o
            }), void 0 !== o ? o : t
        }

        function u(t, e) {
            t.each(function (t, n) {
                var o = a.data(n, i);
                o ? (o.option(e), o._init()) : (o = new r(n, e), a.data(n, i, o))
            })
        }

        a = a || e || t.jQuery, a && (r.prototype.option || (r.prototype.option = function (t) {
            a.isPlainObject(t) && (this.options = a.extend(!0, this.options, t))
        }), a.fn[i] = function (t) {
            if ("string" == typeof t) {
                var e = o.call(arguments, 1);
                return h(this, t, e)
            }
            return u(this, t), this
        }, n(a))
    }

    function n(t) {
        !t || t && t.bridget || (t.bridget = i)
    }

    var o = Array.prototype.slice, r = t.console, s = "undefined" == typeof r ? function () {
    } : function (t) {
        r.error(t)
    };
    return n(e || t.jQuery), i
}), function (t, e) {
    "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", e) : "object" == typeof module && module.exports ? module.exports = e() : t.EvEmitter = e()
}("undefined" != typeof window ? window : this, function () {
    function t() {
    }

    var e = t.prototype;
    return e.on = function (t, e) {
        if (t && e) {
            var i = this._events = this._events || {}, n = i[t] = i[t] || [];
            return -1 == n.indexOf(e) && n.push(e), this
        }
    }, e.once = function (t, e) {
        if (t && e) {
            this.on(t, e);
            var i = this._onceEvents = this._onceEvents || {}, n = i[t] = i[t] || {};
            return n[e] = !0, this
        }
    }, e.off = function (t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
            var n = i.indexOf(e);
            return -1 != n && i.splice(n, 1), this
        }
    }, e.emitEvent = function (t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
            var n = 0, o = i[n];
            e = e || [];
            for (var r = this._onceEvents && this._onceEvents[t]; o;) {
                var s = r && r[o];
                s && (this.off(t, o), delete r[o]), o.apply(this, e), n += s ? 0 : 1, o = i[n]
            }
            return this
        }
    }, t
}), function (t, e) {
    "use strict";
    "function" == typeof define && define.amd ? define("get-size/get-size", [], function () {
        return e()
    }) : "object" == typeof module && module.exports ? module.exports = e() : t.getSize = e()
}(window, function () {
    "use strict";

    function t(t) {
        var e = parseFloat(t), i = -1 == t.indexOf("%") && !isNaN(e);
        return i && e
    }

    function e() {
    }

    function i() {
        for (var t = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0
        }, e = 0; u > e; e++) {
            var i = h[e];
            t[i] = 0
        }
        return t
    }

    function n(t) {
        var e = getComputedStyle(t);
        return e || a("Style returned " + e + ". Are you running this code in a hidden iframe on Firefox? See http://bit.ly/getsizebug1"), e
    }

    function o() {
        if (!d) {
            d = !0;
            var e = document.createElement("div");
            e.style.width = "200px", e.style.padding = "1px 2px 3px 4px", e.style.borderStyle = "solid", e.style.borderWidth = "1px 2px 3px 4px", e.style.boxSizing = "border-box";
            var i = document.body || document.documentElement;
            i.appendChild(e);
            var o = n(e);
            r.isBoxSizeOuter = s = 200 == t(o.width), i.removeChild(e)
        }
    }

    function r(e) {
        if (o(), "string" == typeof e && (e = document.querySelector(e)), e && "object" == typeof e && e.nodeType) {
            var r = n(e);
            if ("none" == r.display) return i();
            var a = {};
            a.width = e.offsetWidth, a.height = e.offsetHeight;
            for (var d = a.isBorderBox = "border-box" == r.boxSizing, l = 0; u > l; l++) {
                var c = h[l], f = r[c], m = parseFloat(f);
                a[c] = isNaN(m) ? 0 : m
            }
            var p = a.paddingLeft + a.paddingRight, g = a.paddingTop + a.paddingBottom,
                y = a.marginLeft + a.marginRight, v = a.marginTop + a.marginBottom,
                _ = a.borderLeftWidth + a.borderRightWidth, E = a.borderTopWidth + a.borderBottomWidth, z = d && s,
                b = t(r.width);
            b !== !1 && (a.width = b + (z ? 0 : p + _));
            var x = t(r.height);
            return x !== !1 && (a.height = x + (z ? 0 : g + E)), a.innerWidth = a.width - (p + _), a.innerHeight = a.height - (g + E), a.outerWidth = a.width + y, a.outerHeight = a.height + v, a
        }
    }

    var s, a = "undefined" == typeof console ? e : function (t) {
            console.error(t)
        },
        h = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
        u = h.length, d = !1;
    return r
}), function (t, e) {
    "use strict";
    "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", e) : "object" == typeof module && module.exports ? module.exports = e() : t.matchesSelector = e()
}(window, function () {
    "use strict";
    var t = function () {
        var t = Element.prototype;
        if (t.matches) return "matches";
        if (t.matchesSelector) return "matchesSelector";
        for (var e = ["webkit", "moz", "ms", "o"], i = 0; i < e.length; i++) {
            var n = e[i], o = n + "MatchesSelector";
            if (t[o]) return o
        }
    }();
    return function (e, i) {
        return e[t](i)
    }
}), function (t, e) {
    "function" == typeof define && define.amd ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function (i) {
        return e(t, i)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("desandro-matches-selector")) : t.fizzyUIUtils = e(t, t.matchesSelector)
}(window, function (t, e) {
    var i = {};
    i.extend = function (t, e) {
        for (var i in e) t[i] = e[i];
        return t
    }, i.modulo = function (t, e) {
        return (t % e + e) % e
    }, i.makeArray = function (t) {
        var e = [];
        if (Array.isArray(t)) e = t; else if (t && "number" == typeof t.length) for (var i = 0; i < t.length; i++) e.push(t[i]); else e.push(t);
        return e
    }, i.removeFrom = function (t, e) {
        var i = t.indexOf(e);
        -1 != i && t.splice(i, 1)
    }, i.getParent = function (t, i) {
        for (; t != document.body;) if (t = t.parentNode, e(t, i)) return t
    }, i.getQueryElement = function (t) {
        return "string" == typeof t ? document.querySelector(t) : t
    }, i.handleEvent = function (t) {
        var e = "on" + t.type;
        this[e] && this[e](t)
    }, i.filterFindElements = function (t, n) {
        t = i.makeArray(t);
        var o = [];
        return t.forEach(function (t) {
            if (t instanceof HTMLElement) {
                if (!n) return void o.push(t);
                e(t, n) && o.push(t);
                for (var i = t.querySelectorAll(n), r = 0; r < i.length; r++) o.push(i[r])
            }
        }), o
    }, i.debounceMethod = function (t, e, i) {
        var n = t.prototype[e], o = e + "Timeout";
        t.prototype[e] = function () {
            var t = this[o];
            t && clearTimeout(t);
            var e = arguments, r = this;
            this[o] = setTimeout(function () {
                n.apply(r, e), delete r[o]
            }, i || 100)
        }
    }, i.docReady = function (t) {
        var e = document.readyState;
        "complete" == e || "interactive" == e ? t() : document.addEventListener("DOMContentLoaded", t)
    }, i.toDashed = function (t) {
        return t.replace(/(.)([A-Z])/g, function (t, e, i) {
            return e + "-" + i
        }).toLowerCase()
    };
    var n = t.console;
    return i.htmlInit = function (e, o) {
        i.docReady(function () {
            var r = i.toDashed(o), s = "data-" + r, a = document.querySelectorAll("[" + s + "]"),
                h = document.querySelectorAll(".js-" + r), u = i.makeArray(a).concat(i.makeArray(h)),
                d = s + "-options", l = t.jQuery;
            u.forEach(function (t) {
                var i, r = t.getAttribute(s) || t.getAttribute(d);
                try {
                    i = r && JSON.parse(r)
                } catch (a) {
                    return void (n && n.error("Error parsing " + s + " on " + t.className + ": " + a))
                }
                var h = new e(t, i);
                l && l.data(t, o, h)
            })
        })
    }, i
}), function (t, e) {
    "function" == typeof define && define.amd ? define("outlayer/item", ["ev-emitter/ev-emitter", "get-size/get-size"], e) : "object" == typeof module && module.exports ? module.exports = e(require("ev-emitter"), require("get-size")) : (t.Outlayer = {}, t.Outlayer.Item = e(t.EvEmitter, t.getSize))
}(window, function (t, e) {
    "use strict";

    function i(t) {
        for (var e in t) return !1;
        return e = null, !0
    }

    function n(t, e) {
        t && (this.element = t, this.layout = e, this.position = {x: 0, y: 0}, this._create())
    }

    function o(t) {
        return t.replace(/([A-Z])/g, function (t) {
            return "-" + t.toLowerCase()
        })
    }

    var r = document.documentElement.style, s = "string" == typeof r.transition ? "transition" : "WebkitTransition",
        a = "string" == typeof r.transform ? "transform" : "WebkitTransform",
        h = {WebkitTransition: "webkitTransitionEnd", transition: "transitionend"}[s], u = {
            transform: a,
            transition: s,
            transitionDuration: s + "Duration",
            transitionProperty: s + "Property",
            transitionDelay: s + "Delay"
        }, d = n.prototype = Object.create(t.prototype);
    d.constructor = n, d._create = function () {
        this._transn = {ingProperties: {}, clean: {}, onEnd: {}}, this.css({position: "absolute"})
    }, d.handleEvent = function (t) {
        var e = "on" + t.type;
        this[e] && this[e](t)
    }, d.getSize = function () {
        this.size = e(this.element)
    }, d.css = function (t) {
        var e = this.element.style;
        for (var i in t) {
            var n = u[i] || i;
            e[n] = t[i]
        }
    }, d.getPosition = function () {
        var t = getComputedStyle(this.element), e = this.layout._getOption("originLeft"),
            i = this.layout._getOption("originTop"), n = t[e ? "left" : "right"], o = t[i ? "top" : "bottom"],
            r = this.layout.size, s = -1 != n.indexOf("%") ? parseFloat(n) / 100 * r.width : parseInt(n, 10),
            a = -1 != o.indexOf("%") ? parseFloat(o) / 100 * r.height : parseInt(o, 10);
        s = isNaN(s) ? 0 : s, a = isNaN(a) ? 0 : a, s -= e ? r.paddingLeft : r.paddingRight, a -= i ? r.paddingTop : r.paddingBottom, this.position.x = s, this.position.y = a
    }, d.layoutPosition = function () {
        var t = this.layout.size, e = {}, i = this.layout._getOption("originLeft"),
            n = this.layout._getOption("originTop"), o = i ? "paddingLeft" : "paddingRight", r = i ? "left" : "right",
            s = i ? "right" : "left", a = this.position.x + t[o];
        e[r] = this.getXValue(a), e[s] = "";
        var h = n ? "paddingTop" : "paddingBottom", u = n ? "top" : "bottom", d = n ? "bottom" : "top",
            l = this.position.y + t[h];
        e[u] = this.getYValue(l), e[d] = "", this.css(e), this.emitEvent("layout", [this])
    }, d.getXValue = function (t) {
        var e = this.layout._getOption("horizontal");
        return this.layout.options.percentPosition && !e ? t / this.layout.size.width * 100 + "%" : t + "px"
    }, d.getYValue = function (t) {
        var e = this.layout._getOption("horizontal");
        return this.layout.options.percentPosition && e ? t / this.layout.size.height * 100 + "%" : t + "px"
    }, d._transitionTo = function (t, e) {
        this.getPosition();
        var i = this.position.x, n = this.position.y, o = parseInt(t, 10), r = parseInt(e, 10),
            s = o === this.position.x && r === this.position.y;
        if (this.setPosition(t, e), s && !this.isTransitioning) return void this.layoutPosition();
        var a = t - i, h = e - n, u = {};
        u.transform = this.getTranslate(a, h), this.transition({
            to: u,
            onTransitionEnd: {transform: this.layoutPosition},
            isCleaning: !0
        })
    }, d.getTranslate = function (t, e) {
        var i = this.layout._getOption("originLeft"), n = this.layout._getOption("originTop");
        return t = i ? t : -t, e = n ? e : -e, "translate3d(" + t + "px, " + e + "px, 0)"
    }, d.goTo = function (t, e) {
        this.setPosition(t, e), this.layoutPosition()
    }, d.moveTo = d._transitionTo, d.setPosition = function (t, e) {
        this.position.x = parseInt(t, 10), this.position.y = parseInt(e, 10)
    }, d._nonTransition = function (t) {
        this.css(t.to), t.isCleaning && this._removeStyles(t.to);
        for (var e in t.onTransitionEnd) t.onTransitionEnd[e].call(this)
    }, d.transition = function (t) {
        if (!parseFloat(this.layout.options.transitionDuration)) return void this._nonTransition(t);
        var e = this._transn;
        for (var i in t.onTransitionEnd) e.onEnd[i] = t.onTransitionEnd[i];
        for (i in t.to) e.ingProperties[i] = !0, t.isCleaning && (e.clean[i] = !0);
        if (t.from) {
            this.css(t.from);
            var n = this.element.offsetHeight;
            n = null
        }
        this.enableTransition(t.to), this.css(t.to), this.isTransitioning = !0
    };
    var l = "opacity," + o(a);
    d.enableTransition = function () {
        if (!this.isTransitioning) {
            var t = this.layout.options.transitionDuration;
            t = "number" == typeof t ? t + "ms" : t, this.css({
                transitionProperty: l,
                transitionDuration: t,
                transitionDelay: this.staggerDelay || 0
            }), this.element.addEventListener(h, this, !1)
        }
    }, d.onwebkitTransitionEnd = function (t) {
        this.ontransitionend(t)
    }, d.onotransitionend = function (t) {
        this.ontransitionend(t)
    };
    var c = {"-webkit-transform": "transform"};
    d.ontransitionend = function (t) {
        if (t.target === this.element) {
            var e = this._transn, n = c[t.propertyName] || t.propertyName;
            if (delete e.ingProperties[n], i(e.ingProperties) && this.disableTransition(), n in e.clean && (this.element.style[t.propertyName] = "", delete e.clean[n]), n in e.onEnd) {
                var o = e.onEnd[n];
                o.call(this), delete e.onEnd[n]
            }
            this.emitEvent("transitionEnd", [this])
        }
    }, d.disableTransition = function () {
        this.removeTransitionStyles(), this.element.removeEventListener(h, this, !1), this.isTransitioning = !1
    }, d._removeStyles = function (t) {
        var e = {};
        for (var i in t) e[i] = "";
        this.css(e)
    };
    var f = {transitionProperty: "", transitionDuration: "", transitionDelay: ""};
    return d.removeTransitionStyles = function () {
        this.css(f)
    }, d.stagger = function (t) {
        t = isNaN(t) ? 0 : t, this.staggerDelay = t + "ms"
    }, d.removeElem = function () {
        this.element.parentNode.removeChild(this.element), this.css({display: ""}), this.emitEvent("remove", [this])
    }, d.remove = function () {
        return s && parseFloat(this.layout.options.transitionDuration) ? (this.once("transitionEnd", function () {
            this.removeElem()
        }), void this.hide()) : void this.removeElem()
    }, d.reveal = function () {
        delete this.isHidden, this.css({display: ""});
        var t = this.layout.options, e = {}, i = this.getHideRevealTransitionEndProperty("visibleStyle");
        e[i] = this.onRevealTransitionEnd, this.transition({
            from: t.hiddenStyle,
            to: t.visibleStyle,
            isCleaning: !0,
            onTransitionEnd: e
        })
    }, d.onRevealTransitionEnd = function () {
        this.isHidden || this.emitEvent("reveal")
    }, d.getHideRevealTransitionEndProperty = function (t) {
        var e = this.layout.options[t];
        if (e.opacity) return "opacity";
        for (var i in e) return i
    }, d.hide = function () {
        this.isHidden = !0, this.css({display: ""});
        var t = this.layout.options, e = {}, i = this.getHideRevealTransitionEndProperty("hiddenStyle");
        e[i] = this.onHideTransitionEnd, this.transition({
            from: t.visibleStyle,
            to: t.hiddenStyle,
            isCleaning: !0,
            onTransitionEnd: e
        })
    }, d.onHideTransitionEnd = function () {
        this.isHidden && (this.css({display: "none"}), this.emitEvent("hide"))
    }, d.destroy = function () {
        this.css({position: "", left: "", right: "", top: "", bottom: "", transition: "", transform: ""})
    }, n
}), function (t, e) {
    "use strict";
    "function" == typeof define && define.amd ? define("outlayer/outlayer", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./item"], function (i, n, o, r) {
        return e(t, i, n, o, r)
    }) : "object" == typeof module && module.exports ? module.exports = e(t, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./item")) : t.Outlayer = e(t, t.EvEmitter, t.getSize, t.fizzyUIUtils, t.Outlayer.Item)
}(window, function (t, e, i, n, o) {
    "use strict";

    function r(t, e) {
        var i = n.getQueryElement(t);
        if (!i) return void (h && h.error("Bad element for " + this.constructor.namespace + ": " + (i || t)));
        this.element = i, u && (this.$element = u(this.element)), this.options = n.extend({}, this.constructor.defaults), this.option(e);
        var o = ++l;
        this.element.outlayerGUID = o, c[o] = this, this._create();
        var r = this._getOption("initLayout");
        r && this.layout()
    }

    function s(t) {
        function e() {
            t.apply(this, arguments)
        }

        return e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e
    }

    function a(t) {
        if ("number" == typeof t) return t;
        var e = t.match(/(^\d*\.?\d*)(\w*)/), i = e && e[1], n = e && e[2];
        if (!i.length) return 0;
        i = parseFloat(i);
        var o = m[n] || 1;
        return i * o
    }

    var h = t.console, u = t.jQuery, d = function () {
    }, l = 0, c = {};
    r.namespace = "outlayer", r.Item = o, r.defaults = {
        containerStyle: {position: "relative"},
        initLayout: !0,
        originLeft: !0,
        originTop: !0,
        resize: !0,
        resizeContainer: !0,
        transitionDuration: "0.4s",
        hiddenStyle: {opacity: 0, transform: "scale(0.001)"},
        visibleStyle: {opacity: 1, transform: "scale(1)"}
    };
    var f = r.prototype;
    n.extend(f, e.prototype), f.option = function (t) {
        n.extend(this.options, t)
    }, f._getOption = function (t) {
        var e = this.constructor.compatOptions[t];
        return e && void 0 !== this.options[e] ? this.options[e] : this.options[t]
    }, r.compatOptions = {
        initLayout: "isInitLayout",
        horizontal: "isHorizontal",
        layoutInstant: "isLayoutInstant",
        originLeft: "isOriginLeft",
        originTop: "isOriginTop",
        resize: "isResizeBound",
        resizeContainer: "isResizingContainer"
    }, f._create = function () {
        this.reloadItems(), this.stamps = [], this.stamp(this.options.stamp), n.extend(this.element.style, this.options.containerStyle);
        var t = this._getOption("resize");
        t && this.bindResize()
    }, f.reloadItems = function () {
        this.items = this._itemize(this.element.children)
    }, f._itemize = function (t) {
        for (var e = this._filterFindItemElements(t), i = this.constructor.Item, n = [], o = 0; o < e.length; o++) {
            var r = e[o], s = new i(r, this);
            n.push(s)
        }
        return n
    }, f._filterFindItemElements = function (t) {
        return n.filterFindElements(t, this.options.itemSelector)
    }, f.getItemElements = function () {
        return this.items.map(function (t) {
            return t.element
        })
    }, f.layout = function () {
        this._resetLayout(), this._manageStamps();
        var t = this._getOption("layoutInstant"), e = void 0 !== t ? t : !this._isLayoutInited;
        this.layoutItems(this.items, e), this._isLayoutInited = !0
    }, f._init = f.layout, f._resetLayout = function () {
        this.getSize()
    }, f.getSize = function () {
        this.size = i(this.element)
    }, f._getMeasurement = function (t, e) {
        var n, o = this.options[t];
        o ? ("string" == typeof o ? n = this.element.querySelector(o) : o instanceof HTMLElement && (n = o), this[t] = n ? i(n)[e] : o) : this[t] = 0
    }, f.layoutItems = function (t, e) {
        t = this._getItemsForLayout(t), this._layoutItems(t, e), this._postLayout()
    }, f._getItemsForLayout = function (t) {
        return t.filter(function (t) {
            return !t.isIgnored
        })
    }, f._layoutItems = function (t, e) {
        if (this._emitCompleteOnItems("layout", t), t && t.length) {
            var i = [];
            t.forEach(function (t) {
                var n = this._getItemLayoutPosition(t);
                n.item = t, n.isInstant = e || t.isLayoutInstant, i.push(n)
            }, this), this._processLayoutQueue(i)
        }
    }, f._getItemLayoutPosition = function () {
        return {x: 0, y: 0}
    }, f._processLayoutQueue = function (t) {
        this.updateStagger(), t.forEach(function (t, e) {
            this._positionItem(t.item, t.x, t.y, t.isInstant, e)
        }, this)
    }, f.updateStagger = function () {
        var t = this.options.stagger;
        return null === t || void 0 === t ? void (this.stagger = 0) : (this.stagger = a(t), this.stagger)
    }, f._positionItem = function (t, e, i, n, o) {
        n ? t.goTo(e, i) : (t.stagger(o * this.stagger), t.moveTo(e, i))
    }, f._postLayout = function () {
        this.resizeContainer()
    }, f.resizeContainer = function () {
        var t = this._getOption("resizeContainer");
        if (t) {
            var e = this._getContainerSize();
            e && (this._setContainerMeasure(e.width, !0), this._setContainerMeasure(e.height, !1))
        }
    }, f._getContainerSize = d, f._setContainerMeasure = function (t, e) {
        if (void 0 !== t) {
            var i = this.size;
            i.isBorderBox && (t += e ? i.paddingLeft + i.paddingRight + i.borderLeftWidth + i.borderRightWidth : i.paddingBottom + i.paddingTop + i.borderTopWidth + i.borderBottomWidth), t = Math.max(t, 0), this.element.style[e ? "width" : "height"] = t + "px"
        }
    }, f._emitCompleteOnItems = function (t, e) {
        function i() {
            o.dispatchEvent(t + "Complete", null, [e])
        }

        function n() {
            s++, s == r && i()
        }

        var o = this, r = e.length;
        if (!e || !r) return void i();
        var s = 0;
        e.forEach(function (e) {
            e.once(t, n)
        })
    }, f.dispatchEvent = function (t, e, i) {
        var n = e ? [e].concat(i) : i;
        if (this.emitEvent(t, n), u) if (this.$element = this.$element || u(this.element), e) {
            var o = u.Event(e);
            o.type = t, this.$element.trigger(o, i)
        } else this.$element.trigger(t, i)
    }, f.ignore = function (t) {
        var e = this.getItem(t);
        e && (e.isIgnored = !0)
    }, f.unignore = function (t) {
        var e = this.getItem(t);
        e && delete e.isIgnored
    }, f.stamp = function (t) {
        t = this._find(t), t && (this.stamps = this.stamps.concat(t), t.forEach(this.ignore, this))
    }, f.unstamp = function (t) {
        t = this._find(t), t && t.forEach(function (t) {
            n.removeFrom(this.stamps, t), this.unignore(t)
        }, this)
    }, f._find = function (t) {
        return t ? ("string" == typeof t && (t = this.element.querySelectorAll(t)), t = n.makeArray(t)) : void 0
    }, f._manageStamps = function () {
        this.stamps && this.stamps.length && (this._getBoundingRect(), this.stamps.forEach(this._manageStamp, this))
    }, f._getBoundingRect = function () {
        var t = this.element.getBoundingClientRect(), e = this.size;
        this._boundingRect = {
            left: t.left + e.paddingLeft + e.borderLeftWidth,
            top: t.top + e.paddingTop + e.borderTopWidth,
            right: t.right - (e.paddingRight + e.borderRightWidth),
            bottom: t.bottom - (e.paddingBottom + e.borderBottomWidth)
        }
    }, f._manageStamp = d, f._getElementOffset = function (t) {
        var e = t.getBoundingClientRect(), n = this._boundingRect, o = i(t), r = {
            left: e.left - n.left - o.marginLeft,
            top: e.top - n.top - o.marginTop,
            right: n.right - e.right - o.marginRight,
            bottom: n.bottom - e.bottom - o.marginBottom
        };
        return r
    }, f.handleEvent = n.handleEvent, f.bindResize = function () {
        t.addEventListener("resize", this), this.isResizeBound = !0
    }, f.unbindResize = function () {
        t.removeEventListener("resize", this), this.isResizeBound = !1
    }, f.onresize = function () {
        this.resize()
    }, n.debounceMethod(r, "onresize", 100), f.resize = function () {
        this.isResizeBound && this.needsResizeLayout() && this.layout()
    }, f.needsResizeLayout = function () {
        var t = i(this.element), e = this.size && t;
        return e && t.innerWidth !== this.size.innerWidth
    }, f.addItems = function (t) {
        var e = this._itemize(t);
        return e.length && (this.items = this.items.concat(e)), e
    }, f.appended = function (t) {
        var e = this.addItems(t);
        e.length && (this.layoutItems(e, !0), this.reveal(e))
    }, f.prepended = function (t) {
        var e = this._itemize(t);
        if (e.length) {
            var i = this.items.slice(0);
            this.items = e.concat(i), this._resetLayout(), this._manageStamps(), this.layoutItems(e, !0), this.reveal(e), this.layoutItems(i)
        }
    }, f.reveal = function (t) {
        if (this._emitCompleteOnItems("reveal", t), t && t.length) {
            var e = this.updateStagger();
            t.forEach(function (t, i) {
                t.stagger(i * e), t.reveal()
            })
        }
    }, f.hide = function (t) {
        if (this._emitCompleteOnItems("hide", t), t && t.length) {
            var e = this.updateStagger();
            t.forEach(function (t, i) {
                t.stagger(i * e), t.hide()
            })
        }
    }, f.revealItemElements = function (t) {
        var e = this.getItems(t);
        this.reveal(e)
    }, f.hideItemElements = function (t) {
        var e = this.getItems(t);
        this.hide(e)
    }, f.getItem = function (t) {
        for (var e = 0; e < this.items.length; e++) {
            var i = this.items[e];
            if (i.element == t) return i
        }
    }, f.getItems = function (t) {
        t = n.makeArray(t);
        var e = [];
        return t.forEach(function (t) {
            var i = this.getItem(t);
            i && e.push(i)
        }, this), e
    }, f.remove = function (t) {
        var e = this.getItems(t);
        this._emitCompleteOnItems("remove", e), e && e.length && e.forEach(function (t) {
            t.remove(), n.removeFrom(this.items, t)
        }, this)
    }, f.destroy = function () {
        var t = this.element.style;
        t.height = "", t.position = "", t.width = "", this.items.forEach(function (t) {
            t.destroy()
        }), this.unbindResize();
        var e = this.element.outlayerGUID;
        delete c[e], delete this.element.outlayerGUID, u && u.removeData(this.element, this.constructor.namespace)
    }, r.data = function (t) {
        t = n.getQueryElement(t);
        var e = t && t.outlayerGUID;
        return e && c[e]
    }, r.create = function (t, e) {
        var i = s(r);
        return i.defaults = n.extend({}, r.defaults), n.extend(i.defaults, e), i.compatOptions = n.extend({}, r.compatOptions), i.namespace = t, i.data = r.data, i.Item = s(o), n.htmlInit(i, t), u && u.bridget && u.bridget(t, i), i
    };
    var m = {ms: 1, s: 1e3};
    return r.Item = o, r
}), function (t, e) {
    "function" == typeof define && define.amd ? define(["outlayer/outlayer", "get-size/get-size"], e) : "object" == typeof module && module.exports ? module.exports = e(require("outlayer"), require("get-size")) : t.Masonry = e(t.Outlayer, t.getSize)
}(window, function (t, e) {
    var i = t.create("masonry");
    return i.compatOptions.fitWidth = "isFitWidth", i.prototype._resetLayout = function () {
        this.getSize(), this._getMeasurement("columnWidth", "outerWidth"), this._getMeasurement("gutter", "outerWidth"), this.measureColumns(), this.colYs = [];
        for (var t = 0; t < this.cols; t++) this.colYs.push(0);
        this.maxY = 0
    }, i.prototype.measureColumns = function () {
        if (this.getContainerWidth(), !this.columnWidth) {
            var t = this.items[0], i = t && t.element;
            this.columnWidth = i && e(i).outerWidth || this.containerWidth
        }
        var n = this.columnWidth += this.gutter, o = this.containerWidth + this.gutter, r = o / n, s = n - o % n,
            a = s && 1 > s ? "round" : "floor";
        r = Math[a](r), this.cols = Math.max(r, 1)
    }, i.prototype.getContainerWidth = function () {
        var t = this._getOption("fitWidth"), i = t ? this.element.parentNode : this.element, n = e(i);
        this.containerWidth = n && n.innerWidth
    }, i.prototype._getItemLayoutPosition = function (t) {
        t.getSize();
        var e = t.size.outerWidth % this.columnWidth, i = e && 1 > e ? "round" : "ceil",
            n = Math[i](t.size.outerWidth / this.columnWidth);
        n = Math.min(n, this.cols);
        for (var o = this._getColGroup(n), r = Math.min.apply(Math, o), s = o.indexOf(r), a = {
            x: this.columnWidth * s,
            y: r
        }, h = r + t.size.outerHeight, u = this.cols + 1 - o.length, d = 0; u > d; d++) this.colYs[s + d] = h;
        return a
    }, i.prototype._getColGroup = function (t) {
        if (2 > t) return this.colYs;
        for (var e = [], i = this.cols + 1 - t, n = 0; i > n; n++) {
            var o = this.colYs.slice(n, n + t);
            e[n] = Math.max.apply(Math, o)
        }
        return e
    }, i.prototype._manageStamp = function (t) {
        var i = e(t), n = this._getElementOffset(t), o = this._getOption("originLeft"), r = o ? n.left : n.right,
            s = r + i.outerWidth, a = Math.floor(r / this.columnWidth);
        a = Math.max(0, a);
        var h = Math.floor(s / this.columnWidth);
        h -= s % this.columnWidth ? 0 : 1, h = Math.min(this.cols - 1, h);
        for (var u = this._getOption("originTop"), d = (u ? n.top : n.bottom) + i.outerHeight, l = a; h >= l; l++) this.colYs[l] = Math.max(d, this.colYs[l])
    }, i.prototype._getContainerSize = function () {
        this.maxY = Math.max.apply(Math, this.colYs);
        var t = {height: this.maxY};
        return this._getOption("fitWidth") && (t.width = this._getContainerFitWidth()), t
    }, i.prototype._getContainerFitWidth = function () {
        for (var t = 0, e = this.cols; --e && 0 === this.colYs[e];) t++;
        return (this.cols - t) * this.columnWidth - this.gutter
    }, i.prototype.needsResizeLayout = function () {
        var t = this.containerWidth;
        return this.getContainerWidth(), t != this.containerWidth
    }, i
});
/*! modernizr 3.3.1 (Custom Build) | MIT *
 * https://modernizr.com/download/?-csstransforms3d-flexbox-setclasses !*/
!function (e, n, t) {
    function r(e, n) {
        return typeof e === n
    }

    function s() {
        var e, n, t, s, o, i, a;
        for (var f in C) if (C.hasOwnProperty(f)) {
            if (e = [], n = C[f], n.name && (e.push(n.name.toLowerCase()), n.options && n.options.aliases && n.options.aliases.length)) for (t = 0; t < n.options.aliases.length; t++) e.push(n.options.aliases[t].toLowerCase());
            for (s = r(n.fn, "function") ? n.fn() : n.fn, o = 0; o < e.length; o++) i = e[o], a = i.split("."), 1 === a.length ? Modernizr[a[0]] = s : (!Modernizr[a[0]] || Modernizr[a[0]] instanceof Boolean || (Modernizr[a[0]] = new Boolean(Modernizr[a[0]])), Modernizr[a[0]][a[1]] = s), y.push((s ? "" : "no-") + a.join("-"))
        }
    }

    function o(e) {
        var n = x.className, t = Modernizr._config.classPrefix || "";
        if (S && (n = n.baseVal), Modernizr._config.enableJSClass) {
            var r = new RegExp("(^|\\s)" + t + "no-js(\\s|$)");
            n = n.replace(r, "$1" + t + "js$2")
        }
        Modernizr._config.enableClasses && (n += " " + t + e.join(" " + t), S ? x.className.baseVal = n : x.className = n)
    }

    function i() {
        return "function" != typeof n.createElement ? n.createElement(arguments[0]) : S ? n.createElementNS.call(n, "http://www.w3.org/2000/svg", arguments[0]) : n.createElement.apply(n, arguments)
    }

    function a() {
        var e = n.body;
        return e || (e = i(S ? "svg" : "body"), e.fake = !0), e
    }

    function f(e, t, r, s) {
        var o, f, l, u, p = "modernizr", d = i("div"), c = a();
        if (parseInt(r, 10)) for (; r--;) l = i("div"), l.id = s ? s[r] : p + (r + 1), d.appendChild(l);
        return o = i("style"), o.type = "text/css", o.id = "s" + p, (c.fake ? c : d).appendChild(o), c.appendChild(d), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(n.createTextNode(e)), d.id = p, c.fake && (c.style.background = "", c.style.overflow = "hidden", u = x.style.overflow, x.style.overflow = "hidden", x.appendChild(c)), f = t(d, e), c.fake ? (c.parentNode.removeChild(c), x.style.overflow = u, x.offsetHeight) : d.parentNode.removeChild(d), !!f
    }

    function l(e, n) {
        return !!~("" + e).indexOf(n)
    }

    function u(e) {
        return e.replace(/([a-z])-([a-z])/g, function (e, n, t) {
            return n + t.toUpperCase()
        }).replace(/^-/, "")
    }

    function p(e, n) {
        return function () {
            return e.apply(n, arguments)
        }
    }

    function d(e, n, t) {
        var s;
        for (var o in e) if (e[o] in n) return t === !1 ? e[o] : (s = n[e[o]], r(s, "function") ? p(s, t || n) : s);
        return !1
    }

    function c(e) {
        return e.replace(/([A-Z])/g, function (e, n) {
            return "-" + n.toLowerCase()
        }).replace(/^ms-/, "-ms-")
    }

    function m(n, r) {
        var s = n.length;
        if ("CSS" in e && "supports" in e.CSS) {
            for (; s--;) if (e.CSS.supports(c(n[s]), r)) return !0;
            return !1
        }
        if ("CSSSupportsRule" in e) {
            for (var o = []; s--;) o.push("(" + c(n[s]) + ":" + r + ")");
            return o = o.join(" or "), f("@supports (" + o + ") { #modernizr { position: absolute; } }", function (e) {
                return "absolute" == getComputedStyle(e, null).position
            })
        }
        return t
    }

    function h(e, n, s, o) {
        function a() {
            p && (delete k.style, delete k.modElem)
        }

        if (o = r(o, "undefined") ? !1 : o, !r(s, "undefined")) {
            var f = m(e, s);
            if (!r(f, "undefined")) return f
        }
        for (var p, d, c, h, v, g = ["modernizr", "tspan", "samp"]; !k.style && g.length;) p = !0, k.modElem = i(g.shift()), k.style = k.modElem.style;
        for (c = e.length, d = 0; c > d; d++) if (h = e[d], v = k.style[h], l(h, "-") && (h = u(h)), k.style[h] !== t) {
            if (o || r(s, "undefined")) return a(), "pfx" == n ? h : !0;
            try {
                k.style[h] = s
            } catch (y) {
            }
            if (k.style[h] != v) return a(), "pfx" == n ? h : !0
        }
        return a(), !1
    }

    function v(e, n, t, s, o) {
        var i = e.charAt(0).toUpperCase() + e.slice(1), a = (e + " " + E.join(i + " ") + i).split(" ");
        return r(n, "string") || r(n, "undefined") ? h(a, n, s, o) : (a = (e + " " + T.join(i + " ") + i).split(" "), d(a, n, t))
    }

    function g(e, n, r) {
        return v(e, t, t, n, r)
    }

    var y = [], C = [], w = {
        _version: "3.3.1",
        _config: {classPrefix: "", enableClasses: !0, enableJSClass: !0, usePrefixes: !0},
        _q: [],
        on: function (e, n) {
            var t = this;
            setTimeout(function () {
                n(t[e])
            }, 0)
        },
        addTest: function (e, n, t) {
            C.push({name: e, fn: n, options: t})
        },
        addAsyncTest: function (e) {
            C.push({name: null, fn: e})
        }
    }, Modernizr = function () {
    };
    Modernizr.prototype = w, Modernizr = new Modernizr;
    var x = n.documentElement, S = "svg" === x.nodeName.toLowerCase(), _ = "CSS" in e && "supports" in e.CSS,
        b = "supportsCSS" in e;
    Modernizr.addTest("supports", _ || b);
    var P = w.testStyles = f, z = "Moz O ms Webkit", E = w._config.usePrefixes ? z.split(" ") : [];
    w._cssomPrefixes = E;
    var T = w._config.usePrefixes ? z.toLowerCase().split(" ") : [];
    w._domPrefixes = T;
    var N = {elem: i("modernizr")};
    Modernizr._q.push(function () {
        delete N.elem
    });
    var k = {style: N.elem.style};
    Modernizr._q.unshift(function () {
        delete k.style
    }), w.testAllProps = v, w.testAllProps = g, Modernizr.addTest("flexbox", g("flexBasis", "1px", !0)), Modernizr.addTest("csstransforms3d", function () {
        var e = !!g("perspective", "1px", !0), n = Modernizr._config.usePrefixes;
        if (e && (!n || "webkitPerspective" in x.style)) {
            var t, r = "#modernizr{width:0;height:0}";
            Modernizr.supports ? t = "@supports (perspective: 1px)" : (t = "@media (transform-3d)", n && (t += ",(-webkit-transform-3d)")), t += "{#modernizr{width:7px;height:18px;margin:0;padding:0;border:0}}", P(r + t, function (n) {
                e = 7 === n.offsetWidth && 18 === n.offsetHeight
            })
        }
        return e
    }), s(), o(y), delete w.addTest, delete w.addAsyncTest;
    for (var j = 0; j < Modernizr._q.length; j++) Modernizr._q[j]();
    e.Modernizr = Modernizr
}(window, document);
/*! respimage - v1.4.2 - 2015-08-22
 Licensed MIT */
!function (a, b, c) {
    "use strict";

    function d(a) {
        return a.trim ? a.trim() : a.replace(/^\s+|\s+$/g, "")
    }

    function e() {
        var b;
        R = !1, U = a.devicePixelRatio, S = {}, T = {}, b = (U || 1) * D.xQuant, D.uT || (D.maxX = Math.max(1.3, D.maxX), b = Math.min(b, D.maxX), v.DPR = b), V.width = Math.max(a.innerWidth || 0, B.clientWidth), V.height = Math.max(a.innerHeight || 0, B.clientHeight), V.vw = V.width / 100, V.vh = V.height / 100, V.em = v.getEmValue(), V.rem = V.em, o = D.lazyFactor / 2, o = o * b + o, q = .4 + .1 * b, l = .5 + .2 * b, m = .5 + .25 * b, p = b + 1.3, (n = V.width > V.height) || (o *= .9), I && (o *= .9), u = [V.width, V.height, b].join("-")
    }

    function f(a, b, c) {
        var d = b * Math.pow(a - .4, 1.9);
        return n || (d /= 1.3), a += d, a > c
    }

    function g(a) {
        var b, c = v.getSet(a), d = !1;
        "pending" != c && (d = u, c && (b = v.setRes(c), d = v.applySetCandidate(b, a))), a[v.ns].evaled = d
    }

    function h(a, b) {
        return a.res - b.res
    }

    function i(a, b, c) {
        var d;
        return !c && b && (c = a[v.ns].sets, c = c && c[c.length - 1]), d = j(b, c), d && (b = v.makeUrl(b), a[v.ns].curSrc = b, a[v.ns].curCan = d, d.res || _(d, d.set.sizes)), d
    }

    function j(a, b) {
        var c, d, e;
        if (a && b) for (e = v.parseSet(b), a = v.makeUrl(a), c = 0; c < e.length; c++) if (a == v.makeUrl(e[c].url)) {
            d = e[c];
            break
        }
        return d
    }

    function k(a, b) {
        var c, d, e, f, g = a.getElementsByTagName("source");
        for (c = 0, d = g.length; d > c; c++) e = g[c], e[v.ns] = !0, f = e.getAttribute("srcset"), f && b.push({
            srcset: f,
            media: e.getAttribute("media"),
            type: e.getAttribute("type"),
            sizes: e.getAttribute("sizes")
        })
    }

    var l, m, n, o, p, q, r, s, t, u, v = {}, w = function () {
        }, x = b.createElement("img"), y = x.getAttribute, z = x.setAttribute, A = x.removeAttribute, B = b.documentElement,
        C = {}, D = {xQuant: 1, lazyFactor: .4, maxX: 2}, E = "data-pfsrc", F = E + "set",
        G = "webkitBackfaceVisibility" in B.style, H = navigator.userAgent,
        I = /rident/.test(H) || /ecko/.test(H) && H.match(/rv\:(\d+)/) && RegExp.$1 > 35, J = "currentSrc",
        K = /\s+\+?\d+(e\d+)?w/, L = /((?:\([^)]+\)(?:\s*and\s*|\s*or\s*|\s*not\s*)?)+)?\s*(.+)/,
        M = /^([\+eE\d\.]+)(w|x)$/, N = /\s*\d+h\s*/, O = a.respimgCFG,
        P = ("https:" == location.protocol, "position:absolute;left:0;visibility:hidden;display:block;padding:0;border:none;font-size:1em;width:1em;overflow:hidden;clip:rect(0px, 0px, 0px, 0px)"),
        Q = "font-size:100%!important;", R = !0, S = {}, T = {}, U = a.devicePixelRatio, V = {px: 1, "in": 96},
        W = b.createElement("a"), X = !1, Y = function (a, b, c, d) {
            a.addEventListener ? a.addEventListener(b, c, d || !1) : a.attachEvent && a.attachEvent("on" + b, c)
        }, Z = function (a) {
            var b = {};
            return function (c) {
                return c in b || (b[c] = a(c)), b[c]
            }
        }, $ = function () {
            var a = /^([\d\.]+)(em|vw|px)$/, b = function () {
                for (var a = arguments, b = 0, c = a[0]; ++b in a;) c = c.replace(a[b], a[++b]);
                return c
            }, c = Z(function (a) {
                return "return " + b((a || "").toLowerCase(), /\band\b/g, "&&", /,/g, "||", /min-([a-z-\s]+):/g, "e.$1>=", /max-([a-z-\s]+):/g, "e.$1<=", /calc([^)]+)/g, "($1)", /(\d+[\.]*[\d]*)([a-z]+)/g, "($1 * e.$2)", /^(?!(e.[a-z]|[0-9\.&=|><\+\-\*\(\)\/])).*/gi, "")
            });
            return function (b, d) {
                var e;
                if (!(b in S)) if (S[b] = !1, d && (e = b.match(a))) S[b] = e[1] * V[e[2]]; else try {
                    S[b] = new Function("e", c(b))(V)
                } catch (f) {
                }
                return S[b]
            }
        }(), _ = function (a, b) {
            return a.w ? (a.cWidth = v.calcListLength(b || "100vw"), a.res = a.w / a.cWidth) : a.res = a.x, a
        }, ab = function (c) {
            var d, e, f, g = c || {};
            if (g.elements && 1 == g.elements.nodeType && ("IMG" == g.elements.nodeName.toUpperCase() ? g.elements = [g.elements] : (g.context = g.elements, g.elements = null)), g.reparse && (g.reevaluate = !0, a.console && console.warn && console.warn("reparse was renamed to reevaluate!")), d = g.elements || v.qsa(g.context || b, g.reevaluate || g.reselect ? v.sel : v.selShort), f = d.length) {
                for (v.setupRun(g), X = !0, e = 0; f > e; e++) v.fillImg(d[e], g);
                v.teardownRun(g)
            }
        }, bb = Z(function (a) {
            var b = [1, "x"], c = d(a || "");
            return c && (c = c.replace(N, ""), b = c.match(M) ? [1 * RegExp.$1, RegExp.$2] : !1), b
        });
    if (J in x || (J = "src"), C["image/jpeg"] = !0, C["image/gif"] = !0, C["image/png"] = !0, C["image/svg+xml"] = b.implementation.hasFeature("http://wwwindow.w3.org/TR/SVG11/feature#Image", "1.1"), v.ns = ("ri" + (new Date).getTime()).substr(0, 9), v.supSrcset = "srcset" in x, v.supSizes = "sizes" in x, v.supPicture = !!a.HTMLPictureElement, v.supSrcset && v.supPicture && !v.supSizes && !function (a) {
        x.srcset = "data:,a", a.src = "data:,a", v.supSrcset = x.complete === a.complete, v.supPicture = v.supSrcset && v.supPicture
    }(b.createElement("img")), v.selShort = "picture>img,img[srcset]", v.sel = v.selShort, v.cfg = D, v.supSrcset && (v.sel += ",img[" + F + "]"), v.DPR = U || 1, v.u = V, v.types = C, s = v.supSrcset && !v.supSizes, v.setSize = w, v.makeUrl = Z(function (a) {
        return W.href = a, W.href
    }), v.qsa = function (a, b) {
        return a.querySelectorAll(b)
    }, v.matchesMedia = function () {
        return v.matchesMedia = a.matchMedia && (matchMedia("(min-width: 0.1em)") || {}).matches ? function (a) {
            return !a || matchMedia(a).matches
        } : v.mMQ, v.matchesMedia.apply(this, arguments)
    }, v.mMQ = function (a) {
        return a ? $(a) : !0
    }, v.calcLength = function (a) {
        var b = $(a, !0) || !1;
        return 0 > b && (b = !1), b
    }, v.supportsType = function (a) {
        return a ? C[a] : !0
    }, v.parseSize = Z(function (a) {
        var b = (a || "").match(L);
        return {media: b && b[1], length: b && b[2]}
    }), v.parseSet = function (a) {
        if (!a.cands) {
            var b, c, d, e, f, g, h = a.srcset;
            for (a.cands = []; h;) h = h.replace(/^\s+/g, ""), b = h.search(/\s/g), d = null, -1 != b ? (c = h.slice(0, b), e = c.charAt(c.length - 1), "," != e && c || (c = c.replace(/,+$/, ""), d = ""), h = h.slice(b + 1), null == d && (f = h.indexOf(","), -1 != f ? (d = h.slice(0, f), h = h.slice(f + 1)) : (d = h, h = ""))) : (c = h, h = ""), c && (d = bb(d)) && (g = {
                url: c.replace(/^,+/, ""),
                set: a
            }, g[d[1]] = d[0], "x" == d[1] && 1 == d[0] && (a.has1x = !0), a.cands.push(g))
        }
        return a.cands
    }, v.getEmValue = function () {
        var a;
        if (!r && (a = b.body)) {
            var c = b.createElement("div"), d = B.style.cssText, e = a.style.cssText;
            c.style.cssText = P, B.style.cssText = Q, a.style.cssText = Q, a.appendChild(c), r = c.offsetWidth, a.removeChild(c), r = parseFloat(r, 10), B.style.cssText = d, a.style.cssText = e
        }
        return r || 16
    }, v.calcListLength = function (a) {
        if (!(a in T) || D.uT) {
            var b, c, e, f, g, h, i = d(a).split(/\s*,\s*/), j = !1;
            for (g = 0, h = i.length; h > g && (b = i[g], c = v.parseSize(b), e = c.length, f = c.media, !e || !v.matchesMedia(f) || (j = v.calcLength(e)) === !1); g++) ;
            T[a] = j ? j : V.width
        }
        return T[a]
    }, v.setRes = function (a) {
        var b;
        if (a) {
            b = v.parseSet(a);
            for (var c = 0, d = b.length; d > c; c++) _(b[c], a.sizes)
        }
        return b
    }, v.setRes.res = _, v.applySetCandidate = function (a, b) {
        if (a.length) {
            var c, d, e, g, j, k, n, r, s, t, w, x, y, z = b[v.ns], A = u, B = o, C = q;
            if (r = z.curSrc || b[J], s = z.curCan || i(b, r, a[0].set), d = v.DPR, y = s && s.res, !n && r && (x = I && !b.complete && s && y - .2 > d, x || s && !(p > y) || (s && d > y && y > l && (m > y && (B *= .8, C += .04 * d), s.res += B * Math.pow(y - C, 2)), t = !z.pic || s && s.set == a[0].set, s && t && s.res >= d && (n = s))), !n) for (y && (s.res = s.res - (s.res - y) / 2), a.sort(h), k = a.length, n = a[k - 1], e = 0; k > e; e++) if (c = a[e], c.res >= d) {
                g = e - 1, n = a[g] && (j = c.res - d) && (x || r != v.makeUrl(c.url)) && f(a[g].res, j, d) ? a[g] : c;
                break
            }
            return y && (s.res = y), n && (w = v.makeUrl(n.url), z.curSrc = w, z.curCan = n, w != r && v.setSrc(b, n), v.setSize(b)), A
        }
    }, v.setSrc = function (a, b) {
        var c;
        a.src = b.url, G && (c = a.style.zoom, a.style.zoom = "0.999", a.style.zoom = c)
    }, v.getSet = function (a) {
        var b, c, d, e = !1, f = a[v.ns].sets;
        for (b = 0; b < f.length && !e; b++) if (c = f[b], c.srcset && v.matchesMedia(c.media) && (d = v.supportsType(c.type))) {
            "pending" == d && (c = d), e = c;
            break
        }
        return e
    }, v.parseSets = function (a, b, d) {
        var e, f, g, h, i = "PICTURE" == b.nodeName.toUpperCase(), l = a[v.ns];
        (l.src === c || d.src) && (l.src = y.call(a, "src"), l.src ? z.call(a, E, l.src) : A.call(a, E)), (l.srcset === c || !v.supSrcset || a.srcset || d.srcset) && (e = y.call(a, "srcset"), l.srcset = e, h = !0), l.sets = [], i && (l.pic = !0, k(b, l.sets)), l.srcset ? (f = {
            srcset: l.srcset,
            sizes: y.call(a, "sizes")
        }, l.sets.push(f), g = (s || l.src) && K.test(l.srcset || ""), g || !l.src || j(l.src, f) || f.has1x || (f.srcset += ", " + l.src, f.cands.push({
            url: l.src,
            x: 1,
            set: f
        }))) : l.src && l.sets.push({
            srcset: l.src,
            sizes: null
        }), l.curCan = null, l.curSrc = c, l.supported = !(i || f && !v.supSrcset || g), h && v.supSrcset && !l.supported && (e ? (z.call(a, F, e), a.srcset = "") : A.call(a, F)), l.supported && !l.srcset && (!l.src && a.src || a.src != v.makeUrl(l.src)) && (null == l.src ? a.removeAttribute("src") : a.src = l.src), l.parsed = !0
    }, v.fillImg = function (a, b) {
        var c, d, e = b.reselect || b.reevaluate;
        if (a[v.ns] || (a[v.ns] = {}), d = a[v.ns], e || d.evaled != u) {
            if (!d.parsed || b.reevaluate) {
                if (c = a.parentNode, !c) return;
                v.parseSets(a, c, b)
            }
            d.supported ? d.evaled = u : g(a)
        }
    }, v.setupRun = function (b) {
        (!X || R || U != a.devicePixelRatio) && (e(), b.elements || b.context || clearTimeout(t))
    }, v.supPicture ? (ab = w, v.fillImg = w) : (b.createElement("picture"), function () {
        var c, d = a.attachEvent ? /d$|^c/ : /d$|^c|^i/, e = function () {
            var a = b.readyState || "";
            h = setTimeout(e, "loading" == a ? 200 : 999), b.body && (c = c || d.test(a), v.fillImgs(), c && clearTimeout(h))
        }, f = function () {
            v.fillImgs()
        }, g = function () {
            clearTimeout(t), R = !0, t = setTimeout(f, 99)
        }, h = setTimeout(e, b.body ? 0 : 20);
        Y(a, "resize", g), Y(b, "readystatechange", e)
    }()), v.respimage = ab, v.fillImgs = ab, v.teardownRun = w, ab._ = v, a.respimage = a.picturefill || ab, !a.picturefill) for (a.respimgCFG = {
        ri: v,
        push: function (a) {
            var b = a.shift();
            "function" == typeof v[b] ? v[b].apply(v, a) : (D[b] = a[0], X && v.fillImgs({reselect: !0}))
        }
    }; O && O.length;) a.respimgCFG.push(O.shift());
    a.picturefill || (a.picturefill = a.respimage, a.picturefillCFG || (a.picturefillCFG = a.respimgCFG))
}(window, document);
// ---------------------------------------------------------------------------
// Shopify generic helper methods
// ---------------------------------------------------------------------------
Shopify.arrayIncludes = function (ary, obj) {
    for (var i = 0; i < ary.length; i++) {
        if (ary[i] == obj) {
            return true;
        }
    }
    return false;
};

Shopify.uniq = function (ary) {
    var result = [];
    for (var i = 0; i < ary.length; i++) {
        if (!Shopify.arrayIncludes(result, ary[i])) {
            result.push(ary[i]);
        }
    }
    return result;
};

// ---------------------------------------------------------------------------
// Image.switchImage
// helps to switch variant images on variant selection
// ---------------------------------------------------------------------------
Shopify.Image = {

    preload: function (images, size) {
        for (var i = 0; i < images.length; i++) {
            var image = images[i];

            this.loadImage(this.getSizedImageUrl(image, size));
        }
    },

    loadImage: function (path) {
        new Image().src = path;
    },

    switchImage: function (image, element, callback) {
        if (!image || !element) {
            return;
        }

        var size = this.imageSize(element.src)
        var imageUrl = this.getSizedImageUrl(image.src, size);

        if (callback) {
            callback(imageUrl, image, element);
        } else {
            element.src = imageUrl;
        }
    },

    imageSize: function (src) {
        var match = src.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);

        if (match != null) {
            return match[1];
        } else {
            return null;
        }
    },

    getSizedImageUrl: function (src, size) {
        if (size == null) {
            return src;
        }

        if (size == 'master') {
            return this.removeProtocol(src);
        }

        var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

        if (match != null) {
            var prefix = src.split(match[0]);
            var suffix = match[0];

            return this.removeProtocol(prefix[0] + "_" + size + suffix);
        } else {
            return null;
        }
    },

    removeProtocol: function (path) {
        return path.replace(/http(s)?:/, "");
    }
};

/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.6.0
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
/* global window, document, define, jQuery, setInterval, clearInterval */
(function (factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports !== 'undefined') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery);
    }

}(function ($) {
    'use strict';
    var Slick = window.Slick || {};

    Slick = (function () {

        var instanceUid = 0;

        function Slick(element, settings) {

            var _ = this, dataSettings;

            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
                nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '50px',
                cssEase: 'ease',
                customPaging: function (slider, i) {
                    return $('<button type="button" data-role="none" role="button" tabindex="0" />').text(i + 1);
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };

            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };

            $.extend(_, _.initials);

            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = 'hidden';
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;

            dataSettings = $(element).data('slick') || {};

            _.options = $.extend({}, _.defaults, settings, dataSettings);

            _.currentSlide = _.options.initialSlide;

            _.originalSettings = _.options;

            if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
            }

            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);

            _.instanceUid = instanceUid++;

            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;


            _.registerBreakpoints();
            _.init(true);

        }

        return Slick;

    }());

    Slick.prototype.activateADA = function () {
        var _ = this;

        _.$slideTrack.find('.slick-active').attr({
            'aria-hidden': 'false'
        }).find('a, input, button, select').attr({
            'tabindex': '0'
        });

    };

    Slick.prototype.addSlide = Slick.prototype.slickAdd = function (markup, index, addBefore) {

        var _ = this;

        if (typeof (index) === 'boolean') {
            addBefore = index;
            index = null;
        } else if (index < 0 || (index >= _.slideCount)) {
            return false;
        }

        _.unload();

        if (typeof (index) === 'number') {
            if (index === 0 && _.$slides.length === 0) {
                $(markup).appendTo(_.$slideTrack);
            } else if (addBefore) {
                $(markup).insertBefore(_.$slides.eq(index));
            } else {
                $(markup).insertAfter(_.$slides.eq(index));
            }
        } else {
            if (addBefore === true) {
                $(markup).prependTo(_.$slideTrack);
            } else {
                $(markup).appendTo(_.$slideTrack);
            }
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slides.each(function (index, element) {
            $(element).attr('data-slick-index', index);
        });

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.animateHeight = function () {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };

    Slick.prototype.animateSlide = function (targetLeft, callback) {

        var animProps = {},
            _ = this;

        _.animateHeight();

        if (_.options.rtl === true && _.options.vertical === false) {
            targetLeft = -targetLeft;
        }
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) {
                _.$slideTrack.animate({
                    left: targetLeft
                }, _.options.speed, _.options.easing, callback);
            } else {
                _.$slideTrack.animate({
                    top: targetLeft
                }, _.options.speed, _.options.easing, callback);
            }

        } else {

            if (_.cssTransitions === false) {
                if (_.options.rtl === true) {
                    _.currentLeft = -(_.currentLeft);
                }
                $({
                    animStart: _.currentLeft
                }).animate({
                    animStart: targetLeft
                }, {
                    duration: _.options.speed,
                    easing: _.options.easing,
                    step: function (now) {
                        now = Math.ceil(now);
                        if (_.options.vertical === false) {
                            animProps[_.animType] = 'translate(' +
                                now + 'px, 0px)';
                            _.$slideTrack.css(animProps);
                        } else {
                            animProps[_.animType] = 'translate(0px,' +
                                now + 'px)';
                            _.$slideTrack.css(animProps);
                        }
                    },
                    complete: function () {
                        if (callback) {
                            callback.call();
                        }
                    }
                });

            } else {

                _.applyTransition();
                targetLeft = Math.ceil(targetLeft);

                if (_.options.vertical === false) {
                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
                } else {
                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
                }
                _.$slideTrack.css(animProps);

                if (callback) {
                    setTimeout(function () {

                        _.disableTransition();

                        callback.call();
                    }, _.options.speed);
                }

            }

        }

    };

    Slick.prototype.getNavTarget = function () {

        var _ = this,
            asNavFor = _.options.asNavFor;

        if (asNavFor && asNavFor !== null) {
            asNavFor = $(asNavFor).not(_.$slider);
        }

        return asNavFor;

    };

    Slick.prototype.asNavFor = function (index) {

        var _ = this,
            asNavFor = _.getNavTarget();

        if (asNavFor !== null && typeof asNavFor === 'object') {
            asNavFor.each(function () {
                var target = $(this).slick('getSlick');
                if (!target.unslicked) {
                    target.slideHandler(index, true);
                }
            });
        }

    };

    Slick.prototype.applyTransition = function (slide) {

        var _ = this,
            transition = {};

        if (_.options.fade === false) {
            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
        } else {
            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
        }

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.autoPlay = function () {

        var _ = this;

        _.autoPlayClear();

        if (_.slideCount > _.options.slidesToShow) {
            _.autoPlayTimer = setInterval(_.autoPlayIterator, _.options.autoplaySpeed);
        }

    };

    Slick.prototype.autoPlayClear = function () {

        var _ = this;

        if (_.autoPlayTimer) {
            clearInterval(_.autoPlayTimer);
        }

    };

    Slick.prototype.autoPlayIterator = function () {

        var _ = this,
            slideTo = _.currentSlide + _.options.slidesToScroll;

        if (!_.paused && !_.interrupted && !_.focussed) {

            if (_.options.infinite === false) {

                if (_.direction === 1 && (_.currentSlide + 1) === (_.slideCount - 1)) {
                    _.direction = 0;
                } else if (_.direction === 0) {

                    slideTo = _.currentSlide - _.options.slidesToScroll;

                    if (_.currentSlide - 1 === 0) {
                        _.direction = 1;
                    }

                }

            }

            _.slideHandler(slideTo);

        }

    };

    Slick.prototype.buildArrows = function () {

        var _ = this;

        if (_.options.arrows === true) {

            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

            if (_.slideCount > _.options.slidesToShow) {

                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

                if (_.htmlExpr.test(_.options.prevArrow)) {
                    _.$prevArrow.prependTo(_.options.appendArrows);
                }

                if (_.htmlExpr.test(_.options.nextArrow)) {
                    _.$nextArrow.appendTo(_.options.appendArrows);
                }

                if (_.options.infinite !== true) {
                    _.$prevArrow
                        .addClass('slick-disabled')
                        .attr('aria-disabled', 'true');
                }

            } else {

                _.$prevArrow.add(_.$nextArrow)

                    .addClass('slick-hidden')
                    .attr({
                        'aria-disabled': 'true',
                        'tabindex': '-1'
                    });

            }

        }

    };

    Slick.prototype.buildDots = function () {

        var _ = this,
            i, dot;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$slider.addClass('slick-dotted');

            dot = $('<ul />').addClass(_.options.dotsClass);

            for (i = 0; i <= _.getDotCount(); i += 1) {
                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
            }

            _.$dots = dot.appendTo(_.options.appendDots);

            _.$dots.find('li').first().addClass('slick-active').attr('aria-hidden', 'false');

        }

    };

    Slick.prototype.buildOut = function () {

        var _ = this;

        _.$slides =
            _.$slider
                .children(_.options.slide + ':not(.slick-cloned)')
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        _.$slides.each(function (index, element) {
            $(element)
                .attr('data-slick-index', index)
                .data('originalStyling', $(element).attr('style') || '');
        });

        _.$slider.addClass('slick-slider');

        _.$slideTrack = (_.slideCount === 0) ?
            $('<div class="slick-track"/>').appendTo(_.$slider) :
            _.$slides.wrapAll('<div class="slick-track"/>').parent();

        _.$list = _.$slideTrack.wrap(
            '<div aria-live="polite" class="slick-list"/>').parent();
        _.$slideTrack.css('opacity', 0);

        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
            _.options.slidesToScroll = 1;
        }

        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

        _.setupInfinite();

        _.buildArrows();

        _.buildDots();

        _.updateDots();


        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        if (_.options.draggable === true) {
            _.$list.addClass('draggable');
        }

    };

    Slick.prototype.buildRows = function () {

        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides, slidesPerSection;

        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();

        if (_.options.rows > 1) {

            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(
                originalSlides.length / slidesPerSection
            );

            for (a = 0; a < numOfSlides; a++) {
                var slide = document.createElement('div');
                for (b = 0; b < _.options.rows; b++) {
                    var row = document.createElement('div');
                    for (c = 0; c < _.options.slidesPerRow; c++) {
                        var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
                        if (originalSlides.get(target)) {
                            row.appendChild(originalSlides.get(target));
                        }
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }

            _.$slider.empty().append(newSlides);
            _.$slider.children().children().children()
                .css({
                    'width': (100 / _.options.slidesPerRow) + '%',
                    'display': 'inline-block'
                });

        }

    };

    Slick.prototype.checkResponsive = function (initial, forceUpdate) {

        var _ = this,
            breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();

        if (_.respondTo === 'window') {
            respondToWidth = windowWidth;
        } else if (_.respondTo === 'slider') {
            respondToWidth = sliderWidth;
        } else if (_.respondTo === 'min') {
            respondToWidth = Math.min(windowWidth, sliderWidth);
        }

        if (_.options.responsive &&
            _.options.responsive.length &&
            _.options.responsive !== null) {

            targetBreakpoint = null;

            for (breakpoint in _.breakpoints) {
                if (_.breakpoints.hasOwnProperty(breakpoint)) {
                    if (_.originalSettings.mobileFirst === false) {
                        if (respondToWidth < _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    } else {
                        if (respondToWidth > _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    }
                }
            }

            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint =
                            targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                            _.unslick(targetBreakpoint);
                        } else {
                            _.options = $.extend({}, _.originalSettings,
                                _.breakpointSettings[
                                    targetBreakpoint]);
                            if (initial === true) {
                                _.currentSlide = _.options.initialSlide;
                            }
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                        _.unslick(targetBreakpoint);
                    } else {
                        _.options = $.extend({}, _.originalSettings,
                            _.breakpointSettings[
                                targetBreakpoint]);
                        if (initial === true) {
                            _.currentSlide = _.options.initialSlide;
                        }
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else {
                if (_.activeBreakpoint !== null) {
                    _.activeBreakpoint = null;
                    _.options = _.originalSettings;
                    if (initial === true) {
                        _.currentSlide = _.options.initialSlide;
                    }
                    _.refresh(initial);
                    triggerBreakpoint = targetBreakpoint;
                }
            }

            // only trigger breakpoints during an actual break. not on initialize.
            if (!initial && triggerBreakpoint !== false) {
                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
            }
        }

    };

    Slick.prototype.changeSlide = function (event, dontAnimate) {

        var _ = this,
            $target = $(event.currentTarget),
            indexOffset, slideOffset, unevenOffset;

        // If target is a link, prevent default action.
        if ($target.is('a')) {
            event.preventDefault();
        }

        // If target is not the <li> element (ie: a child), find the <li>.
        if (!$target.is('li')) {
            $target = $target.closest('li');
        }

        unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

        switch (event.data.message) {

            case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                }
                break;

            case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                }
                break;

            case 'index':
                var index = event.data.index === 0 ? 0 :
                    event.data.index || $target.index() * _.options.slidesToScroll;

                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;

            default:
                return;
        }

    };

    Slick.prototype.checkNavigable = function (index) {

        var _ = this,
            navigables, prevNavigable;

        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) {
            index = navigables[navigables.length - 1];
        } else {
            for (var n in navigables) {
                if (index < navigables[n]) {
                    index = prevNavigable;
                    break;
                }
                prevNavigable = navigables[n];
            }
        }

        return index;
    };

    Slick.prototype.cleanUpEvents = function () {

        var _ = this;

        if (_.options.dots && _.$dots !== null) {

            $('li', _.$dots)
                .off('click.slick', _.changeSlide)
                .off('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .off('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

        _.$slider.off('focus.slick blur.slick');

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
        }

        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

        _.$list.off('click.slick', _.clickHandler);

        $(document).off(_.visibilityChange, _.visibility);

        _.cleanUpSlideEvents();

        if (_.options.accessibility === true) {
            _.$list.off('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
        }

        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(document).off('ready.slick.slick-' + _.instanceUid, _.setPosition);

    };

    Slick.prototype.cleanUpSlideEvents = function () {

        var _ = this;

        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));

    };

    Slick.prototype.cleanUpRows = function () {

        var _ = this, originalSlides;

        if (_.options.rows > 1) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.empty().append(originalSlides);
        }

    };

    Slick.prototype.clickHandler = function (event) {

        var _ = this;

        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }

    };

    Slick.prototype.destroy = function (refresh) {

        var _ = this;

        _.autoPlayClear();

        _.touchObject = {};

        _.cleanUpEvents();

        $('.slick-cloned', _.$slider).detach();

        if (_.$dots) {
            _.$dots.remove();
        }

        if (_.$prevArrow && _.$prevArrow.length) {

            _.$prevArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display', '');

            if (_.htmlExpr.test(_.options.prevArrow)) {
                _.$prevArrow.remove();
            }
        }

        if (_.$nextArrow && _.$nextArrow.length) {

            _.$nextArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display', '');

            if (_.htmlExpr.test(_.options.nextArrow)) {
                _.$nextArrow.remove();
            }
        }


        if (_.$slides) {

            _.$slides
                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
                .removeAttr('aria-hidden')
                .removeAttr('data-slick-index')
                .each(function () {
                    $(this).attr('style', $(this).data('originalStyling'));
                });

            _.$slideTrack.children(this.options.slide).detach();

            _.$slideTrack.detach();

            _.$list.detach();

            _.$slider.append(_.$slides);
        }

        _.cleanUpRows();

        _.$slider.removeClass('slick-slider');
        _.$slider.removeClass('slick-initialized');
        _.$slider.removeClass('slick-dotted');

        _.unslicked = true;

        if (!refresh) {
            _.$slider.trigger('destroy', [_]);
        }

    };

    Slick.prototype.disableTransition = function (slide) {

        var _ = this,
            transition = {};

        transition[_.transitionType] = '';

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.fadeSlide = function (slideIndex, callback) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });

            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });

            if (callback) {
                setTimeout(function () {

                    _.disableTransition(slideIndex);

                    callback.call();
                }, _.options.speed);
            }

        }

    };

    Slick.prototype.fadeSlideOut = function (slideIndex) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).animate({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            }, _.options.speed, _.options.easing);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });

        }

    };

    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function (filter) {

        var _ = this;

        if (filter !== null) {

            _.$slidesCache = _.$slides;

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.focusHandler = function () {

        var _ = this;

        _.$slider
            .off('focus.slick blur.slick')
            .on('focus.slick blur.slick',
                '*:not(.slick-arrow)', function (event) {

                    event.stopImmediatePropagation();
                    var $sf = $(this);

                    setTimeout(function () {

                        if (_.options.pauseOnFocus) {
                            _.focussed = $sf.is(':focus');
                            _.autoPlay();
                        }

                    }, 0);

                });
    };

    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function () {

        var _ = this;
        return _.currentSlide;

    };

    Slick.prototype.getDotCount = function () {

        var _ = this;

        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;

        if (_.options.infinite === true) {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        } else if (_.options.centerMode === true) {
            pagerQty = _.slideCount;
        } else if (!_.options.asNavFor) {
            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        } else {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        }

        return pagerQty - 1;

    };

    Slick.prototype.getLeft = function (slideIndex) {

        var _ = this,
            targetLeft,
            verticalHeight,
            verticalOffset = 0,
            targetSlide;

        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);

        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
                verticalOffset = (verticalHeight * _.options.slidesToShow) * -1;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
                        verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
                    } else {
                        _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
                        verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
                    }
                }
            }
        } else {
            if (slideIndex + _.options.slidesToShow > _.slideCount) {
                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
            }
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }

        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
            _.slideOffset = ((_.slideWidth * Math.floor(_.options.slidesToShow)) / 2) - ((_.slideWidth * _.slideCount) / 2);
        } else if (_.options.centerMode === true && _.options.infinite === true) {
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        } else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }

        if (_.options.vertical === false) {
            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
        } else {
            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
        }

        if (_.options.variableWidth === true) {

            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            } else {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            }

            if (_.options.rtl === true) {
                if (targetSlide[0]) {
                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                } else {
                    targetLeft = 0;
                }
            } else {
                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            }

            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                } else {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                }

                if (_.options.rtl === true) {
                    if (targetSlide[0]) {
                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    } else {
                        targetLeft = 0;
                    }
                } else {
                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                }

                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }

        return targetLeft;

    };

    Slick.prototype.getOption = Slick.prototype.slickGetOption = function (option) {

        var _ = this;

        return _.options[option];

    };

    Slick.prototype.getNavigableIndexes = function () {

        var _ = this,
            breakPoint = 0,
            counter = 0,
            indexes = [],
            max;

        if (_.options.infinite === false) {
            max = _.slideCount;
        } else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }

        while (breakPoint < max) {
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }

        return indexes;

    };

    Slick.prototype.getSlick = function () {

        return this;

    };

    Slick.prototype.getSlideCount = function () {

        var _ = this,
            slidesTraversed, swipedSlide, centerOffset;

        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;

        if (_.options.swipeToSlide === true) {
            _.$slideTrack.find('.slick-slide').each(function (index, slide) {
                if (slide.offsetLeft - centerOffset + ($(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {
                    swipedSlide = slide;
                    return false;
                }
            });

            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

            return slidesTraversed;

        } else {
            return _.options.slidesToScroll;
        }

    };

    Slick.prototype.goTo = Slick.prototype.slickGoTo = function (slide, dontAnimate) {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'index',
                index: parseInt(slide)
            }
        }, dontAnimate);

    };

    Slick.prototype.init = function (creation) {

        var _ = this;

        if (!$(_.$slider).hasClass('slick-initialized')) {

            $(_.$slider).addClass('slick-initialized');

            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();

        }

        if (creation) {
            _.$slider.trigger('init', [_]);
        }

        if (_.options.accessibility === true) {
            _.initADA();
        }

        if (_.options.autoplay) {

            _.paused = false;
            _.autoPlay();

        }

    };

    Slick.prototype.initADA = function () {
        var _ = this;
        if (_.$slides == null) {
            setTimeout(Slick.prototype.initADA, 100);
            return;
        }
        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
            'aria-hidden': 'true',
            'tabindex': '-1'
        }).find('a, input, button, select').attr({
            'tabindex': '-1'
        });

        _.$slideTrack.attr('role', 'listbox');

        _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function (i) {
            $(this).attr('role', 'option');

            //Evenly distribute aria-describedby tags through available dots.
            var describedBySlideId = _.options.centerMode ? i : Math.floor(i / _.options.slidesToShow);

            if (_.options.dots === true) {
                $(this).attr('aria-describedby', 'slick-slide' + _.instanceUid + describedBySlideId + '');
            }
        });

        if (_.$dots !== null) {
            _.$dots.attr('role', 'tablist').find('li').each(function (i) {
                $(this).attr({
                    'role': 'presentation',
                    'aria-selected': 'false',
                    'aria-controls': 'navigation' + _.instanceUid + i + '',
                    'id': 'slick-slide' + _.instanceUid + i + ''
                });
            })
                .first().attr('aria-selected', 'true').end()
                .find('button').attr('role', 'button').end()
                .closest('div').attr('role', 'toolbar');
        }
        _.activateADA();

    };

    Slick.prototype.initArrowEvents = function () {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow
                .off('click.slick')
                .on('click.slick', {
                    message: 'previous'
                }, _.changeSlide);
            _.$nextArrow
                .off('click.slick')
                .on('click.slick', {
                    message: 'next'
                }, _.changeSlide);
        }

    };

    Slick.prototype.initDotEvents = function () {

        var _ = this;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $('li', _.$dots).on('click.slick', {
                message: 'index'
            }, _.changeSlide);
        }

        if (_.options.dots === true && _.options.pauseOnDotsHover === true) {

            $('li', _.$dots)
                .on('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initSlideEvents = function () {

        var _ = this;

        if (_.options.pauseOnHover) {

            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initializeEvents = function () {

        var _ = this;

        _.initArrowEvents();

        _.initDotEvents();
        _.initSlideEvents();

        _.$list.on('touchstart.slick mousedown.slick', {
            action: 'start'
        }, _.swipeHandler);
        _.$list.on('touchmove.slick mousemove.slick', {
            action: 'move'
        }, _.swipeHandler);
        _.$list.on('touchend.slick mouseup.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('touchcancel.slick mouseleave.slick', {
            action: 'end'
        }, _.swipeHandler);

        _.$list.on('click.slick', _.clickHandler);

        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));

        if (_.options.accessibility === true) {
            _.$list.on('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));

        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));

        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(document).on('ready.slick.slick-' + _.instanceUid, _.setPosition);

    };

    Slick.prototype.initUI = function () {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.show();
            _.$nextArrow.show();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.show();

        }

    };

    Slick.prototype.keyHandler = function (event) {

        var _ = this;
        //Dont slide if the cursor is inside the form fields and arrow keys are pressed
        if (!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
            if (event.keyCode === 37 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'next' : 'previous'
                    }
                });
            } else if (event.keyCode === 39 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'previous' : 'next'
                    }
                });
            }
        }

    };

    Slick.prototype.lazyLoad = function () {

        var _ = this,
            loadRange, cloneRange, rangeStart, rangeEnd;

        function loadImages(imagesScope) {

            $('img[data-lazy]', imagesScope).each(function () {

                var image = $(this),
                    imageSource = $(this).attr('data-lazy'),
                    imageToLoad = document.createElement('img');

                imageToLoad.onload = function () {

                    image
                        .animate({opacity: 0}, 100, function () {
                            image
                                .attr('src', imageSource)
                                .animate({opacity: 1}, 200, function () {
                                    image
                                        .removeAttr('data-lazy')
                                        .removeClass('slick-loading');
                                });
                            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                        });

                };

                imageToLoad.onerror = function () {

                    image
                        .removeAttr('data-lazy')
                        .removeClass('slick-loading')
                        .addClass('slick-lazyload-error');

                    _.$slider.trigger('lazyLoadError', [_, image, imageSource]);

                };

                imageToLoad.src = imageSource;

            });

        }

        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }

        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);

        if (_.options.lazyLoad === 'anticipated') {
            var prevSlide = rangeStart - 1,
                nextSlide = rangeEnd,
                $slides = _.$slider.find('.slick-slide');

            for (var i = 0; i < _.options.slidesToScroll; i++) {
                if (prevSlide < 0) prevSlide = _.slideCount - 1;
                loadRange = loadRange.add($slides.eq(prevSlide));
                loadRange = loadRange.add($slides.eq(nextSlide));
                prevSlide--;
                nextSlide++;
            }
        }

        loadImages(loadRange);

        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
        } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }

    };

    Slick.prototype.loadSlider = function () {

        var _ = this;

        _.setPosition();

        _.$slideTrack.css({
            opacity: 1
        });

        _.$slider.removeClass('slick-loading');

        _.initUI();

        if (_.options.lazyLoad === 'progressive') {
            _.progressiveLazyLoad();
        }

    };

    Slick.prototype.next = Slick.prototype.slickNext = function () {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'next'
            }
        });

    };

    Slick.prototype.orientationChange = function () {

        var _ = this;

        _.checkResponsive();
        _.setPosition();

    };

    Slick.prototype.pause = Slick.prototype.slickPause = function () {

        var _ = this;

        _.autoPlayClear();
        _.paused = true;

    };

    Slick.prototype.play = Slick.prototype.slickPlay = function () {

        var _ = this;

        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;

    };

    Slick.prototype.postSlide = function (index) {

        var _ = this;

        if (!_.unslicked) {

            _.$slider.trigger('afterChange', [_, index]);

            _.animating = false;

            _.setPosition();

            _.swipeLeft = null;

            if (_.options.autoplay) {
                _.autoPlay();
            }

            if (_.options.accessibility === true) {
                _.initADA();
            }

        }

    };

    Slick.prototype.prev = Slick.prototype.slickPrev = function () {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'previous'
            }
        });

    };

    Slick.prototype.preventDefault = function (event) {

        event.preventDefault();

    };

    Slick.prototype.progressiveLazyLoad = function (tryCount) {

        tryCount = tryCount || 1;

        var _ = this,
            $imgsToLoad = $('img[data-lazy]', _.$slider),
            image,
            imageSource,
            imageToLoad;

        if ($imgsToLoad.length) {

            image = $imgsToLoad.first();
            imageSource = image.attr('data-lazy');
            imageToLoad = document.createElement('img');

            imageToLoad.onload = function () {

                image
                    .attr('src', imageSource)
                    .removeAttr('data-lazy')
                    .removeClass('slick-loading');

                if (_.options.adaptiveHeight === true) {
                    _.setPosition();
                }

                _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                _.progressiveLazyLoad();

            };

            imageToLoad.onerror = function () {

                if (tryCount < 3) {

                    /**
                     * try to load the image 3 times,
                     * leave a slight delay so we don't get
                     * servers blocking the request.
                     */
                    setTimeout(function () {
                        _.progressiveLazyLoad(tryCount + 1);
                    }, 500);

                } else {

                    image
                        .removeAttr('data-lazy')
                        .removeClass('slick-loading')
                        .addClass('slick-lazyload-error');

                    _.$slider.trigger('lazyLoadError', [_, image, imageSource]);

                    _.progressiveLazyLoad();

                }

            };

            imageToLoad.src = imageSource;

        } else {

            _.$slider.trigger('allImagesLoaded', [_]);

        }

    };

    Slick.prototype.refresh = function (initializing) {

        var _ = this, currentSlide, lastVisibleIndex;

        lastVisibleIndex = _.slideCount - _.options.slidesToShow;

        // in non-infinite sliders, we don't want to go past the
        // last visible index.
        if (!_.options.infinite && (_.currentSlide > lastVisibleIndex)) {
            _.currentSlide = lastVisibleIndex;
        }

        // if less slides than to show, go to start.
        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;

        }

        currentSlide = _.currentSlide;

        _.destroy(true);

        $.extend(_, _.initials, {currentSlide: currentSlide});

        _.init();

        if (!initializing) {

            _.changeSlide({
                data: {
                    message: 'index',
                    index: currentSlide
                }
            }, false);

        }

    };

    Slick.prototype.registerBreakpoints = function () {

        var _ = this, breakpoint, currentBreakpoint, l,
            responsiveSettings = _.options.responsive || null;

        if ($.type(responsiveSettings) === 'array' && responsiveSettings.length) {

            _.respondTo = _.options.respondTo || 'window';

            for (breakpoint in responsiveSettings) {

                l = _.breakpoints.length - 1;
                currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

                if (responsiveSettings.hasOwnProperty(breakpoint)) {

                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while (l >= 0) {
                        if (_.breakpoints[l] && _.breakpoints[l] === currentBreakpoint) {
                            _.breakpoints.splice(l, 1);
                        }
                        l--;
                    }

                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;

                }

            }

            _.breakpoints.sort(function (a, b) {
                return (_.options.mobileFirst) ? a - b : b - a;
            });

        }

    };

    Slick.prototype.reinit = function () {

        var _ = this;

        _.$slides =
            _.$slideTrack
                .children(_.options.slide)
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }

        _.registerBreakpoints();

        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();

        _.checkResponsive(false, true);

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        _.setPosition();
        _.focusHandler();

        _.paused = !_.options.autoplay;
        _.autoPlay();

        _.$slider.trigger('reInit', [_]);

    };

    Slick.prototype.resize = function () {

        var _ = this;

        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function () {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if (!_.unslicked) {
                    _.setPosition();
                }
            }, 50);
        }
    };

    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function (index, removeBefore, removeAll) {

        var _ = this;

        if (typeof (index) === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else {
            index = removeBefore === true ? --index : index;
        }

        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
            return false;
        }

        _.unload();

        if (removeAll === true) {
            _.$slideTrack.children().remove();
        } else {
            _.$slideTrack.children(this.options.slide).eq(index).remove();
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.setCSS = function (position) {

        var _ = this,
            positionProps = {},
            x, y;

        if (_.options.rtl === true) {
            position = -position;
        }
        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

        positionProps[_.positionProp] = position;

        if (_.transformsEnabled === false) {
            _.$slideTrack.css(positionProps);
        } else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
            }
        }

    };

    Slick.prototype.setDimensions = function () {

        var _ = this;

        if (_.options.vertical === false) {
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: ('0px ' + _.options.centerPadding)
                });
            }
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: (_.options.centerPadding + ' 0px')
                });
            }
        }

        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();


        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));

        } else if (_.options.variableWidth === true) {
            _.$slideTrack.width(5000 * _.slideCount);
        } else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
        }

        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);

    };

    Slick.prototype.setFade = function () {

        var _ = this,
            targetLeft;

        _.$slides.each(function (index, element) {
            targetLeft = (_.slideWidth * index) * -1;
            if (_.options.rtl === true) {
                $(element).css({
                    position: 'relative',
                    right: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            } else {
                $(element).css({
                    position: 'relative',
                    left: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            }
        });

        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });

    };

    Slick.prototype.setHeight = function () {

        var _ = this;

        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
        }

    };

    Slick.prototype.setOption =
        Slick.prototype.slickSetOption = function () {

            /**
             * accepts arguments in format of:
             *
             *  - for changing a single option's value:
             *     .slick("setOption", option, value, refresh )
             *
             *  - for changing a set of responsive options:
             *     .slick("setOption", 'responsive', [{}, ...], refresh )
             *
             *  - for updating multiple values at once (not responsive)
             *     .slick("setOption", { 'option': value, ... }, refresh )
             */

            var _ = this, l, item, option, value, refresh = false, type;

            if ($.type(arguments[0]) === 'object') {

                option = arguments[0];
                refresh = arguments[1];
                type = 'multiple';

            } else if ($.type(arguments[0]) === 'string') {

                option = arguments[0];
                value = arguments[1];
                refresh = arguments[2];

                if (arguments[0] === 'responsive' && $.type(arguments[1]) === 'array') {

                    type = 'responsive';

                } else if (typeof arguments[1] !== 'undefined') {

                    type = 'single';

                }

            }

            if (type === 'single') {

                _.options[option] = value;


            } else if (type === 'multiple') {

                $.each(option, function (opt, val) {

                    _.options[opt] = val;

                });


            } else if (type === 'responsive') {

                for (item in value) {

                    if ($.type(_.options.responsive) !== 'array') {

                        _.options.responsive = [value[item]];

                    } else {

                        l = _.options.responsive.length - 1;

                        // loop through the responsive object and splice out duplicates.
                        while (l >= 0) {

                            if (_.options.responsive[l].breakpoint === value[item].breakpoint) {

                                _.options.responsive.splice(l, 1);

                            }

                            l--;

                        }

                        _.options.responsive.push(value[item]);

                    }

                }

            }

            if (refresh) {

                _.unload();
                _.reinit();

            }

        };

    Slick.prototype.setPosition = function () {

        var _ = this;

        _.setDimensions();

        _.setHeight();

        if (_.options.fade === false) {
            _.setCSS(_.getLeft(_.currentSlide));
        } else {
            _.setFade();
        }

        _.$slider.trigger('setPosition', [_]);

    };

    Slick.prototype.setProps = function () {

        var _ = this,
            bodyStyle = document.body.style;

        _.positionProp = _.options.vertical === true ? 'top' : 'left';

        if (_.positionProp === 'top') {
            _.$slider.addClass('slick-vertical');
        } else {
            _.$slider.removeClass('slick-vertical');
        }

        if (bodyStyle.WebkitTransition !== undefined ||
            bodyStyle.MozTransition !== undefined ||
            bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) {
                _.cssTransitions = true;
            }
        }

        if (_.options.fade) {
            if (typeof _.options.zIndex === 'number') {
                if (_.options.zIndex < 3) {
                    _.options.zIndex = 3;
                }
            } else {
                _.options.zIndex = _.defaults.zIndex;
            }
        }

        if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
        }
        _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
    };


    Slick.prototype.setSlideClasses = function (index) {

        var _ = this,
            centerOffset, allSlides, indexOffset, remainder;

        allSlides = _.$slider
            .find('.slick-slide')
            .removeClass('slick-active slick-center slick-current')
            .attr('aria-hidden', 'true');

        _.$slides
            .eq(index)
            .addClass('slick-current');

        if (_.options.centerMode === true) {

            centerOffset = Math.floor(_.options.slidesToShow / 2);

            if (_.options.infinite === true) {

                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {

                    _.$slides
                        .slice(index - centerOffset, index + centerOffset + 1)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    indexOffset = _.options.slidesToShow + index;
                    allSlides
                        .slice(indexOffset - centerOffset + 1, indexOffset + centerOffset + 2)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

                if (index === 0) {

                    allSlides
                        .eq(allSlides.length - 1 - _.options.slidesToShow)
                        .addClass('slick-center');

                } else if (index === _.slideCount - 1) {

                    allSlides
                        .eq(_.options.slidesToShow)
                        .addClass('slick-center');

                }

            }

            _.$slides
                .eq(index)
                .addClass('slick-center');

        } else {

            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {

                _.$slides
                    .slice(index, index + _.options.slidesToShow)
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else if (allSlides.length <= _.options.slidesToShow) {

                allSlides
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else {

                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {

                    allSlides
                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    allSlides
                        .slice(indexOffset, indexOffset + _.options.slidesToShow)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

            }

        }

        if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
            _.lazyLoad();
        }
    };

    Slick.prototype.setupInfinite = function () {

        var _ = this,
            i, slideIndex, infiniteCount;

        if (_.options.fade === true) {
            _.options.centerMode = false;
        }

        if (_.options.infinite === true && _.options.fade === false) {

            slideIndex = null;

            if (_.slideCount > _.options.slidesToShow) {

                if (_.options.centerMode === true) {
                    infiniteCount = _.options.slidesToShow + 1;
                } else {
                    infiniteCount = _.options.slidesToShow;
                }

                for (i = _.slideCount; i > (_.slideCount -
                    infiniteCount); i -= 1) {
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex - _.slideCount)
                        .prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for (i = 0; i < infiniteCount; i += 1) {
                    slideIndex = i;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex + _.slideCount)
                        .appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function () {
                    $(this).attr('id', '');
                });

            }

        }

    };

    Slick.prototype.interrupt = function (toggle) {

        var _ = this;

        if (!toggle) {
            _.autoPlay();
        }
        _.interrupted = toggle;

    };

    Slick.prototype.selectHandler = function (event) {

        var _ = this;

        var targetElement =
            $(event.target).is('.slick-slide') ?
                $(event.target) :
                $(event.target).parents('.slick-slide');

        var index = parseInt(targetElement.attr('data-slick-index'));

        if (!index) index = 0;

        if (_.slideCount <= _.options.slidesToShow) {

            _.setSlideClasses(index);
            _.asNavFor(index);
            return;

        }

        _.slideHandler(index);

    };

    Slick.prototype.slideHandler = function (index, sync, dontAnimate) {

        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
            _ = this, navTarget;

        sync = sync || false;

        if (_.animating === true && _.options.waitForAnimate === true) {
            return;
        }

        if (_.options.fade === true && _.currentSlide === index) {
            return;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            return;
        }

        if (sync === false) {
            _.asNavFor(index);
        }

        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);

        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true) {
                    _.animateSlide(slideLeft, function () {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true) {
                    _.animateSlide(slideLeft, function () {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        }

        if (_.options.autoplay) {
            clearInterval(_.autoPlayTimer);
        }

        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
            } else {
                animSlide = _.slideCount + targetSlide;
            }
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = 0;
            } else {
                animSlide = targetSlide - _.slideCount;
            }
        } else {
            animSlide = targetSlide;
        }

        _.animating = true;

        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;

        _.setSlideClasses(_.currentSlide);

        if (_.options.asNavFor) {

            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');

            if (navTarget.slideCount <= navTarget.options.slidesToShow) {
                navTarget.setSlideClasses(_.currentSlide);
            }

        }

        _.updateDots();
        _.updateArrows();

        if (_.options.fade === true) {
            if (dontAnimate !== true) {

                _.fadeSlideOut(oldSlide);

                _.fadeSlide(animSlide, function () {
                    _.postSlide(animSlide);
                });

            } else {
                _.postSlide(animSlide);
            }
            _.animateHeight();
            return;
        }

        if (dontAnimate !== true) {
            _.animateSlide(targetLeft, function () {
                _.postSlide(animSlide);
            });
        } else {
            _.postSlide(animSlide);
        }

    };

    Slick.prototype.startLoad = function () {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.hide();
            _.$nextArrow.hide();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.hide();

        }

        _.$slider.addClass('slick-loading');

    };

    Slick.prototype.swipeDirection = function () {

        var xDist, yDist, r, swipeAngle, _ = this;

        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);

        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) {
            swipeAngle = 360 - Math.abs(swipeAngle);
        }

        if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
            return (_.options.rtl === false ? 'right' : 'left');
        }
        if (_.options.verticalSwiping === true) {
            if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
                return 'down';
            } else {
                return 'up';
            }
        }

        return 'vertical';

    };

    Slick.prototype.swipeEnd = function (event) {

        var _ = this,
            slideCount,
            direction;

        _.dragging = false;
        _.interrupted = false;
        _.shouldClick = (_.touchObject.swipeLength > 10) ? false : true;

        if (_.touchObject.curX === undefined) {
            return false;
        }

        if (_.touchObject.edgeHit === true) {
            _.$slider.trigger('edge', [_, _.swipeDirection()]);
        }

        if (_.touchObject.swipeLength >= _.touchObject.minSwipe) {

            direction = _.swipeDirection();

            switch (direction) {

                case 'left':
                case 'down':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable(_.currentSlide + _.getSlideCount()) :
                            _.currentSlide + _.getSlideCount();

                    _.currentDirection = 0;

                    break;

                case 'right':
                case 'up':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable(_.currentSlide - _.getSlideCount()) :
                            _.currentSlide - _.getSlideCount();

                    _.currentDirection = 1;

                    break;

                default:


            }

            if (direction != 'vertical') {

                _.slideHandler(slideCount);
                _.touchObject = {};
                _.$slider.trigger('swipe', [_, direction]);

            }

        } else {

            if (_.touchObject.startX !== _.touchObject.curX) {

                _.slideHandler(_.currentSlide);
                _.touchObject = {};

            }

        }

    };

    Slick.prototype.swipeHandler = function (event) {

        var _ = this;

        if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
            return;
        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
            return;
        }

        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
            event.originalEvent.touches.length : 1;

        _.touchObject.minSwipe = _.listWidth / _.options
            .touchThreshold;

        if (_.options.verticalSwiping === true) {
            _.touchObject.minSwipe = _.listHeight / _.options
                .touchThreshold;
        }

        switch (event.data.action) {

            case 'start':
                _.swipeStart(event);
                break;

            case 'move':
                _.swipeMove(event);
                break;

            case 'end':
                _.swipeEnd(event);
                break;

        }

    };

    Slick.prototype.swipeMove = function (event) {

        var _ = this,
            edgeWasHit = false,
            curLeft, swipeDirection, swipeLength, positionOffset, touches;

        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

        if (!_.dragging || touches && touches.length !== 1) {
            return false;
        }

        curLeft = _.getLeft(_.currentSlide);

        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

        _.touchObject.swipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

        if (_.options.verticalSwiping === true) {
            _.touchObject.swipeLength = Math.round(Math.sqrt(
                Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
        }

        swipeDirection = _.swipeDirection();

        if (swipeDirection === 'vertical') {
            return;
        }

        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            event.preventDefault();
        }

        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) {
            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        }


        swipeLength = _.touchObject.swipeLength;

        _.touchObject.edgeHit = false;

        if (_.options.infinite === false) {
            if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }

        if (_.options.vertical === false) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        } else {
            _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
        }
        if (_.options.verticalSwiping === true) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        }

        if (_.options.fade === true || _.options.touchMove === false) {
            return false;
        }

        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }

        _.setCSS(_.swipeLeft);

    };

    Slick.prototype.swipeStart = function (event) {

        var _ = this,
            touches;

        _.interrupted = true;

        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }

        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
            touches = event.originalEvent.touches[0];
        }

        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

        _.dragging = true;

    };

    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function () {

        var _ = this;

        if (_.$slidesCache !== null) {

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.unload = function () {

        var _ = this;

        $('.slick-cloned', _.$slider).remove();

        if (_.$dots) {
            _.$dots.remove();
        }

        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
            _.$prevArrow.remove();
        }

        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
            _.$nextArrow.remove();
        }

        _.$slides
            .removeClass('slick-slide slick-active slick-visible slick-current')
            .attr('aria-hidden', 'true')
            .css('width', '');

    };

    Slick.prototype.unslick = function (fromBreakpoint) {

        var _ = this;
        _.$slider.trigger('unslick', [_, fromBreakpoint]);
        _.destroy();

    };

    Slick.prototype.updateArrows = function () {

        var _ = this,
            centerOffset;

        centerOffset = Math.floor(_.options.slidesToShow / 2);

        if (_.options.arrows === true &&
            _.slideCount > _.options.slidesToShow &&
            !_.options.infinite) {

            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            if (_.currentSlide === 0) {

                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            }

        }

    };

    Slick.prototype.updateDots = function () {

        var _ = this;

        if (_.$dots !== null) {

            _.$dots
                .find('li')
                .removeClass('slick-active')
                .attr('aria-hidden', 'true');

            _.$dots
                .find('li')
                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
                .addClass('slick-active')
                .attr('aria-hidden', 'false');

        }

    };

    Slick.prototype.visibility = function () {

        var _ = this;

        if (_.options.autoplay) {

            if (document[_.hidden]) {

                _.interrupted = true;

            } else {

                _.interrupted = false;

            }

        }

    };

    $.fn.slick = function () {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i].slick = new Slick(_[i], opt);
            else
                ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    };

}));

(function e(t, n, r) {
    function s(o, u) {
        if (!n[o]) {
            if (!t[o]) {
                var a = typeof require == "function" && require;
                if (!u && a) return a(o, !0);
                if (i) return i(o, !0);
                var f = new Error("Cannot find module '" + o + "'");
                throw f.code = "MODULE_NOT_FOUND", f
            }
            var l = n[o] = {exports: {}};
            t[o][0].call(l.exports, function (e) {
                var n = t[o][1][e];
                return s(n ? n : e)
            }, l, l.exports, e, t, n, r)
        }
        return n[o].exports
    }

    var i = typeof require == "function" && require;
    for (var o = 0; o < r.length; o++) s(r[o]);
    return s
})({
    1: [function (require, module, exports) {
        (function (global, factory) {
            typeof exports === 'object' && typeof module !== 'undefined' ? factory() :
                typeof define === 'function' && define.amd ? define(factory) :
                    (factory());
        }(this, (function () {
            'use strict';

            /**
             * https://github.com/WICG/focus-visible
             */
            function init() {
                var hadKeyboardEvent = true;
                var hadFocusVisibleRecently = false;
                var hadFocusVisibleRecentlyTimeout = null;

                var inputTypesWhitelist = {
                    text: true,
                    search: true,
                    url: true,
                    tel: true,
                    email: true,
                    password: true,
                    number: true,
                    date: true,
                    month: true,
                    week: true,
                    time: true,
                    datetime: true,
                    'datetime-local': true
                };

                /**
                 * Helper function for legacy browsers and iframes which sometimes focus
                 * elements like document, body, and non-interactive SVG.
                 * @param {Element} el
                 */
                function isValidFocusTarget(el) {
                    if (
                        el &&
                        el !== document &&
                        el.nodeName !== 'HTML' &&
                        el.nodeName !== 'BODY' &&
                        'classList' in el &&
                        'contains' in el.classList
                    ) {
                        return true;
                    }
                    return false;
                }

                /**
                 * Computes whether the given element should automatically trigger the
                 * `focus-visible` class being added, i.e. whether it should always match
                 * `:focus-visible` when focused.
                 * @param {Element} el
                 * @return {boolean}
                 */
                function focusTriggersKeyboardModality(el) {
                    var type = el.type;
                    var tagName = el.tagName;

                    if (tagName == 'INPUT' && inputTypesWhitelist[type] && !el.readOnly) {
                        return true;
                    }

                    if (tagName == 'TEXTAREA' && !el.readOnly) {
                        return true;
                    }

                    if (el.isContentEditable) {
                        return true;
                    }

                    return false;
                }

                /**
                 * Add the `focus-visible` class to the given element if it was not added by
                 * the author.
                 * @param {Element} el
                 */
                function addFocusVisibleClass(el) {
                    if (el.classList.contains('focus-visible')) {
                        return;
                    }
                    el.classList.add('focus-visible');
                    el.setAttribute('data-focus-visible-added', '');
                }

                /**
                 * Remove the `focus-visible` class from the given element if it was not
                 * originally added by the author.
                 * @param {Element} el
                 */
                function removeFocusVisibleClass(el) {
                    if (!el.hasAttribute('data-focus-visible-added')) {
                        return;
                    }
                    el.classList.remove('focus-visible');
                    el.removeAttribute('data-focus-visible-added');
                }

                /**
                 * Treat `keydown` as a signal that the user is in keyboard modality.
                 * Apply `focus-visible` to any current active element and keep track
                 * of our keyboard modality state with `hadKeyboardEvent`.
                 * @param {Event} e
                 */
                function onKeyDown(e) {
                    if (isValidFocusTarget(document.activeElement)) {
                        addFocusVisibleClass(document.activeElement);
                    }

                    hadKeyboardEvent = true;
                }

                /**
                 * If at any point a user clicks with a pointing device, ensure that we change
                 * the modality away from keyboard.
                 * This avoids the situation where a user presses a key on an already focused
                 * element, and then clicks on a different element, focusing it with a
                 * pointing device, while we still think we're in keyboard modality.
                 * @param {Event} e
                 */
                function onPointerDown(e) {
                    hadKeyboardEvent = false;
                }

                /**
                 * On `focus`, add the `focus-visible` class to the target if:
                 * - the target received focus as a result of keyboard navigation, or
                 * - the event target is an element that will likely require interaction
                 *   via the keyboard (e.g. a text box)
                 * @param {Event} e
                 */
                function onFocus(e) {
                    // Prevent IE from focusing the document or HTML element.
                    if (!isValidFocusTarget(e.target)) {
                        return;
                    }

                    if (hadKeyboardEvent || focusTriggersKeyboardModality(e.target)) {
                        addFocusVisibleClass(e.target);
                    }
                }

                /**
                 * On `blur`, remove the `focus-visible` class from the target.
                 * @param {Event} e
                 */
                function onBlur(e) {
                    if (!isValidFocusTarget(e.target)) {
                        return;
                    }

                    if (
                        e.target.classList.contains('focus-visible') ||
                        e.target.hasAttribute('data-focus-visible-added')
                    ) {
                        // To detect a tab/window switch, we look for a blur event followed
                        // rapidly by a visibility change.
                        // If we don't see a visibility change within 100ms, it's probably a
                        // regular focus change.
                        hadFocusVisibleRecently = true;
                        window.clearTimeout(hadFocusVisibleRecentlyTimeout);
                        hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
                            hadFocusVisibleRecently = false;
                            window.clearTimeout(hadFocusVisibleRecentlyTimeout);
                        }, 100);
                        removeFocusVisibleClass(e.target);
                    }
                }

                /**
                 * If the user changes tabs, keep track of whether or not the previously
                 * focused element had .focus-visible.
                 * @param {Event} e
                 */
                function onVisibilityChange(e) {
                    if (document.visibilityState == 'hidden') {
                        // If the tab becomes active again, the browser will handle calling focus
                        // on the element (Safari actually calls it twice).
                        // If this tab change caused a blur on an element with focus-visible,
                        // re-apply the class when the user switches back to the tab.
                        if (hadFocusVisibleRecently) {
                            hadKeyboardEvent = true;
                        }
                        addInitialPointerMoveListeners();
                    }
                }

                /**
                 * Add a group of listeners to detect usage of any pointing devices.
                 * These listeners will be added when the polyfill first loads, and anytime
                 * the window is blurred, so that they are active when the window regains
                 * focus.
                 */
                function addInitialPointerMoveListeners() {
                    document.addEventListener('mousemove', onInitialPointerMove);
                    document.addEventListener('mousedown', onInitialPointerMove);
                    document.addEventListener('mouseup', onInitialPointerMove);
                    document.addEventListener('pointermove', onInitialPointerMove);
                    document.addEventListener('pointerdown', onInitialPointerMove);
                    document.addEventListener('pointerup', onInitialPointerMove);
                    document.addEventListener('touchmove', onInitialPointerMove);
                    document.addEventListener('touchstart', onInitialPointerMove);
                    document.addEventListener('touchend', onInitialPointerMove);
                }

                function removeInitialPointerMoveListeners() {
                    document.removeEventListener('mousemove', onInitialPointerMove);
                    document.removeEventListener('mousedown', onInitialPointerMove);
                    document.removeEventListener('mouseup', onInitialPointerMove);
                    document.removeEventListener('pointermove', onInitialPointerMove);
                    document.removeEventListener('pointerdown', onInitialPointerMove);
                    document.removeEventListener('pointerup', onInitialPointerMove);
                    document.removeEventListener('touchmove', onInitialPointerMove);
                    document.removeEventListener('touchstart', onInitialPointerMove);
                    document.removeEventListener('touchend', onInitialPointerMove);
                }

                /**
                 * When the polfyill first loads, assume the user is in keyboard modality.
                 * If any event is received from a pointing device (e.g. mouse, pointer,
                 * touch), turn off keyboard modality.
                 * This accounts for situations where focus enters the page from the URL bar.
                 * @param {Event} e
                 */
                function onInitialPointerMove(e) {
                    // Work around a Safari quirk that fires a mousemove on <html> whenever the
                    // window blurs, even if you're tabbing out of the page. ¯\_(ツ)_/¯
                    if (e.target.nodeName.toLowerCase() === 'html') {
                        return;
                    }

                    hadKeyboardEvent = false;
                    removeInitialPointerMoveListeners();
                }

                document.addEventListener('keydown', onKeyDown, true);
                document.addEventListener('mousedown', onPointerDown, true);
                document.addEventListener('pointerdown', onPointerDown, true);
                document.addEventListener('touchstart', onPointerDown, true);
                document.addEventListener('focus', onFocus, true);
                document.addEventListener('blur', onBlur, true);
                document.addEventListener('visibilitychange', onVisibilityChange, true);
                addInitialPointerMoveListeners();

                document.body.classList.add('js-focus-visible');
            }

            /**
             * Subscription when the DOM is ready
             * @param {Function} callback
             */
            function onDOMReady(callback) {
                var loaded;

                /**
                 * Callback wrapper for check loaded state
                 */
                function load() {
                    if (!loaded) {
                        loaded = true;

                        callback();
                    }
                }

                if (['interactive', 'complete'].indexOf(document.readyState) >= 0) {
                    callback();
                } else {
                    loaded = false;
                    document.addEventListener('DOMContentLoaded', load, false);
                    window.addEventListener('load', load, false);
                }
            }

            if (typeof document !== 'undefined') {
                onDOMReady(init);
            }

        })));

    }, {}],
    2: [function (require, module, exports) {
        /*!
  * $script.js JS loader & dependency manager
  * https://github.com/ded/script.js
  * (c) Dustin Diaz 2014 | License MIT
  */

        (function (name, definition) {
            if (typeof module != 'undefined' && module.exports) module.exports = definition()
            else if (typeof define == 'function' && define.amd) define(definition)
            else this[name] = definition()
        })('$script', function () {
            var doc = document
                , head = doc.getElementsByTagName('head')[0]
                , s = 'string'
                , f = false
                , push = 'push'
                , readyState = 'readyState'
                , onreadystatechange = 'onreadystatechange'
                , list = {}
                , ids = {}
                , delay = {}
                , scripts = {}
                , scriptpath
                , urlArgs

            function every(ar, fn) {
                for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
                return 1
            }

            function each(ar, fn) {
                every(ar, function (el) {
                    return !fn(el)
                })
            }

            function $script(paths, idOrDone, optDone) {
                paths = paths[push] ? paths : [paths]
                var idOrDoneIsDone = idOrDone && idOrDone.call
                    , done = idOrDoneIsDone ? idOrDone : optDone
                    , id = idOrDoneIsDone ? paths.join('') : idOrDone
                    , queue = paths.length

                function loopFn(item) {
                    return item.call ? item() : list[item]
                }

                function callback() {
                    if (!--queue) {
                        list[id] = 1
                        done && done()
                        for (var dset in delay) {
                            every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
                        }
                    }
                }

                setTimeout(function () {
                    each(paths, function loading(path, force) {
                        if (path === null) return callback()

                        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
                            path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
                        }

                        if (scripts[path]) {
                            if (id) ids[id] = 1
                            return (scripts[path] == 2) ? callback() : setTimeout(function () {
                                loading(path, true)
                            }, 0)
                        }

                        scripts[path] = 1
                        if (id) ids[id] = 1
                        create(path, callback)
                    })
                }, 0)
                return $script
            }

            function create(path, fn) {
                var el = doc.createElement('script'), loaded
                el.onload = el.onerror = el[onreadystatechange] = function () {
                    if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
                    el.onload = el[onreadystatechange] = null
                    loaded = 1
                    scripts[path] = 2
                    fn()
                }
                el.async = 1
                el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
                head.insertBefore(el, head.lastChild)
            }

            $script.get = create

            $script.order = function (scripts, id, done) {
                (function callback(s) {
                    s = scripts.shift()
                    !scripts.length ? $script(s, id, done) : $script(s, callback)
                }())
            }

            $script.path = function (p) {
                scriptpath = p
            }
            $script.urlArgs = function (str) {
                urlArgs = str;
            }
            $script.ready = function (deps, ready, req) {
                deps = deps[push] ? deps : [deps]
                var missing = [];
                !each(deps, function (dep) {
                    list[dep] || missing[push](dep);
                }) && every(deps, function (dep) {
                    return list[dep]
                }) ?
                    ready() : !function (key) {
                        delay[key] = delay[key] || []
                        delay[key][push](ready)
                        req && req(missing)
                    }(deps.join('|'))
                return $script
            }

            $script.done = function (idOrDone) {
                $script([null], idOrDone)
            }

            return $script
        });

    }, {}],
    3: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;

        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError('Cannot call a class as a function');
            }
        }

        var _globalLoadData = require('./global/loadData');

        var Sections = (function () {
            function Sections() {
                _classCallCheck(this, Sections);

                this.sections = {};
                this.handlers = {};
                this._onSectionEvent = this._onSectionEvent.bind(this);

                document.addEventListener('shopify:section:load', this._onSectionEvent);
                document.addEventListener('shopify:section:unload', this._onSectionEvent);
                document.addEventListener('shopify:section:select', this._onSectionEvent);
                document.addEventListener('shopify:section:deselect', this._onSectionEvent);
                document.addEventListener('shopify:section:reorder', this._onSectionEvent);
                document.addEventListener('shopify:block:select', this._onSectionEvent);
                document.addEventListener('shopify:block:deselect', this._onSectionEvent);
            }

            Sections.prototype.unbind = function unbind() {
                document.removeEventListener('shopify:section:load', this._onSectionEvent);
                document.removeEventListener('shopify:section:unload', this._onSectionEvent);
                document.removeEventListener('shopify:section:select', this._onSectionEvent);
                document.removeEventListener('shopify:section:deselect', this._onSectionEvent);
                document.removeEventListener('shopify:section:reorder', this._onSectionEvent);
                document.removeEventListener('shopify:block:select', this._onSectionEvent);
                document.removeEventListener('shopify:block:deselect', this._onSectionEvent);

                this.sections = {};
                this.handlers = {};
            };

            Sections.prototype._onSectionEvent = function _onSectionEvent(event) {
                var el = event.target;
                var sectionId = event.detail.sectionId;
                var blockId = event.detail.blockId;
                var section = this.sections[sectionId];

                switch (event.type) {
                    case 'shopify:section:load':
                        this._loadSection(el, sectionId);
                        break;

                    case 'shopify:section:unload':
                        this._triggerSectionEvent(section, 'unloadSection');
                        delete this.sections[section];
                        break;

                    case 'shopify:section:select':
                        this._triggerSectionEvent(section, 'selectSection', {sectionId: sectionId});
                        break;

                    case 'shopify:section:deselect':
                        this._triggerSectionEvent(section, 'deselectSection');
                        break;

                    case 'shopify:section:reorder':
                        this._triggerSectionEvent(section, 'reorderSection');
                        break;

                    case 'shopify:block:select':
                        this._triggerSectionEvent(section, 'selectBlock', {blockId: blockId});
                        break;

                    case 'shopify:block:deselect':
                        this._triggerSectionEvent(section, 'deselectBlock', {blockId: blockId});
                        break;
                }
            };

            Sections.prototype._loadSection = function _loadSection(el, sectionId) {
                var scriptEl = el.querySelector('[data-section-id="' + sectionId + '"]');
                if (!scriptEl) return;

                var type = scriptEl.getAttribute('data-section-type');

                if (!this.handlers[type]) return;

                var handler = this.handlers[type];
                var data = _globalLoadData.loadData(scriptEl);

                this.sections[sectionId] = handler({
                    el: el,
                    data: data
                });
            };

            Sections.prototype._triggerSectionEvent = function _triggerSectionEvent(section, eventName) {
                if (section && section[eventName]) {
                    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
                        args[_key - 2] = arguments[_key];
                    }

                    section[eventName].apply(section, args);
                }
            };

            Sections.prototype.initSection = function initSection(type, handler) {
                if (!this.handlers[type]) this.handlers[type] = handler;
                var scriptEls = document.querySelectorAll('[data-section-type="' + type + '"]');

                for (var _iterator = scriptEls, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ;) {
                    var _ref;

                    if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref = _i.value;
                    }

                    var scriptEl = _ref;

                    var el = scriptEl.parentNode;
                    var sectionId = scriptEl.getAttribute('data-section-id');
                    var data = _globalLoadData.loadData(scriptEl);

                    this.sections[sectionId] = handler({
                        el: el,
                        data: data
                    });
                }
            };

            return Sections;
        })();

        exports['default'] = Sections;
        module.exports = exports['default'];

    }, {"./global/loadData": 10}],
    4: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {'default': obj};
        }

        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError('Cannot call a class as a function');
            }
        }

        require('focus-visible');

        var _globalImage = require('./global/image');

        var _globalImage2 = _interopRequireDefault(_globalImage);

        var _templatesAccount = require('./templates/Account');

        var _templatesAccount2 = _interopRequireDefault(_templatesAccount);

        var _templatesBlog = require('./templates/Blog');

        var _templatesBlog2 = _interopRequireDefault(_templatesBlog);

        var _templatesCart = require('./templates/Cart');

        var _templatesCart2 = _interopRequireDefault(_templatesCart);

        var _templatesCollection = require('./templates/Collection');

        var _templatesCollection2 = _interopRequireDefault(_templatesCollection);

        var _templatesHome = require('./templates/Home');

        var _templatesHome2 = _interopRequireDefault(_templatesHome);

        var _templatesProduct = require('./templates/Product');

        var _templatesProduct2 = _interopRequireDefault(_templatesProduct);

        var _snippetsProductItem = require('./snippets/ProductItem');

        var _snippetsProductItem2 = _interopRequireDefault(_snippetsProductItem);

        var _snippetsHeader = require('./snippets/Header');

        var _snippetsHeader2 = _interopRequireDefault(_snippetsHeader);

        var _snippetsMailingList = require('./snippets/MailingList');

        var _snippetsMailingList2 = _interopRequireDefault(_snippetsMailingList);

        var _snippetsNavigation = require('./snippets/Navigation');

        var _snippetsNavigation2 = _interopRequireDefault(_snippetsNavigation);

        var _snippetsNavigationMobile = require('./snippets/NavigationMobile');

        var _snippetsNavigationMobile2 = _interopRequireDefault(_snippetsNavigationMobile);

        var _globalRte = require('./global/Rte');

        var _globalRte2 = _interopRequireDefault(_globalRte);

        var _snippetsFooterTapbar = require('./snippets/FooterTapbar');

        var _snippetsFooterTapbar2 = _interopRequireDefault(_snippetsFooterTapbar);

        var _Sections = require('./Sections');

        var _Sections2 = _interopRequireDefault(_Sections);

        var _sectionsSlideshow = require('./sections/Slideshow');

        var _sectionsSlideshow2 = _interopRequireDefault(_sectionsSlideshow);

        var Theme = (function () {
            function Theme() {
                _classCallCheck(this, Theme);

                this.$window = $(window);
                this.$body = $(document.body);

                var sections = new _Sections2['default']();

                if (!this.$body.hasClass('template-password')) {
                    sections.initSection('header', function (section) {
                        return new _snippetsHeader2['default'](section);
                    });
                    sections.initSection('slideshow', function (section) {
                        return new _sectionsSlideshow2['default'](section);
                    });
                }

                // Initialize lazysizes customMedia
                _globalImage2['default']();

                this._checkMobile();
                this._initTemplates();
                this._bindEvents();
            }

            Theme.prototype._bindEvents = function _bindEvents() {
                $(document.body).on('shopify:section:load shopify:section:unload shopify:section:reorder shopify:block:select', this._handleSettingsUpdate.bind(this));
            };

            Theme.prototype._checkMobile = function _checkMobile() {
                if (navigator.userAgent.match(/Mobile/i)) {
                    $(document.body).addClass('is-mobile').trigger('bindMobile');
                }
            };

            Theme.prototype._initTemplates = function _initTemplates() {
                this.hasProductItems = $('[data-product-item-wrapper]').length;

                var isAccount = this.$body.hasClass('template-customers'),
                    isBlog = this.$body.hasClass('template-blog'),
                    isCart = this.$body.hasClass('template-cart'),
                    isCollection = this.$body.hasClass('template-collection'),
                    isHome = this.$body.hasClass('template-index'),
                    isPassword = this.$body.hasClass('template-password'),
                    isProduct = this.$body.hasClass('template-product');

                if (!isPassword) {
                    new _snippetsNavigation2['default']('[data-main-navigation]');
                    new _snippetsNavigationMobile2['default']('[data-mobile-navigation]');

                    if (isAccount) {
                        new _templatesAccount2['default']('[data-account]');
                    }

                    if (isBlog) {
                        new _templatesBlog2['default']('[data-blog]');
                    }

                    if (isCart) {
                        new _templatesCart2['default']('[data-cart]');
                    }

                    if (isCollection) {
                        new _templatesCollection2['default']('.collection-main-wrapper');
                    }

                    if (isHome) {
                        this.Home = new _templatesHome2['default']();
                    }

                    if (isProduct) {
                        new _templatesProduct2['default']('[data-product]');
                    }

                    if ($('.rich-text').length) {
                        new _globalRte2['default']('.page-wrapper');
                    }

                    if (this.hasProductItems) {
                        new _snippetsProductItem2['default']('[data-product-item-wrapper]');
                    }

                    new _snippetsFooterTapbar2['default']('[data-footer-tapbar]');
                }

                if ($('[data-mailing-list]').length) {
                    new _snippetsMailingList2['default']('[data-mailing-list]');
                }
            };

            Theme.prototype._handleSettingsUpdate = function _handleSettingsUpdate(event) {
                var eventType = event.originalEvent.type;
                var sectionId = event.originalEvent.detail.sectionId;
                var $section = $('[data-section-id="' + sectionId + '"]');

                if ($section.length) {
                    var type = $section.data('section-type');

                    if (eventType === 'shopify:section:load') {
                        this._loadSection(type, sectionId);
                    }

                    if (eventType === 'shopify:section:unload') {
                        this._unloadSection(type, sectionId);
                    }

                    if (eventType === 'shopify:block:select') {
                        var blockId = event.originalEvent.detail.blockId;
                        this._selectBlock(type, $section, blockId);
                    }
                }
            };

            Theme.prototype._loadSection = function _loadSection(type, sectionId) {
                switch (type) {
                    case 'navigation':
                        new _snippetsNavigation2['default']('[data-main-navigation]');
                        new _snippetsNavigationMobile2['default']('[data-mobile-navigation]');
                        break;
                    case 'footer':
                        new _snippetsMailingList2['default']('[data-mailing-list]');
                        break;
                    case 'home':
                        var childType = $('[data-section-id="' + sectionId + '"]').data('section-child');
                        switch (childType) {
                            case 'departments':
                                this.Home.initDepartments();
                                break;
                            case 'instagram':
                                this.Home.initInstagram(sectionId);
                                break;
                            case 'featured-products':
                                this.Home.initCollectionSlider();
                                break;
                            case 'slideshow':
                                this.Home.initSlideshow(sectionId);
                                break;
                            case 'video':
                                this.Home.initVideo(sectionId);
                                break;
                            case 'map':
                                this.Home.initMaps(sectionId);
                                break;
                            case 'featured-product':
                                this.Home.initFeaturedProduct(sectionId);
                                break;
                        }
                        break;
                    case 'collection':
                        new _templatesCollection2['default']('.collection-main-wrapper');
                        if (this.hasProductItems) {
                            new _snippetsProductItem2['default']('[data-product-item-wrapper]');
                        }
                        break;
                    case 'password':
                        new _snippetsMailingList2['default']('[data-mailing-list]');
                        break;
                    case 'product':
                        new _templatesProduct2['default']('[data-product]');
                        this.$window.trigger('resize.product');
                        if (this.hasProductItems) {
                            new _snippetsProductItem2['default']('[data-product-item-wrapper]');
                        }
                        break;
                    case 'cart':
                        new _templatesCart2['default']('[data-cart]');

                        if (this.hasProductItems) {
                            new _snippetsProductItem2['default']('[data-products-recent]');
                        }
                        break;
                }
            };

            Theme.prototype._unloadSection = function _unloadSection(type, sectionId) {
                this.$window.off('.' + type);
                this.$body.off('.' + type);

                switch (type) {
                    case 'home':
                        var childType = $('[data-section-id="' + sectionId + '"]').data('section-child');

                        switch (childType) {
                            case 'departments':
                                if (window.innerWidth > 600) {
                                    $('[data-departments-slideshow]').slick('unslick');
                                }
                                break;

                            case 'featured-products':
                                $('[data-section-id="' + sectionId + '"] [data-featured-products]').slick('unslick');
                                break;

                            case 'featured-product':
                                this.Home.unloadFeaturedProduct();
                                break;
                        }
                        break;

                    case 'product':
                        if (window.innerWidth > 600 && $('[data-product-thumbnail-index]').length > 1) {
                            $('[data-product-images]').slick('unslick');
                        }
                        break;
                }
            };

            Theme.prototype._selectBlock = function _selectBlock(type, $section, blockId) {
                switch (type) {
                    case 'home':
                        var childType = $section.data('section-child');

                        switch (childType) {
                            case 'departments':
                                if (window.innerWidth > 600) {
                                    var $block = $section.find('[data-block-id="' + blockId + '"]');
                                    var slideIndex = $block.data('department-slide');
                                    $section.find('[data-departments-slideshow]').slick('slickGoTo', slideIndex);
                                }
                                break;
                        }
                        break;
                }
            };

            return Theme;
        })();

        exports['default'] = Theme;

        $(function () {
            return new Theme();
        });
        module.exports = exports['default'];

    }, {
        "./Sections": 3,
        "./global/Rte": 6,
        "./global/image": 9,
        "./sections/Slideshow": 17,
        "./snippets/FooterTapbar": 20,
        "./snippets/Header": 21,
        "./snippets/MailingList": 23,
        "./snippets/Navigation": 24,
        "./snippets/NavigationMobile": 25,
        "./snippets/ProductItem": 27,
        "./templates/Account": 30,
        "./templates/Blog": 31,
        "./templates/Cart": 32,
        "./templates/Collection": 33,
        "./templates/Home": 34,
        "./templates/Product": 35,
        "focus-visible": 1
    }],
    5: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;

        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError('Cannot call a class as a function');
            }
        }

        var Filters = (function () {
            function Filters(el, collection) {
                _classCallCheck(this, Filters);

                this.$el = $(el);
                this.$body = $(document.body);
                this.$sidebar = this.$body.find('[data-collection-sidebar]');
                this.collection = collection;
                this.collectionUrl = '/collections/' + this.collection;
                this.tags = this._getTags();

                this._bindEvents();
            }

            Filters.prototype._bindEvents = function _bindEvents() {
                var _this = this;

                this.$el.on('click', '[data-filter-tag]', function (event) {
                    // event.preventDefault();
                    // _this._updateTags(event);
                });

                this.$el.on('click', '[data-filter-toggle]', function (event) {
                    _this._toggleFilterSection(event);
                });

                this.$el.on('click', '[data-filters-submit]', function () {
                    window.location.pathname = _this.collectionUrl + '/' + _this.tags.join('+');
                });

                this.$el.on('click', '[data-filter-tag-box]', function (event) {
                    _this._removeTagBox(event);
                });

                this.$body.on('click', '[data-collection-filters-toggle]', function (event) {
                    event.preventDefault();
                    _this._toggleFilters();
                });

                this.$body.on('click', '[data-collection-sidebar]', function (event) {
                    if (!$(event.target).closest('[data-collection-filters]').length) {
                        _this._toggleFilters();
                    }
                });
            };

            Filters.prototype._toggleFilters = function _toggleFilters() {
                if (window.innerWidth < 721) {
                    this.$sidebar.revealer('toggle');
                    this.$body.toggleClass('scroll-locked');
                }
            };

            Filters.prototype._getTags = function _getTags() {
                var url = window.location.pathname;
                var tags = url.split(this.collectionUrl)[1];
                if (tags == undefined) {
                    tags = url.split(encodeURI(this.collectionUrl))[1];
                }

                if (tags === undefined) {
                    tags = ''
                }

                if (tags.substring(0, 1) == '/') {
                    tags = tags.substring(1);
                }

                if (tags.length && tags.indexOf('+') !== -1) {
                    tags = tags.split('+');
                } else if (tags.length) {
                    tags = [tags];
                } else {
                    tags = [];
                }

                return tags;
            };

            Filters.prototype._updateTags = function _updateTags(event) {
                var $target = $(event.currentTarget);
                var $targetWrapper = $target.closest('[data-filter-wrapper]');
                var $activeTag = $targetWrapper.find('.active').length ? $targetWrapper.find('.active') : false;
                var activeTag = $activeTag.length ? $activeTag.data('filter-tag') : false;
                var tag = $target.data('filter-tag');
                var removeTag = !!$target.data('filter');

                if (removeTag) {
                    this._removeTag($target, this.tags, tag);
                    $targetWrapper.data('filter-wrapper', '');
                } else {
                    this._addTag($target, this.tags, tag);
                    $targetWrapper.data('filter-wrapper', tag);

                    if (activeTag.length) {
                        this._removeTag($activeTag, this.tags, activeTag);
                    }
                }

                if (window.innerWidth > 720) {
                    window.location = this.collectionUrl + '/' + this.tags.join('+');
                }
            };

            Filters.prototype._addTag = function _addTag($target, tags, tag) {
                $target.addClass('active').data('filter', 'true');

                var filter = $target.text(),
                    group = $target.closest('[data-filter-wrapper]').find('[data-filter-toggle]').text();
                var text = group + ': ' + filter;

                tags.push('' + tag);

                this.$el.find('[data-filter-tag-boxes]').append('\n      <span class="collection-filters-tag-box" data-filter-tag-box="' + tag + '">\n        ' + text + '\n        <span>&times;</span>\n        <a href="' + tag + '"></a>\n      </span>\n    ');
            };

            Filters.prototype._removeTag = function _removeTag($target, tags, tag) {
                var tagIndex = tags.indexOf(tag);
                tags.splice(tagIndex, 1);

                $target.removeClass('active').data('filter', '');

                this.$el.find('[data-filter-tag-box="' + tag + '"]').remove();
            };

            Filters.prototype._removeTagBox = function _removeTagBox(event) {
                if (window.innerWidth > 720) {
                    return false;
                }

                event.preventDefault();
                var $target = $(event.currentTarget);
                var tag = $target.data('filter-tag-box');

                this.$el.find('[data-filter-tag=' + tag + ']').trigger('click');
            };

            Filters.prototype._toggleFilterSection = function _toggleFilterSection(event) {
                var $target = $(event.currentTarget).closest('[data-filter-wrapper]');
                $target.toggleClass('active');
            };

            return Filters;
        })();

        exports['default'] = Filters;
        module.exports = exports['default'];

    }, {}],
    6: [function (require, module, exports) {
        "use strict";

        exports.__esModule = true;

        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            }
        }

        var Rte = function Rte(el) {
            _classCallCheck(this, Rte);

            this.$el = $(el);
            this.$el.fitVids();
        };

        exports["default"] = Rte;
        module.exports = exports["default"];

    }, {}],
    7: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;

        exports['default'] = function () {
            Shopify.getCart(function (data) {
                var itemCount = data.item_count > 0 ? data.item_count : '';
                $('[data-header-cart-count]').text(itemCount);
            });
        };

        module.exports = exports['default'];

    }, {}],
    8: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;

        exports['default'] = function ($el) {
            $el.find('span.money').each(function (i, el) {
                $(el).data('currency-' + Theme.currency, $(el).html());
            });
        };

        module.exports = exports['default'];

    }, {}],
    9: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;
        exports['default'] = image;

        function image() {
            window.lazySizesConfig = window.lazySizesConfig || {};
            window.lazySizesConfig.customMedia = {
                '--xs': '(max-width: 500px)',
                '--s': '(max-width: 600px)',
                '--m': '(max-width: 960px)',
                '--l': '(max-width: 1060px)'
            };
        }

        module.exports = exports['default'];

    }, {}],
    10: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;

        function loadData(el) {
            if (el.hasAttribute('data-section-data') && el.innerHTML) {
                return JSON.parse(el.innerHTML);
            }
            return false;
        }

        exports.loadData = loadData;

    }, {}],
    11: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {'default': obj};
        }

        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError('Cannot call a class as a function');
            }
        }

        var _currencySaver = require('../currencySaver');

        var _currencySaver2 = _interopRequireDefault(_currencySaver);

        var _cartUpdateCartCount = require('../cart/updateCartCount');

        var _cartUpdateCartCount2 = _interopRequireDefault(_cartUpdateCartCount);

        var ProductUtils = (function () {
            function ProductUtils(el, scope) {
                var _this = this;

                _classCallCheck(this, ProductUtils);

                this.$window = $(window);
                this.$body = $(document.body);
                this.$el = $(el);
                this.scope = scope;
                this.addInProgress = false;

                this.productHandle = this.$el.data('product');
                this.product = this.$el.data('product-json');
                this.currentVariant = this.$el.data('product-current-variant');
                this.hasDeepLinking = this.$el.data('product-deeplinking') ? true : false;

                // Product elements
                this.$images = this.$el.find('[data-product-images]');
                this.$thumbnails = this.$el.find('[data-product-thumbnails]'), this.$lightbox = this.$el.find('[data-product-images-lightbox-wrapper]');
                this.$options = this.$el.find('[data-product-options]');
                this.$price = this.$el.find('[data-product-price]');
                this.$priceCompare = this.$el.find('[data-product-price-compare]');
                this.$stockWrapper = this.$options.find('[data-product-stock-wrapper]');
                this.$addToCart = this.$options.find('[data-product-add]');
                this.$message = this.$el.find('[data-product-message]');

                this.$el.find('.product-image-first').allLazyLoaded().on('containerlazyloaded', function () {
                    _this.initSlick();
                    _this._setInitialVariant();
                });

                this._bindEvents();
            }

            ProductUtils.prototype._bindEvents = function _bindEvents() {
                var _this2 = this;

                this.events = [this.$addToCart.on('click.' + this.scope, function (event) {
                    event.preventDefault();
                    _this2._closeMessage();
                    _this2._addToCart();
                }), this.$options.on('change.' + this.scope, '[data-product-swatch-input]', function (event) {
                    _this2._getCurrentVariant();
                }), this.$images.on('click.' + this.scope, 'img', function (event) {
                    _this2._showLightbox(event);
                }), this.$thumbnails.on('click.' + this.scope, 'img', function (event) {
                    _this2._switchImage($(event.currentTarget).data('product-thumbnail-src'));
                }), this.$el.on('click.' + this.scope, '[data-product-images-lightbox-close]', function () {
                    _this2._hideLightbox();
                }), this.$lightbox.on('click.' + this.scope, function (event) {
                    if (!$(event.target).closest('[data-product-images-lightbox]').length) {
                        _this2._hideLightbox();
                    }
                })];

                Shopify.onError = function (XMLHttpRequest) {
                    _this2._handleErrors(XMLHttpRequest);
                };
            };

            ProductUtils.prototype.unload = function unload() {
                var _this3 = this;

                this.events.forEach(function (el, i) {
                    return $(el).off('.' + _this3.scope);
                });
            };

            ProductUtils.prototype._escapeString = function _escapeString(string) {
                return string.replace(/'/g, "\\'");
            };

            ProductUtils.prototype._setInitialVariant = function _setInitialVariant() {
                for (var i in this.product.options) {
                    var optionIndex = 'option' + (parseInt(i, 10) + 1),
                        $option = this.$options.find('[data-product-swatch="' + i + '"]'),
                        optionValue = this._escapeString(this.currentVariant[optionIndex]);
                    var $optionItem = $option.find('[data-product-swatch-value="' + optionValue + '"]');

                    $optionItem.find('input').prop('checked', 'checked');
                }

                if (!(this.product.variants.length === 1 && this.product.variants[0].title === 'Default Title')) {
                    Shopify.linkOptionSelectors(this.product, this.product.id);
                }

                this._selectCallback(this.currentVariant);
            };

            ProductUtils.prototype._getCurrentVariant = function _getCurrentVariant() {
                var options = this.product.options,
                    variants = this.product.variants,
                    selectedOptions = [];

                for (var i in options) {
                    selectedOptions.push(this.$options.find('[data-product-swatch="' + i + '"] input:checked').val());
                }

                for (var i in variants) {
                    if (selectedOptions[0] === variants[i].option1) {
                        if (options.length > 1) {
                            if (selectedOptions[1] === variants[i].option2) {
                                if (options.length === 3) {
                                    if (selectedOptions[2] === variants[i].option3) {
                                        this.currentVariant = variants[i];
                                    }
                                } else {
                                    this.currentVariant = variants[i];
                                }
                            }
                        } else {
                            this.currentVariant = variants[i];
                        }
                    }
                }

                this._selectCallback(this.currentVariant);
            };

            ProductUtils.prototype._selectCallback = function _selectCallback(variant) {
                if (variant) {
                    var priceFormatted = Shopify.formatMoney(variant.price, Theme.moneyFormat);
                    var compareAtPriceFormatted = Shopify.formatMoney(variant.compare_at_price, Theme.moneyFormat);

                    this.$options.find('#product-select-simple').val(variant.id);
                    this.$price.html(priceFormatted);

                    if (variant.compare_at_price > variant.price) {
                        this.$priceCompare.removeClass('hidden').html(compareAtPriceFormatted);
                    } else {
                        this.$priceCompare.addClass('hidden');
                    }

                    this._closeMessage();

                    if (this.$stockWrapper.length) {
                        this._updateStock();
                    }

                    if (Theme.currencySwitcher) {
                        this.$el.find('.product-wrapper span.money').each(function (i, el) {
                            $.each($(el)[0].attributes, function (index, value) {
                                if (value.name.indexOf('data-currency') != -1) {
                                    $(el).attr(value.name, '');
                                }
                            });
                        });

                        _currencySaver2['default'](this.$options);
                        $(document.body).trigger('currency-reset');
                    }

                    if (variant.featured_image) {
                        this._switchImage(variant.featured_image.src);
                    }

                    if (this.hasDeepLinking) {
                        this._updateVariantDeepLink(variant);
                    }

                    if (variant.available) {
                        this._updateButtonText(Theme.localization.product.addToCart, true);
                    } else {
                        this._updateButtonText(Theme.localization.product.soldOut, false);
                    }
                } else {
                    this._updateButtonText(Theme.localization.product.unavailable, false);
                }
            };

            ProductUtils.prototype._updateButtonText = function _updateButtonText(text, isEnabled, $button) {
                this.$addToCart.prop('disabled', !isEnabled).toggleClass('button-disabled', !isEnabled).children('.button-text').text(text);
            };

            ProductUtils.prototype._updateVariantDeepLink = function _updateVariantDeepLink(variant) {
                if (window.history && window.history.replaceState) {
                    window.history.replaceState({}, document.title, "?variant=" + variant.id);
                }
            };

            ProductUtils.prototype._updateStock = function _updateStock() {
                var $currentStock = this.$stockWrapper.find('[data-product-stock-variant="' + this.currentVariant.id + '"]');
                var stockIndex = $currentStock.data('product-stock-index');

                $currentStock.addClass('visible').siblings().removeClass('visible');

                var $stockVisual = this.$stockWrapper.find('[data-product-stock-variant-visual]');
                var inventory = $stockVisual.data('product-stock-variant-visual');

                $stockVisual.width(inventory[stockIndex]);
            };

            ProductUtils.prototype._addToCart = async function _addToCart(event) {
                var _this4 = this;

                // カート内に指定のタグをもつ商品がある場合、カートに追加できない
                var $cartItems =  await fetch('/cart.js').then(function(response) {
                    return response.json();
                }).then(function(cart) {
                    return cart.items;
                });

                var only_once = false;
                var has_onlyproduct = false;
                if(_this4.product.tags.includes('１個のみ購入可能')){
                    only_once = true;
                }

                var limited = false;
                var has_limited = false;
                if(_this4.product.tags.includes('限定商品')){
                    limited = true;
                }
                let limited_cartitems = JSON.parse(document.querySelector('#limited-product-json').innerHTML);
                if(limited_cartitems.products.length > 0 && limited){
                    has_limited = true;
                }

                $cartItems.forEach((item)=>{
                    if(only_once){
                        if(item.product_id == _this4.product.id){
                            has_onlyproduct = true;
                        }
                    }
                })
                if(has_onlyproduct){
                    alert('1個までです');
                }else if(has_limited){
                    alert('限定商品は2つ以上購入できません');
                }

                if (!this.addInProgress && !has_onlyproduct && !has_limited) {
                    var quantity = this.$options.find('[data-product-quantity]').val();
                    this.addInProgress = true;

                    this._toggleLoader(true);

                    var formId = 'product_form_' + this.product.id;

                    Shopify.addItemFromForm(formId, function (response) {
                        buyTogetherAddCart();
                        var message = Theme.localization.product.added.replace('*item*', response.title);

                        setTimeout(function () {
                            _cartUpdateCartCount2['default']();
                            _this4._updateMessage(message);
                            _this4._toggleLoader();
                            _this4.addInProgress = false;
                            _this4._showCartAddedModal();
                        }, 500);
                    });
                }
            };

            ProductUtils.prototype._handleErrors = function _handleErrors(errors) {
                var _this5 = this;

                var error = $.parseJSON(errors.responseText);

                setTimeout(function () {
                    if (error.message === 'Cart Error') {
                        _this5._updateMessage(error.description, true);
                    }

                    _this5._toggleLoader();
                    _this5.addInProgress = false;
                }, 500);
            };

            ProductUtils.prototype._updateMessage = function _updateMessage(message, isError) {
                var _this6 = this;

                if (isError) {
                    this.$message.addClass('error');
                } else {
                    message = '<a href="/cart">' + message + '</a>';
                }

                this.$message.html(message).revealer('show');

                setTimeout(function () {
                    _this6._closeMessage();
                }, 5000);
            };

            ProductUtils.prototype._closeMessage = function _closeMessage() {
                var _this7 = this;

                this.$message.revealer('hide');

                setTimeout(function () {
                    _this7.$message.removeClass('error');
                }, 200);
            };

            ProductUtils.prototype._toggleLoader = function _toggleLoader(start) {
                var _this8 = this;

                if (start) {
                    this.$addToCart.addClass('active').one('trend', function () {
                        _this8.$addToCart.addClass('loading');
                    });
                } else {
                    this.$addToCart.removeClass('loading').one('trend', function () {
                        _this8.$addToCart.removeClass('active');
                    });
                }
            };

            ProductUtils.prototype._showCartAddedModal = function(){
                $('.js-ly-product-add').removeClass('d-none');

            }

            ProductUtils.prototype.initSlick = function initSlick() {
                var _this9 = this;

                if (this.$images.children().length) {
                    this.$images.slick({
                        infinite: false,
                        fade: true,
                        speed: 0,
                        arrows: false,
                        adaptiveHeight: true
                    }).init(function () {
                        _this9.$thumbnails.parent().removeClass('visibly-hidden');
                    });
                }
            };

            ProductUtils.prototype.unloadSlick = function unloadSlick() {
                if (this.$images && this.$images.slick('getSlick')) {
                    this.$images.slick('unslick');
                }
            };

            ProductUtils.prototype._switchImage = function _switchImage(src) {
                var img_src = src.indexOf('?v=') != -1 ? src.split('?v=')[0] : src;
                img_src = img_src.indexOf('products/') != -1 ? img_src.split('products/')[1] : src;
                img_src = 'products/' + img_src;

                var $image = this.$images.find('[data-product-image-src="' + img_src + '"]');
                var index = $image.data('slick-index');
                this.$images.slick('slickGoTo', index);

                var img_src_new = src.indexOf('?v=') != -1 ? src.split('?v=')[0] : src;
                img_src_new = img_src_new.indexOf('files/') != -1 ? img_src_new.split('files/')[1] : src;
                img_src_new = 'files/' + img_src_new;

                var $image_new = this.$images.find('[data-product-image-src="' + img_src_new + '"]');
                var index_new = $image_new.data('slick-index');
                this.$images.slick('slickGoTo', index_new);
            };

            ProductUtils.prototype._scrollLockToggle = function _scrollLockToggle(lock) {
                this.$body.toggleClass('scroll-locked', lock);
            };

            ProductUtils.prototype._showLightbox = function _showLightbox(event) {
                var imgSrc = $(event.currentTarget).data('high-res');

                this._scrollLockToggle(true);
                this.$lightbox.find('img').attr('src', imgSrc);

                this.$lightbox.revealer('show');
            };

            ProductUtils.prototype._hideLightbox = function _hideLightbox() {
                this._scrollLockToggle();
                this.$lightbox.revealer('hide');
            };

            return ProductUtils;
        })();

        exports['default'] = ProductUtils;
        module.exports = exports['default'];

    }, {"../cart/updateCartCount": 7, "../currencySaver": 8}],
    12: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {'default': obj};
        }

        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError('Cannot call a class as a function');
            }
        }

        var _snippetsProductItem = require('../../snippets/ProductItem');

        var _snippetsProductItem2 = _interopRequireDefault(_snippetsProductItem);

        var RecentlyViewed = (function () {
            function RecentlyViewed(el) {
                _classCallCheck(this, RecentlyViewed);

                this.$window = $(window);
                this.$body = $(document.body);
                this.$el = $(el);
                this.handle = this.$el.data('products-recent-handle');
                this.item = this.$el.data('products-recent-item');

                this.$window.on('load', this._updateRecentlyViewed());
            }

            RecentlyViewed.prototype._updateRecentlyViewed = function _updateRecentlyViewed() {
                var recentlyViewed = localStorage.getItem('recentlyViewed');
                recentlyViewed = recentlyViewed != null ? JSON.parse(recentlyViewed) : [];

                if (this.handle) {
                    var item = {
                        'handle': this.handle,
                        'markup': this.item
                    };

                    recentlyViewed.unshift(item);
                }

                var uniqueArray = recentlyViewed.length ? this._getUniqueArray(recentlyViewed) : recentlyViewed;

                if (uniqueArray.length > 6) {
                    uniqueArray = uniqueArray.slice(0, 6);
                }

                localStorage.setItem('recentlyViewed', JSON.stringify(uniqueArray));

                if (uniqueArray.length > 1 || uniqueArray.length === 1 && uniqueArray[0]['handle'] !== this.handle) {
                    this._buildRecentlyViewed(uniqueArray);
                } else {
                    this.$el.closest('[data-products-recent-wrapper]').remove();
                }
            };

            RecentlyViewed.prototype._getUniqueArray = function _getUniqueArray(array) {
                var newArray = new Array();
                var handleArray = new Array();

                for (var i = 0; i < array.length; i++) {
                    var handle = array[i]['handle'];
                    if (handleArray.indexOf(handle) === -1) {
                        newArray.push(array[i]);
                        handleArray.push(handle);
                    }
                }

                return newArray;
            };

            RecentlyViewed.prototype._buildRecentlyViewed = function _buildRecentlyViewed(recentlyViewed) {
                Shopify.queue = recentlyViewed;
                Shopify.queue.splice(0, 1);

                this._addProduct(Shopify.queue.shift());
            };

            RecentlyViewed.prototype._addProduct = function _addProduct(item) {
                this.$el.append(item.markup);

                if (Shopify.queue.length) {
                    this._addProduct(Shopify.queue.shift());
                } else {
                    this.$el.closest('[data-products-recent-wrapper]').addClass('visible');
                    this.$body.trigger('currency-reset');
                    new _snippetsProductItem2['default']('[data-products-recent]');
                }
            };

            return RecentlyViewed;
        })();

        exports['default'] = RecentlyViewed;
        module.exports = exports['default'];

    }, {"../../snippets/ProductItem": 27}],
    13: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;

        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError('Cannot call a class as a function');
            }
        }

        var Departments = (function () {
            function Departments(el) {
                _classCallCheck(this, Departments);

                this.$el = $(el);
                this.$window = $(window);
                this.$body = $(document.body);
                this.slideCount = this.$el.find('.departments-slide').length;
                this.hasSlick = false;

                this._bindEvents();
                this._windowWidthCheck();
            }

            Departments.prototype._bindEvents = function _bindEvents() {
                this.$window.on('resize.home', _.debounce(this._windowWidthCheck.bind(this), 500));
            };

            Departments.prototype._bindSlickEvents = function _bindSlickEvents() {
                var _this = this;

                this.$el.on('init', function () {
                    _this.hasSlick = true;
                });

                this.$el.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                    var activeSlides = [nextSlide, nextSlide + 1];

                    if (activeSlides[1] >= _this.slideCount) {
                        activeSlides.push(0, -1);
                    } else if (nextSlide === 0) {
                        activeSlides.push(_this.slideCount, _this.slideCount + 1);
                    }

                    for (var i in activeSlides) {
                        _this.$el.find('[data-slick-index=' + activeSlides[i] + ']').addClass('visible');
                    }
                });

                this.$el.on('afterChange', function () {
                    _this.$el.find('.slick-slide').removeClass('visible');
                });
            };

            Departments.prototype._windowWidthCheck = function _windowWidthCheck() {
                var windowWidth = window.innerWidth;
                if (windowWidth > 720 && !this.hasSlick) {
                    this.hasSlick = true;
                    this._setupSlideshow();
                } else if (windowWidth <= 720 && this.hasSlick) {
                    this.hasSlick = false;
                    this.$el.slick('unslick');
                }
            };

            Departments.prototype._setupSlideshow = function _setupSlideshow() {
                var $parent = this.$el.closest('[data-section-id]');
                var prev = $parent.find('[data-departments-slideshow-previous]');
                var next = $parent.find('[data-departments-slideshow-next]');

                this.$el.slick({
                    infinite: true,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    prevArrow: prev,
                    nextArrow: next
                });

                // Force fire of lazyload to catch cloned slick slides
                // created due to use of infinite option above
                this.slides = this.$el[0].querySelectorAll('.departments-slide figure');
                for (var i = 0; i < this.slides.length; i++) {
                    lazySizes.loader.unveil(this.slides[i]);
                }

                this._bindSlickEvents();
            };

            return Departments;
        })();

        exports['default'] = Departments;
        module.exports = exports['default'];

    }, {}],
    14: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;

        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError('Cannot call a class as a function');
            }
        }

        var FeaturedProducts = (function () {
            function FeaturedProducts(el) {
                var _this = this;

                _classCallCheck(this, FeaturedProducts);

                this.$el = $(el);
                this.$wrapper = this.$el.find('[data-featured-products-outer]');
                this.$collection = this.$wrapper.find('[data-featured-products]');
                this.$active = this._getActive();

                this.$el.imagesLoaded(function () {
                    _this._bindEvents();

                    for (var i = 0; i < _this.$collection.length; i++) {
                        var $collection = _this.$collection.eq(i);
                        _this._initSlick($collection);
                    }
                });
            }

            FeaturedProducts.prototype._bindEvents = function _bindEvents() {
                var _this2 = this;

                this.$active.on('init', function () {
                    _this2._setHeight();
                    _this2.$wrapper.addClass('processed');
                });

                $(window).on('resize', _.debounce(this._setHeight.bind(this), 100));

                this.$el.on('click', '[data-featured-products-button]', function (event) {
                    event.preventDefault();
                    _this2._updateCollection(event);
                });
            };

            FeaturedProducts.prototype._getActive = function _getActive() {
                return this.$wrapper.children('.active');
            };

            FeaturedProducts.prototype._initSlick = function _initSlick($collection) {
                var prev = $collection.next().find('[data-featured-products-previous]');
                var next = $collection.next().find('[data-featured-products-next]');

                $collection.slick({
                    infinite: false,
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    prevArrow: prev,
                    nextArrow: next,
                    responsive: [{
                        breakpoint: 960,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4
                        }
                    }, {
                        breakpoint: 720,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 3
                        }
                    }, {
                        breakpoint: 500,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 2
                        }
                    }]
                });
            };

            FeaturedProducts.prototype._setHeight = function _setHeight() {
                this.$wrapper.height(this.$active.height());
            };

            FeaturedProducts.prototype._updateCollection = function _updateCollection(event) {
                var $target = $(event.currentTarget).parent();
                var index = $target.index();

                $target.addClass('active').siblings().removeClass('active');

                this.$collection.parent().eq(index).addClass('active').siblings().removeClass('active');

                this.$active = this._getActive();
                this._setHeight();
            };

            return FeaturedProducts;
        })();

        exports['default'] = FeaturedProducts;
        module.exports = exports['default'];

    }, {}],
    15: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;

        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError('Cannot call a class as a function');
            }
        }

        var Map = (function () {
            function Map(el) {
                var _this = this;

                _classCallCheck(this, Map);

                var $el = $(el);
                var key = $el.data('map-api');
                $.getScript('https://maps.googleapis.com/maps/api/js?key=' + key).then(function () {
                    $el.each(function (i, el) {
                        _this.buildMap(el);
                    });
                });
            }

            Map.prototype.buildMap = function buildMap(el) {
                var _this2 = this;

                var $el = $(el);
                var sectionId = $el.data('section-id');
                var apiKey = $el.data('map-api');
                var address = $el.data('map-address');
                var hours = $el.data('map-hours') != '' ? $el.data('map-hours') : false;
                var style = $el.data('map-style') != '' ? $el.data('map-style') : false;
                var image = $el.data('map-image') ? $el.data('map-image') : false;
                var info = undefined;

                var geocoder = new google.maps.Geocoder();

                if (hours) {
                    info = new google.maps.InfoWindow({
                        content: hours
                    });
                }

                geocoder.geocode({'address': address}, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        (function () {

                            var mapOptions = {
                                zoom: 12,
                                center: results[0].geometry.location,
                                styles: style
                            };

                            var map = new google.maps.Map(document.getElementById('index-map-' + sectionId), mapOptions);

                            var marker = new google.maps.Marker({
                                map: map,
                                position: results[0].geometry.location
                            });

                            if (hours) {
                                marker.addListener('click', function () {
                                    info.open(map, marker);
                                });
                            }
                        })();
                    } else {
                        console.error('Google Maps geocode was not successful for the following reason: ' + status);

                        if (image) {
                            var $map = _this2.$el.find('[data-map-content]');
                            var newImg = new Image();
                            newImg.src = _this2.image;
                            $map[0].appendChild(newImg);
                        }
                    }
                });
            };

            return Map;
        })();

        exports['default'] = Map;
        module.exports = exports['default'];

    }, {}],
    16: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {'default': obj};
        }

        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError('Cannot call a class as a function');
            }
        }

        var _snippetsProductItem = require("../snippets/ProductItem");

        var _snippetsProductItem2 = _interopRequireDefault(_snippetsProductItem);

        var ProductRecommendations = (function () {
            function ProductRecommendations() {
                _classCallCheck(this, ProductRecommendations);

                this._loadProductRecommendationsIntoSection();
            }

            ProductRecommendations.prototype._loadProductRecommendationsIntoSection = function _loadProductRecommendationsIntoSection() {
                var productRecommendationsSection = document.querySelector('.product-recommendations-wrapper');

                if (productRecommendationsSection === null) {
                    return;
                }

                var productId = productRecommendationsSection.dataset.productId;
                var limit = productRecommendationsSection.dataset.limit;
                var requestUrl = '/recommendations/products?section_id=product-recommendations&limit=' + limit + '&product_id=' + productId;

                var request = new XMLHttpRequest();
                request.open('GET', requestUrl);
                request.onload = function () {
                    if (request.status >= 200 && request.status < 300) {
                        var container = document.createElement('div');
                        container.innerHTML = request.response;
                        productRecommendationsSection.parentElement.innerHTML = container.querySelector('.product-recommendations-wrapper').innerHTML;
                        $(document.body).trigger('currency-reset');
                        new _snippetsProductItem2['default']('[data-product-recommendations-inner]');
                    }
                };
                request.send();
            };

            return ProductRecommendations;
        })();

        exports['default'] = ProductRecommendations;
        module.exports = exports['default'];

    }, {"../snippets/ProductItem": 27}],
    17: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;

        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError('Cannot call a class as a function');
            }
        }

        var Slideshow = (function () {
            function Slideshow(section) {
                _classCallCheck(this, Slideshow);

                this.data = section.data;

                if (this.data.slideshowEnabled) {
                    this.$el = $(section.el);
                    this.$slideshow = this.$el.find('[data-slideshow]');

                    this.$slideshow.fitVids();
                    this.$slideshow.toggleClass('has-dots', this.data.hasDots);
                    this._initSlideshow();
                }
            }

            Slideshow.prototype._initSlideshow = function _initSlideshow() {
                this.$slideshow.slick({
                    autoplay: this.data.autoplay,
                    autoplaySpeed: this.data.speed,
                    arrows: this.data.slideshowEnabled,
                    nextArrow: this.data.iconNext,
                    prevArrow: this.data.iconPrevious,
                    dots: this.data.hasDots,
                    centerMode: true,
                    centerPadding: '6%',
                    responsive: [ {
                        breakpoint: 600,
                        settings: {
                            centerMode: false
                        }
                    } ]
                });
            };

            Slideshow.prototype.selectBlock = function selectBlock(_ref) {
                var blockId = _ref.blockId;

                var $slide = this.$slideshow.find('[data-slideshow-item="' + blockId + '"]');
                var slideIndex = $slide.data('slick-index');

                this.$slideshow.slick('slickGoTo', slideIndex);
                this.$slideshow.slick('slickPause');
            };

            Slideshow.prototype.deselectBlock = function deselectBlock() {
                if (this.data.autoplay) {
                    this.$slideshow.slick('slickPlay');
                }
            };

            Slideshow.prototype.unloadSection = function unloadSection() {
                if (this.data.slideshowEnabled) {
                    this.$slideshow.slick('unslick');
                }
            };

            Slideshow.prototype.selectSection = function selectSection(_ref2) {
                var sectionId = _ref2.sectionId;

                if (sectionId === 'hero') {
                    $('[data-header]').trigger('check-fullbleed');
                }
            };

            return Slideshow;
        })();

        exports['default'] = Slideshow;
        module.exports = exports['default'];

    }, {}],
    18: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {'default': obj};
        }

        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError('Cannot call a class as a function');
            }
        }

        var _scriptjs = require('scriptjs');

        var _scriptjs2 = _interopRequireDefault(_scriptjs);

        var Video = (function () {
            function Video(el) {
                _classCallCheck(this, Video);

                this.$el = $(el);
                this.$cover = this.$el.find('[data-video-cover]');
                this.$play = this.$el.find('[data-video-play]');
                this.sectionId = this.$el.data('section-id');
                this.id = this.$el.data('video-id');
                this.type = this.$el.data('video-type');

                this._initVideo();
                this._bindEvents();
            }

            Video.prototype._bindEvents = function _bindEvents() {
                var _this = this;

                this.$play.on('click.video', function () {
                    _this._startVideo();
                });
            };

            Video.prototype._initVideo = function _initVideo() {
                var _this2 = this;

                if (this.type === 'youtube') {
                    (function () {
                        var videoOptions = {
                            height: '390',
                            width: '640',
                            videoId: _this2.id
                        };

                        if (window.onYouTubeIframeAPIReady) {
                            _this2._buildPlayer(videoOptions);
                        } else {
                            _scriptjs2['default']('https://www.youtube.com/iframe_api', function () {
                                window.onYouTubeIframeAPIReady = function () {
                                    _this2._buildPlayer(videoOptions);
                                };
                            });
                        }
                    })();
                } else if (this.type === 'vimeo') {
                    (function () {
                        var videoOptions = {
                            width: '640',
                            id: _this2.id
                        };

                        if (window.Vimeo) {
                            _this2._buildPlayer(videoOptions);
                        } else {
                            _scriptjs2['default']('https://player.vimeo.com/api/player.js', function () {
                                _this2._buildPlayer(videoOptions);
                            });
                        }
                    })();
                }
            };

            Video.prototype._buildPlayer = function _buildPlayer(videoOptions) {
                var _this3 = this;

                if (this.type === 'youtube') {
                    this.player = new YT.Player('video-player-' + this.sectionId, videoOptions);
                } else if (this.type === 'vimeo') {
                    this.player = new Vimeo.Player('video-player-' + this.sectionId, videoOptions);
                }

                setTimeout(function () {
                    _this3.$el.fitVids();
                }, 200);
            };

            Video.prototype._startVideo = function _startVideo() {
                this.$cover.addClass('visibly-hidden');

                if (this.type === 'youtube') {
                    this.player.playVideo();
                } else if (this.type === 'vimeo') {
                    this.player.play();
                }
            };

            return Video;
        })();

        exports['default'] = Video;
        module.exports = exports['default'];

    }, {"scriptjs": 2}],
    19: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {'default': obj};
        }

        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError('Cannot call a class as a function');
            }
        }

        var _globalCurrencySaver = require('../global/currencySaver');

        var _globalCurrencySaver2 = _interopRequireDefault(_globalCurrencySaver);

        var CurrencySwitcher = (function () {
            function CurrencySwitcher() {
                _classCallCheck(this, CurrencySwitcher);

                this.$window = $(window);
                this.$body = $(document.body);
                this.$el = $('[name="currencies"]');
                this.$currencySvg = this.$el.next('[data-currency-selected]').find('svg use');
                this.$footerCurrencySvg = $('[data-footer-currency-toggle] svg use');
                Currency.format = Theme.currencySwitcherFormat;
                Currency.money_with_currency_format = {};
                Currency.money_with_currency_format[Theme.currency] = Theme.moneyFormatCurrency;
                Currency.money_format = {};
                Currency.money_format[Theme.currency] = Theme.moneyFormat;
                this.cookieCurrency = Currency.cookie.read();

                if (this.cookieCurrency) {
                    this.$el.val(this.cookieCurrency);
                }

                this._bindEvents();
            }

            CurrencySwitcher.prototype._bindEvents = function _bindEvents() {
                var _this = this;

                this.$el.on('change.currency', function (event) {
                    _this._convertAll(event);
                });

                this.$body.on('currency-reset.currency', function () {
                    _this._reset();
                });

                // save the current price
                _globalCurrencySaver2['default'](this.$body);

                this._switchCurrency();

                this.$currencySvg.attr('xlink:href', '#currency-' + Currency.currentCurrency);
                this.$footerCurrencySvg.attr('xlink:href', '#currency-' + Currency.currentCurrency);

                this.$el.closest('[data-currency-switcher]').addClass('currency-switcher--initialized');
            };

            CurrencySwitcher.prototype._reset = function _reset() {
                Currency.convertAll(Theme.currency, this.$el.val());
            };

            CurrencySwitcher.prototype._switchCurrency = function _switchCurrency() {
                if (this.cookieCurrency === null) {
                    Currency.currentCurrency = Theme.currency;
                } else if (this.$el.length && this.$el.find('option[value=' + this.cookieCurrency + ']').length === 0) {
                    // If the cookie value does not correspond to any value in the currency dropdown
                    Currency.currentCurrency = Theme.currency;
                    Currency.cookie.write(Theme.currency);
                } else if (this.cookieCurrency === Theme.currency) {
                    Currency.currentCurrency = Theme.currency;
                } else {
                    Currency.convertAll(Theme.currency, this.cookieCurrency);
                }
            };

            CurrencySwitcher.prototype._convertAll = function _convertAll(event, variant, selector) {
                var newCurrency = $(event.target).val();

                Currency.convertAll(Currency.currentCurrency, newCurrency);
                this.$currencySvg.attr('xlink:href', '#currency-' + Currency.currentCurrency);
                this.$footerCurrencySvg.attr('xlink:href', '#currency-' + Currency.currentCurrency);

                this.cookieCurrency = newCurrency;
            };

            CurrencySwitcher.prototype.unload = function unload() {
                this.$body.off('.currency');
                this.$el.off('.currency');
            };

            return CurrencySwitcher;
        })();

        exports['default'] = CurrencySwitcher;
        module.exports = exports['default'];

    }, {"../global/currencySaver": 8}],
    20: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;

        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError('Cannot call a class as a function');
            }
        }

        var FooterTapbar = (function () {
            function FooterTapbar(el) {
                _classCallCheck(this, FooterTapbar);

                this.$el = $(el);
                this.$window = $(window);
                this.$content = this.$el.find('[data-footer-content]');

                this.isOpen = false;
                this.contentOpen = false;
                this.layout = 'large';

                this._setAccountIcon();

                this._bindEvents();
            }

            FooterTapbar.prototype._bindEvents = function _bindEvents() {
                var _this = this;

                this.$el.on('click', '[data-footer-currency-toggle]', function (event) {
                    event.preventDefault();
                    _this._toggleContent(event, 'currency');
                });

                this.$el.on('click', '[data-footer-account-toggle]', function (event) {
                    location.href = '/account';
                    event.preventDefault();
                    _this._toggleContent(event, 'account');
                });

                this.$el.on('click', '[data-footer-search-toggle]', function (event) {
                    event.preventDefault();
                    _this._toggleContent(event, 'search');
                });

                this.$el.on('focus', '[data-footer-search] .form-input', function (event) {
                    event.preventDefault();
                    $(window).off('scroll.header');
                    _this._focusSearch(event);
                });

                this.$el.on('blur', '[data-footer-search] .form-input', function (event) {
                    event.preventDefault();
                    $(window).trigger('bind-header-scroll');
                    _this._blurSearch(event);
                });

                this.$el.on('click', '[data-footer-currency] button', function (event) {
                    event.preventDefault();
                    _this._switchCurrency(event);
                });

                this.$window.on('resize', _.debounce(this._moveAccountContent.bind(this), 50)).trigger('resize');
            };

            FooterTapbar.prototype._getAccountContentHeights = function _getAccountContentHeights(type) {
                var $item = this.$el.find('[data-footer-' + type + ']');
                return $item.outerHeight();
            };

            FooterTapbar.prototype._toggleContent = function _toggleContent(event, type) {
                var $target = $(event.currentTarget);
                var newHeight = this._getAccountContentHeights(type);
                var height = this.isOpen ? 0 : newHeight;
                var offset = undefined;
                this.$content.height(height);

                this.$content.children('[data-footer-content-item="' + type + '"]').addClass('active').siblings().removeClass('active');

                if (this.isOpen && this.contentOpen !== type) {
                    this.$content.height(newHeight);
                    this.isOpen = true;
                } else {
                    this.isOpen = !this.isOpen;
                }

                $target.parent('li').toggleClass('active', this.isOpen).siblings().removeClass('active');

                this.contentOpen = this.isOpen ? type : false;
            };

            FooterTapbar.prototype._blurSearch = function _blurSearch() {
                var offset = parseInt(document.body.style.top, 10);
                document.body.classList.remove('footer-search-focused');
                document.body.scrollTop = offset * -1;
            };

            FooterTapbar.prototype._focusSearch = function _focusSearch() {
                var offset = document.body.scrollTop;
                document.body.style.top = offset * -1 + 'px';
                document.body.classList.add('footer-search-focused');
            };

            FooterTapbar.prototype._moveAccountContent = function _moveAccountContent() {
                var windowWidth = window.innerWidth;

                if (windowWidth > 720 && this.layout !== 'large') {
                    var $accountContent = $('[data-footer-account] [data-account-dropdown]').detach();
                    $accountContent.prependTo('[data-header-account-dropdown-wrapper]');
                    this.layout = 'large';
                } else if (windowWidth <= 720 && this.layout !== 'small') {
                    var $accountContent = $('[data-header-account-dropdown-wrapper] [data-account-dropdown]').detach();
                    $accountContent.appendTo('[data-footer-account]');
                    this.layout = 'small';
                }
            };

            FooterTapbar.prototype._switchCurrency = function _switchCurrency(event) {
                var $target = $(event.currentTarget),
                    currencyValue = $target.val();

                $('select#currencies').val(currencyValue).trigger('change');
            };

            FooterTapbar.prototype._setAccountIcon = function _setAccountIcon() {
                var $headerAccount = $(document.body).find('[data-header-account] > a use');
                if (!$headerAccount.length) return;

                var id = $headerAccount.attr('xlink:href');
                var $footerAccount = this.$el.find('[data-footer-account-toggle]');
                var iconStyle = id.split('#icon-account-')[1];

                $footerAccount.addClass('footer-account-toggle--style-' + iconStyle).find('use').attr('xlink:href', id);
            };

            return FooterTapbar;
        })();

        exports['default'] = FooterTapbar;
        module.exports = exports['default'];

    }, {}],
    21: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {'default': obj};
        }

        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError('Cannot call a class as a function');
            }
        }

        var _CurrencySwitcher = require('./CurrencySwitcher');

        var _CurrencySwitcher2 = _interopRequireDefault(_CurrencySwitcher);

        var _Search = require('./Search');

        var _Search2 = _interopRequireDefault(_Search);

        var _HeaderAccountDropdown = require('./HeaderAccountDropdown');

        var _HeaderAccountDropdown2 = _interopRequireDefault(_HeaderAccountDropdown);

        var Header = (function () {
            function Header(section) {
                _classCallCheck(this, Header);

                this.data = section.data;
                this.$window = $(window);
                this.$body = $(document.body);
                this.$el = $(section.el);
                this.$header = this.$el.closest('[data-header]');
                this.$tapbar = $('[data-footer-tapbar]');

                if (Theme.currencySwitcher) {
                    this.currencySwitcher = new _CurrencySwitcher2['default']();
                }

                new _HeaderAccountDropdown2['default']('[data-header-account]');

                if (Modernizr.flexbox) {
                    new _Search2['default']('[data-header-search-form]');
                }

                this._bindEvents();
                this._checkFullBleed();

                this.$window.on('load', this._onWindowResize.bind(this));
            }

            Header.prototype._bindEvents = function _bindEvents() {
                var _this = this;

                this._bindHeaderScroll();

                this.$window.on('bind-header-scroll', function () {
                    _this._bindHeaderScroll();
                });

                this.$window.on('resize', _.debounce(this._onWindowResize.bind(this), 100));
                this.$header.on('check-fullbleed', this._checkFullBleed.bind(this));
            };

            Header.prototype._bindHeaderScroll = function _bindHeaderScroll() {
                var _this2 = this;

                this.$window.on('scroll.header', function () {
                    if (window.innerWidth <= 720 && !_this2.checkingSticky && !_this2.$body.hasClass('scroll-locked')) {
                        _this2.checkingSticky = true;
                        setTimeout(_this2._checkSticky.bind(_this2), 250);
                    }
                });
            };

            Header.prototype._onWindowResize = function _onWindowResize() {
                this._getDocumentHeights();
                this._setBodyPadding();
            };

            Header.prototype._getDocumentHeights = function _getDocumentHeights() {
                this.documentHeight = $(document).height();
                this.windowHeight = this.$window.height();
            };

            Header.prototype._setBodyPadding = function _setBodyPadding() {
                if (window.innerWidth <= 720) {
                    this.$body.css({
                        'padding-top': this.$header.outerHeight()
                    });
                }
            };

            Header.prototype._checkSticky = function _checkSticky() {
                var topPosition = this.$window.scrollTop();
                var direction = this.topPosition > topPosition ? 'up' : 'down';
                var offset = 100;

                var distanceMoved = this.topPosition - topPosition;
                var adequateDistance = Math.abs(distanceMoved) > 40;
                var hideBars = direction === 'down' && topPosition > offset ? true : false;
                var hideTapbar = hideBars && this.documentHeight - offset > topPosition + this.$window.height() ? true : false;

                if (adequateDistance) {
                    this.$header.toggleClass('out-of-view', hideBars);
                    this.$tapbar.toggleClass('out-of-view', hideTapbar);
                }

                this.topPosition = topPosition;
                this.checkingSticky = false;
            };

            Header.prototype._checkFullBleed = function _checkFullBleed() {
                var hasHero = !!document.querySelector('[data-section-id="hero"]');
                var isIndex = this.$body.hasClass('template-index');

                this.$header.toggleClass('is-fullbleed', this.data.isFullBleed && hasHero && isIndex).toggleClass('no-border', !this.data.isFullBleed && hasHero && isIndex);
            };

            Header.prototype.unloadSection = function unloadSection() {
                this.currencySwitcher.unload();
            };

            return Header;
        })();

        exports['default'] = Header;
        module.exports = exports['default'];

    }, {"./CurrencySwitcher": 19, "./HeaderAccountDropdown": 22, "./Search": 28}],
    22: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;

        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError('Cannot call a class as a function');
            }
        }

        var HeaderAccountDropdown = (function () {
            function HeaderAccountDropdown(el) {
                _classCallCheck(this, HeaderAccountDropdown);

                this.$el = $(el);
                this.$recentlyViewed = this.$el.find('[data-header-account-recent-items]');

                this._setupAccessibility();
                this._checkRecentlyViewed();
            }

            HeaderAccountDropdown.prototype._setupAccessibility = function _setupAccessibility() {
                var _this = this;

                this.$el.on('focus blur', '[data-header-account-dropdown-item]', function (event) {
                    _this.$el.toggleClass('active', !_this.$el.hasClass('active'));
                });
            };

            HeaderAccountDropdown.prototype._checkRecentlyViewed = function _checkRecentlyViewed() {
                var recentlyViewed = localStorage.getItem('recentlyViewed');
                recentlyViewed = recentlyViewed != null ? JSON.parse(recentlyViewed) : false;

                if (recentlyViewed) {
                    this.$el.find('[data-header-account-recent]').addClass('visible');
                    this._buildRecentlyViewed(recentlyViewed);
                } else {
                    this.$el.find('[data-header-account-recent]').remove();
                }
            };

            HeaderAccountDropdown.prototype._buildRecentlyViewed = function _buildRecentlyViewed(recentlyViewed) {
                var _this2 = this;

                var handle = recentlyViewed.shift();

                Shopify.getProduct(handle, function (item) {
                    var image = Shopify.resizeImage(item.featured_image, '100x');
                    var priceMin = Shopify.formatMoney(item.price_min, Theme.moneyFormant);
                    var price = item.price_varies ? priceMin + ' +' : priceMin;

                    var sale = item.compare_at_price_min > item.price_min ? true : false;
                    var percent = Theme.localization.header.percentOff.replace('*percent*', Math.round((1 - item.price / item.compare_at_price_min) * 100) + '%');
                    var percentOff = sale ? '<span class="module-sale">' + percent + '</span>' : '';

                    _this2.$recentlyViewed.append('\n        <li class="grid module-order-item">\n          <figure class="grid-item">\n            <a href="' + item.url + '" tabindex="-1">\n              <img src="' + image + '" alt="' + item.title + '">\n            </a>\n          </figure>\n          <div class="grid-item">\n            <span class="module-price"><a href="' + item.url + '" data-header-account-dropdown-item>' + item.title + '</a></span>\n            <span class="money">' + price + '</span>\n            ' + percentOff + '\n          </div>\n        </li>\n      ');
                });
            };

            return HeaderAccountDropdown;
        })();

        exports['default'] = HeaderAccountDropdown;
        module.exports = exports['default'];

    }, {}],
    23: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;

        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError('Cannot call a class as a function');
            }
        }

        var MailingList = (function () {
            function MailingList(el) {
                _classCallCheck(this, MailingList);

                this.$el = $(el);
                this.$body = $(document.body);

                this._bindEvents();
            }

            MailingList.prototype._bindEvents = function _bindEvents() {
                var _this = this;

                this.$el.on('change', 'select', function (event) {
                    _this._updateFormTags(event);
                });
            };

            MailingList.prototype._updateFormTags = function _updateFormTags(event) {
                var tags = $(event.currentTarget).val();
                this.$el.find('[data-mailing-list-tags]').val(tags);
            };

            return MailingList;
        })();

        exports['default'] = MailingList;
        module.exports = exports['default'];

    }, {}],
    24: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {'default': obj};
        }

        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError('Cannot call a class as a function');
            }
        }

        var _NavigationSuper = require('./NavigationSuper');

        var _NavigationSuper2 = _interopRequireDefault(_NavigationSuper);

        var Navigation = (function () {
            function Navigation(el) {
                _classCallCheck(this, Navigation);

                this.$el = $(el);

                this._initMegaMenus();
                this._positionDropdowns();

                this._setupAccessibility();
                this._bindEvents();

                if ($(document.body).hasClass('is-mobile')) {
                    this._bindMobileEvents();
                }
            }

            Navigation.prototype._initMegaMenus = function _initMegaMenus() {
                var $megaMenu = this.$el.find('[data-navigation-super]');
                if ($megaMenu.length) {
                    for (var i = 0; i < $megaMenu.length; i++) {
                        new _NavigationSuper2['default']($megaMenu.eq(i));
                    }
                }
            };

            Navigation.prototype._setupAccessibility = function _setupAccessibility() {
                this.$el.on('focus blur', '[data-navigation-dropdown-item]', function (event) {
                    var $parent = $(event.currentTarget).closest('[data-navigation-item]');
                    $parent.toggleClass('active', !$parent.hasClass('active'));
                });
            };

            Navigation.prototype._bindEvents = function _bindEvents() {
                $(window).on('resize', _.debounce(this._positionDropdowns.bind(this), 100));
            };

            Navigation.prototype._bindMobileEvents = function _bindMobileEvents() {
                var _this = this;

                this.$el.on('click', '.has-super-nav > a, .has-dropdown > a, [data-navigation-super] [data-navigation-dropdown-item]', function (event) {
                    var $parent = $(event.currentTarget).closest('[data-navigation-item]');

                    if (!$parent.hasClass('active')) {
                        event.preventDefault();
                    }

                    $parent.toggleClass('active', !$parent.hasClass('active')).siblings().removeClass('active');
                });

                $(document.body).on('click', function (event) {
                    if (!$(event.target).closest('[data-header]').length) {
                        _this.$el.find('[data-navigation-item]').removeClass('active');
                    }
                });
            };

            Navigation.prototype._positionDropdowns = function _positionDropdowns() {
                var $secondaryDropdown = this.$el.find('.navigation-dropdown-simple.secondary');

                if ($secondaryDropdown.length) {
                    var containerRect = this.$el[0].getBoundingClientRect();

                    for (var i = 0; i < $secondaryDropdown.length; i++) {
                        var $currentDropdown = $secondaryDropdown.eq(i);
                        var dropdownRect = $currentDropdown[0].getBoundingClientRect();

                        if (dropdownRect.right > containerRect.right) {
                            $currentDropdown.addClass('alt-alignment');
                        } else if (containerRect.right > dropdownRect.right + dropdownRect.width * 2) {
                            $currentDropdown.removeClass('alt-alignment');
                        }
                    }
                }
            };

            return Navigation;
        })();

        exports['default'] = Navigation;
        module.exports = exports['default'];

    }, {"./NavigationSuper": 26}],
    25: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;

        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError('Cannot call a class as a function');
            }
        }

        var NavigationMobile = (function () {
            function NavigationMobile(el) {
                _classCallCheck(this, NavigationMobile);

                this.$el = $(el);
                this.$window = $(window);
                this.$body = $(document.body);
                this.$header = $('[data-header]');
                this.$toggle = this.$header.find('[data-navigation-toggle]');
                this.layout = 'desktop';
                this.windowWidth = window.innerWidth;

                this._bindEvents();
            }

            NavigationMobile.prototype._bindEvents = function _bindEvents() {
                var _this = this;

                this.$header.on('click', '[data-navigation-toggle]', function (event) {
                    event.preventDefault();
                    if (_this.$el.revealer('isVisible')) {
                        _this._closeMenu();
                    } else {
                        _this._openMenu();
                    }
                });

                this.$el.on('click', '.navigation-list-item-inner:not(.not-move)', function (event) {
                    event.preventDefault();
                    _this._toggleTier(event);
                });

                this.$window.on('resize', _.debounce(this._resize.bind(this), 100)).trigger('resize');
            };

            NavigationMobile.prototype._resize = function _resize() {
                // if (this.$window.width() > 720 && this.layout === 'mobile') {
                //     this.layout = 'desktop';
                //     this.$footer = $('[data-footer]').detach();
                //     this.$footer.appendTo('[data-footer-wrapper]');
                // } else if (this.$window.width() <= 720 && this.layout === 'desktop') {
                //     this.layout = 'mobile';
                //     this.$footer = $('[data-footer]').detach();
                //     this.$footer.appendTo('[data-mobile-navigation]');
                // }

                if (this.windowWidth === window.innerWidth) {
                    return false;
                }

                this._closeMenu();
            };

            NavigationMobile.prototype._openMenu = function _openMenu() {
                this.$header.addClass('mobile-navigation-open');
                this.$body.addClass('scroll-locked');
                this.$el.revealer('show');
                this.$toggle.addClass('active');

                this.$el.css({
                    'height': '' + (this.$window.height() - this.$header.outerHeight())
                });
            };

            NavigationMobile.prototype._closeMenu = function _closeMenu() {
                this.$header.removeClass('mobile-navigation-open');
                this.$body.removeClass('scroll-locked');
                this.$el.revealer('hide');
                this.$toggle.removeClass('active');
            };

            NavigationMobile.prototype._toggleTier = function _toggleTier(event) {
                var $target = $(event.currentTarget);
                var $targetItem = $target.closest('[data-navigation-item]');
                var $use = $target.find('use');
                var $targetSubmenu = $targetItem.find('#' + $target.attr('aria-controls'));

                if ($targetItem.hasClass('active')) {
                    $target.attr('aria-expanded', false);
                    $use.attr('xlink:href', '#icon-plus');
                    $targetItem.removeClass('active');
                    $targetSubmenu.attr('aria-hidden', true);
                } else {
                    $target.attr('aria-expanded', true);
                    $use.attr('xlink:href', '#icon-minus');
                    $targetItem.addClass('active');
                    $targetSubmenu.attr('aria-hidden', false);
                }

                this._closeChildTiers($targetItem.siblings());
            };

            NavigationMobile.prototype._closeChildTiers = function _closeChildTiers($target) {
                $target.removeClass('active').find('.active').removeClass('active');

                $target.find('use').attr('xlink:href', '#icon-plus');
            };

            return NavigationMobile;
        })();

        exports['default'] = NavigationMobile;
        module.exports = exports['default'];

    }, {}],
    26: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;

        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError('Cannot call a class as a function');
            }
        }

        var NavigationSuper = (function () {
            function NavigationSuper($el) {
                var _this = this;

                _classCallCheck(this, NavigationSuper);

                this.$body = $(document.body);
                this.$el = $el;
                this.$departments = this.$el.find('[data-navigation-super-departments]');
                this.$collections = this.$el.find('[data-navigation-super-collections]');
                this.$defaultContent = this.$el.find('[data-navigation-super-default]');
                this.loading = false;
                this.$currentDepartment = this.$defaultContent;

                this.$defaultContent.imagesLoaded(function () {
                    _this.departmentsHeight = _this.$departments.outerHeight();

                    _this.$defaultContent.height(_this.departmentsHeight);
                    _this.$collections.height(_this.departmentsHeight);
                });

                this._bindEvents();
                this._setupAccessibility();

                if (this.$body.hasClass('is-mobile')) {
                    this._bindMobileEvents();
                }
            }

            NavigationSuper.prototype._bindEvents = function _bindEvents() {
                var _this2 = this;

                var timeout = undefined;
                var setupDepartmentSwitch = function setupDepartmentSwitch(event) {
                    if (!_this2.loading) {
                        _this2.loading = true;
                        if ($(event.currentTarget).data('navigation-dropdown-item') === 'default') {
                            _this2._resetDepartments();
                        } else {
                            _this2._switchDepartments(event);
                        }
                    }
                };

                this.$departments.on('mouseenter focus', '.navigation-super-department', function (event) {
                    timeout = setTimeout(setupDepartmentSwitch.bind(_this2, event), 200);
                });

                this.$departments.on('mouseleave blur', '.navigation-super-department', function () {
                    clearTimeout(timeout);
                });

                $('.has-super-nav').on('mouseleave blur', function () {
                    _this2._resetDepartments(null);
                });

                $(window).on('resize', _.debounce(this._setNavContentHeight.bind(this), 100));
            };

            NavigationSuper.prototype._navTriggerOverride = function _navTriggerOverride(event) {
                var $target = $(event.currentTarget),
                    targetHandle = $target.data('navigation-dropdown-item');

                if (targetHandle.length) {
                    var $collectionNavItem = this.$el.find('[data-navigation-super-collection-parent]').find('#' + targetHandle);
                    $collectionNavItem.toggleClass('focused', !$collectionNavItem.hasClass('focused'));

                    var $departmentWrapper = $target.closest('[data-navigation-super-department-wrapper]');
                    if (!$departmentWrapper.hasClass('active')) {
                        if (!this.loading) {
                            this.loading = true;
                            var $department = $departmentWrapper.children('a');
                            this._switchDepartments(null, $department);
                        }
                    }
                }
            };

            NavigationSuper.prototype._bindMobileEvents = function _bindMobileEvents() {
                var _this3 = this;

                this.$departments.on('click', '[data-navigation-dropdown-item]', function (event) {
                    _this3._navTriggerOverride(event);
                });
            };

            NavigationSuper.prototype._setupAccessibility = function _setupAccessibility() {
                var _this4 = this;

                this.$departments.on('focus blur', '[data-navigation-dropdown-item]', function (event) {
                    _this4._navTriggerOverride(event);
                });
            };

            NavigationSuper.prototype._switchDepartments = function _switchDepartments(event, $department) {
                var _this5 = this;

                var $target = $department ? $department : $(event.currentTarget);
                var newDepartmentKey = $target.data('navigation-dropdown-item');
                var $newDepartment = this.$collections.find('[data-navigation-super-collection-parent="' + newDepartmentKey + '"]');

                if (newDepartmentKey === 'default' && this.$currentDepartment.is('[data-navigation-super-default]')) {
                    this.loading = false;
                    return;
                }

                $target.parent().addClass('active').siblings().removeClass('active');

                var $this = this.$collections.find('.visible');

                if ($this.length) {
                    $this.addClass('animating').removeClass('visible').one('trend', function () {
                        $this.removeClass('animating');
                        _this5._loadNewDepartment($newDepartment);
                    });
                } else {
                    this._loadNewDepartment($newDepartment);
                }
            };

            NavigationSuper.prototype._loadNewDepartment = function _loadNewDepartment($newDepartment) {
                var _this6 = this;

                $newDepartment.addClass('animating').attr('aria-hidden', false);

                this.$currentDepartment = $newDepartment;
                this._setNavContentHeight();

                setTimeout(function () {
                    $newDepartment.toggleClass('animating visible');
                    _this6.loading = false;
                }, 75);
            };

            NavigationSuper.prototype._resetDepartments = function _resetDepartments() {
                var _this7 = this;

                if (this.$defaultContent.is('.visible')) {
                    this.loading = false;
                    return;
                }

                this.$departments.find('[data-navigation-super-department-wrapper]').removeClass('active');
                this.$collections.find('.visible').removeClass('visible');

                this.$defaultContent.addClass('animating').one('trend', function () {
                    _this7.$defaultContent.addClass('visible').removeClass('animating');
                });

                setTimeout(function () {
                    _this7.$currentDepartment.attr('aria-hidden', true);

                    _this7.$currentDepartment = _this7.$defaultContent;

                    _this7.$currentDepartment.attr('aria-hidden', false);

                    _this7._setNavContentHeight();
                    _this7.loading = false;
                }, 150);
            };

            NavigationSuper.prototype._setNavContentHeight = function _setNavContentHeight() {
                var newHeight = this.$currentDepartment.outerHeight();

                if (this.$currentDepartment.hasClass('navigation-super-default')) {
                    newHeight = this.$currentDepartment.height();
                }

                this.$collections.height(newHeight > this.departmentsHeight ? newHeight : this.departmentsHeight);
            };

            return NavigationSuper;
        })();

        exports['default'] = NavigationSuper;
        module.exports = exports['default'];

    }, {}],
    27: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;

        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError('Cannot call a class as a function');
            }
        }

        var ProductItem = (function () {
            function ProductItem(el) {
                var _this = this;

                _classCallCheck(this, ProductItem);

                this.$window = $(window);
                this.$body = $(document.body);
                this.$el = $(el);

                this._bindEvents();
                this._setupAccessibility();

                this.$el.imagesLoaded(function () {
                    _this._positionDetails();
                });
            }

            ProductItem.prototype._bindEvents = function _bindEvents() {
                this.$window.on('resize', _.debounce(this._positionDetails.bind(this), 100));
            };

            ProductItem.prototype._setupAccessibility = function _setupAccessibility() {
                this.$el.on('focus blur', '*', function (event) {
                    var $target = $(event.currentTarget);
                    $target.toggleClass('active', !$target.hasClass('active'));
                });
            };

            ProductItem.prototype._positionDetails = function _positionDetails() {
                if (this.$el[0] == undefined) {
                    return;
                }
                var collectionRight = this.$el[0].getBoundingClientRect().right;

                this.$el.find('[data-product-item]').each(function (i, el) {
                    var $product = $(el);
                    var productCoords = $product[0].getBoundingClientRect();

                    if (collectionRight < productCoords.right + productCoords.width * 1.5) {
                        $product.removeClass('on-right').addClass('on-left');
                    } else {
                        $product.removeClass('on-left').addClass('on-right');
                    }
                });
            };

            return ProductItem;
        })();

        exports['default'] = ProductItem;
        module.exports = exports['default'];

    }, {}],
    28: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;

        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError('Cannot call a class as a function');
            }
        }

        var Search = (function () {
            function Search(el) {
                _classCallCheck(this, Search);

                this.$el = $(el);
                this.$body = $(document.body);

                this.$header = $('[data-header]');
                this.$headerSearch = this.$header.find('.header-search-form-wrapper');
                this.$overlay = this.$header.find('[data-overlay]');

                this.$searchInput = this.$el.find('.form-input');
                this.$searchResultsWrapper = this.$el.children('[data-header-search-results-wrapper]');
                this.$searchResults = this.$searchResultsWrapper.children('[data-header-search-results]');
                this.$searchPlaceholderLinks = this.$searchResults.html();
                this.loaded = false;
                this.isOpen = false;
                this.speed = 200;

                this.currentSearch = undefined;

                this._bindEvents();
            }

            Search.prototype._bindEvents = function _bindEvents() {
                var _this = this;

                this.$el.on('focus', 'input', function () {
                    if (!_this.isOpen) {
                        _this._focusSearch();
                        _this.isOpen = true;
                    }
                });

                // this.$el.on('click', '[data-header-search-submit]', (event) => {
                //   if (!this.isOpen) {
                //     event.preventDefault();
                //     this._focusSearch();
                //     this.isOpen = true;
                //   }
                // });

                this.$body.on('click', function (event) {
                    if (!$(event.target).closest('[data-header-search-form]').length && _this.isOpen) {
                        _this._blurSearch();
                        _this.isOpen = false;
                    }
                });

                $(window).on('blur', function () {
                    if (_this.isOpen) {
                        _this._blurSearch();
                        _this.isOpen = false;
                    }
                });

                // $(window).on('load', () => {
                //   this.$searchResultsWrapper.height(this.$searchResultsWrapper.outerHeight());
                // });

                var debounceSetup = function debounceSetup(event) {
                    event.preventDefault();
                    if (event.which <= 90 && event.which >= 48 || event.which == 8) {
                        _this._getSearchTerm();
                    }
                };

                this.$el.on('keyup.searchQuery', 'input', _.debounce(debounceSetup, 500));
            };

            Search.prototype._focusSearch = function _focusSearch() {
                var _this2 = this;

                this.$header.addClass('search-open');
                this.$headerSearch.addClass('active');

                this.$searchResultsWrapper.revealer('show');

                setTimeout(function () {
                    _this2.initialHeight = _this2.$searchResults.outerHeight();
                    _this2.$searchResultsWrapper.height(_this2.initialHeight);
                }, this.speed);
            };

            Search.prototype._blurSearch = function _blurSearch() {
                var _this3 = this;

                this.$el.find('input').blur();

                this.$searchResultsWrapper.css('height', '0').revealer('hide');

                setTimeout(function () {
                    _this3.$header.removeClass('search-open');
                    _this3.$headerSearch.removeClass('active');
                    _this3._setPlaceholderLinks(false);
                    _this3.$body.removeClass('scroll-locked');
                }, this.speed);
            };

            Search.prototype._setPlaceholderLinks = function _setPlaceholderLinks(displayLinks) {
                var _this4 = this;

                if (this.$searchInput.val().length === 0) {
                    this.$searchResultsWrapper.height(this.initialHeight);

                    setTimeout(function () {
                        _this4.$searchResults.html(_this4.$searchPlaceholderLinks).toggleClass('visible', displayLinks);
                    }, this.speed);
                }
            };

            Search.prototype._getSearchTerm = function _getSearchTerm() {
                var _this5 = this;

                this.searchComplete = false;
                this.searchResultsArray = [];
                var query = this.$searchInput.val();

                if (query.length > 2) {
                    this._searchPages(query);

                    setTimeout(function () {
                        if (!_this5.$searchResultsWrapper.revealer('isVisible')) {
                            _this5.$searchResultsWrapper.revealer('show');
                        }
                    }, this.speed);
                } else {
                    this._cancelSearch();
                    this._setPlaceholderLinks(true);
                }
            };

            Search.prototype._searchPages = function _searchPages(query) {
                this._performSearch(query, 'page');
            };

            Search.prototype._searchProducts = function _searchProducts(query) {
                this._performSearch(query, 'product');
                this.searchComplete = true;
            };

            Search.prototype._performSearch = function _performSearch(query, queryType) {
                var _this6 = this;

                var url = '/search?type=' + queryType + '&q=';
                var title = queryType === 'page' ? 'Departments' : 'Products';
                var searchResultsArrayTemp = [];

                this._cancelSearch();

                this.currentSearch = $.getJSON(url + '*' + query + '*&view=json', function (data) {
                    if (data && data.results.length) {

                        $.each(data.results, function (index, item) {
                            if (queryType === 'product' || queryType == 'page' && item.type && item.type === 'department') {
                                searchResultsArrayTemp.push('\n              <li>\n                <a href="//' + Shopify.shop + item.url + '">' + item.title + '</a>\n              </li>\n            ');
                            }
                        });

                        var viewAll = searchResultsArrayTemp.length > 10 ? '<li><a class="header-search-viewall" href="' + url + query + '">' + Theme.localization.search.viewAll + '</a></li>' : '';

                        if (searchResultsArrayTemp.length) {
                            _this6.searchResultsArray.push('\n            <h5>' + title + '</h5>\n            <ul>\n              ' + searchResultsArrayTemp.slice(0, 10).join('') + '\n              ' + viewAll + '\n            </ul>\n          ');
                        }

                        if (_this6.searchComplete) {
                            _this6._openResultsPanel(url, query);
                        } else {
                            _this6._searchProducts(query);
                        }
                    } else {
                        if (_this6.searchComplete) {
                            if (_this6.searchResultsArray.length) {
                                _this6._openResultsPanel(url, query);
                            } else {
                                _this6._noResults();
                            }
                        } else {
                            _this6._searchProducts(query);
                        }
                    }
                });
            };

            Search.prototype._cancelSearch = function _cancelSearch() {
                if (this.currentSearch) {
                    this.currentSearch.abort();
                }
            };

            Search.prototype._openResultsPanel = function _openResultsPanel(url, query) {
                var _this7 = this;

                this.$searchResults.html('' + this.searchResultsArray.join(''));
                this.$searchResultsWrapper.height(this.$searchResults.outerHeight()).one('trend', function () {
                    _this7.$searchResults.addClass('visible');
                });
            };

            Search.prototype._noResults = function _noResults() {
                this.$searchResults.html('<span class="header-search-empty">' + Theme.localization.search.empty + '</span>');
                this.$searchResultsWrapper.height(this.$searchResults.outerHeight());
            };

            return Search;
        })();

        exports['default'] = Search;
        module.exports = exports['default'];

    }, {}],
    29: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;

        exports['default'] = function (el) {
            var $el = $(el);
            var imageCount = parseInt($el.data('instagram-count'), 10);
            var token = $el.data('instagram');
            var $followUs = $el.find('[data-instagram-user]');
            var url = 'https://api.instagram.com/v1/users/self/media/recent?access_token=' + token + '&count=50&callback=';

            $.ajax({
                method: 'GET',
                dataType: 'jsonp',
                url: url,
                success: function success(response) {
                    if (response.meta.code === 200) {
                        (function () {
                            var username = response.data[0].user.username;
                            var usernameCompiled = '<a href="//instagram.com/' + username + '">@' + username + '</a>';
                            var followUs = Theme.localization.modules.instagram.followUs.replace('*username*', usernameCompiled);
                            $followUs.html(followUs);

                            var images = [];
                            $.each(response.data, function (index, item) {
                                if (images.length < imageCount) {
                                    var image = '\n              <a class=\'instagram-item grid-item-16\' target=\'_blank\' href=\'' + item.link + '\'>\n                <figure style="background-image:url(\'' + item.images.low_resolution.url + '\')">\n                  <span class="instagram-overlay">\n                    <span class="instagram-count-wrapper">\n                      <span class="instagram-likes">\n                        ' + item.likes.count + '\n                        <svg><use xlink:href="#icon-heart"></use></svg>\n                      </span>\n                      <span class="instagram-comments">\n                        ' + item.comments.count + '\n                        <svg><use xlink:href="#icon-comment"></use></svg>\n                      </span>\n                    </span>\n                    <svg class="instagram-icon"><use xlink:href="#social-instagram"></use></svg>\n                  </span>\n                </figure>\n              </a>';
                                    images.push(image);
                                }
                            });

                            $el.children('[data-instagram-images]').html(images.join(''));
                        })();
                    } else {
                        console.error('There was an issue with your Instagram Access token.');
                    }
                },
                error: function error() {
                    console.error('There was an issue with your Instagram Access token.');
                }
            });
        };

        module.exports = exports['default'];

    }, {}],
    30: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;

        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError('Cannot call a class as a function');
            }
        }

        var Account = (function () {
            function Account(el) {
                _classCallCheck(this, Account);

                this.$el = $(el);
                this._bindEvents();

                if ($(document.body).hasClass('template-addresses')) {
                    this._setupProvinceSelectors();
                }

                if (window.location.hash === '#recover') {
                    this._toggleResetPasswordForm();
                }
            }

            Account.prototype._bindEvents = function _bindEvents() {
                var _this = this;

                this.$el.on('click', '[data-account-reset-password-toggle]', function (event) {
                    event.preventDefault();
                    _this._toggleResetPasswordForm();
                });

                this.$el.on('click', '[data-addresses-new-toggle]', function (event) {
                    event.preventDefault();
                    _this._toggleNewAddressForm();
                });

                this.$el.on('click', '[data-address-edit-toggle]', function (event) {
                    event.preventDefault();
                    _this._toggleEditAddressForm(event);
                });

                this.$el.on('click', '[data-address-delete]', function (event) {
                    event.preventDefault();
                    _this._deleteAddress(event);
                });

                this.$el.find('[data-address-country-select]').on('change', function (event) {
                    _this._prependSelect(event);
                });
            };

            Account.prototype._toggleResetPasswordForm = function _toggleResetPasswordForm() {
                var $login = this.$el.find('[data-account-login]');
                var $resetPassword = this.$el.find('[data-account-reset-password]');

                window.location.hash = '#recover';

                $resetPassword.add($login).toggleClass('visible');

                if ($resetPassword.hasClass('visible')) {
                    $resetPassword.find('.form-input').focus();
                } else {
                    $login.find('.form-input').first().focus();
                    window.location.hash = '';
                }
            };

            Account.prototype._toggleNewAddressForm = function _toggleNewAddressForm() {
                this.$el.find('[data-addresses]').add(this.$el.find('[data-addresses-new]')).toggleClass('visible');
            };

            Account.prototype._toggleEditAddressForm = function _toggleEditAddressForm(event) {
                var addressId = $(event.currentTarget).data('address-id');

                this.$el.find('[data-addresses]').add(this.$el.find('[data-addresses-edit]')).toggleClass('visible');

                this.$el.find('#address_form_' + addressId).toggleClass('visible').siblings().removeClass('visible');
            };

            Account.prototype._deleteAddress = function _deleteAddress(event) {
                var addressId = $(event.currentTarget).data('address-id');

                Shopify.CustomerAddress.destroy = function (addressId, confirm_msg) {
                    if (confirm(confirm_msg || Theme.localization.account.addressConfirmDelete)) {
                        Shopify.postLink('/account/addresses/' + addressId, {'parameters': {'_method': 'delete'}});
                    }
                };
            };

            Account.prototype._setupProvinceSelectors = function _setupProvinceSelectors() {
                new Shopify.CountryProvinceSelector('address-country-new', 'address-province-new', {
                    hideElement: 'address-province-new-wrapper'
                });

                var $addressEditForm = this.$el.find('.address-edit-form');

                $addressEditForm.each(function (index, element) {
                    var addressId = $(element).children('[data-address-id]').data('address-id');

                    new Shopify.CountryProvinceSelector('address-country-' + addressId, 'address-province-' + addressId, {
                        hideElement: 'address-province-' + addressId + '-wrapper'
                    });
                });
            };

            return Account;
        })();

        exports['default'] = Account;
        module.exports = exports['default'];

    }, {}],
    31: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;

        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError('Cannot call a class as a function');
            }
        }

        var Blog = function Blog(el) {
            var _this = this;

            _classCallCheck(this, Blog);

            this.$el = $(el);

            this.$el.allLazyLoaded().on('containerlazyloaded', function () {
                _this.$el.masonry({
                    itemSelector: '[data-blog-item]',
                    transitionDuration: 0
                });
            });
        };

        exports['default'] = Blog;
        module.exports = exports['default'];

    }, {}],
    32: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {'default': obj};
        }

        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError('Cannot call a class as a function');
            }
        }

        var _globalProductRecentlyViewed = require('../global/product/RecentlyViewed');

        var _globalProductRecentlyViewed2 = _interopRequireDefault(_globalProductRecentlyViewed);

        var Cart = (function () {
            function Cart(el) {
                _classCallCheck(this, Cart);

                this.$el = $(el);

                if (this.$el.find('[data-shipping]').length) {
                    this.$shipping = this.$el.find('[data-shipping]');
                    this.$shippingButton = this.$shipping.find('[data-shipping-rates-submit]');

                    this._initShipping();
                    this._bindShippingEvents();
                }

                if ($('[data-products-recent-wrapper]').length) {
                    new _globalProductRecentlyViewed2['default']('[data-products-recent]');
                }

                this._bindEvents();
            }

            Cart.prototype._bindEvents = function _bindEvents() {
                var _this = this;

                this.$el.on('click', '[data-cart-module-toggle]', function (event) {
                    event.preventDefault();
                    _this._toggleModule(event);
                });

                this.$el.on('click', '[data-cart-item-quantity-edit]:not(.active)', function (event) {
                    event.preventDefault();
                    _this._focusQuantityInput(event);
                });

                this.$el.on('click', '[data-cart-item-quantity-edit].active', function (event) {
                    event.preventDefault();
                    _this._updateCart();
                });
            };

            Cart.prototype._bindShippingEvents = function _bindShippingEvents() {
                var _this2 = this;

                this.$shippingButton.on('click', function (event) {
                    event.preventDefault();
                    _this2._getShippingRates();
                });

                this.$shipping.on('change', '[data-shipping-country]', function (event) {
                    _this2._updateProvince('[data-shipping-province]');
                });

                this.$el.on('click', '[data-cart-module-toggle]', function (event) {
                    _this2.$shipping.find('[data-shipping-country]').trigger('change');
                });

                Shopify.onError = function (XMLHttpRequest) {
                    _this2._handleErrors(XMLHttpRequest);
                };
            };

            Cart.prototype._focusQuantityInput = function _focusQuantityInput(event) {
                var $target = $(event.currentTarget);
                $target.addClass('active').text($target.data('text-update')).prev().select();
            };

            Cart.prototype._updateCart = function _updateCart() {
                this.$el.find('[data-cart-update]').trigger('click');
            };

            Cart.prototype._initShipping = function _initShipping() {
                this.shippingStrings = Theme.localization.cart.shipping;

                Shopify.Cart.ShippingCalculator.show({
                    submitButton: this.shippingStrings.submit,
                    submitButtonDisabled: this.shippingStrings.calculating,
                    customerIsLoggedIn: Theme.hasCustomer,
                    moneyFormat: Theme.moneyFormat
                });
            };

            Cart.prototype._getShippingRates = function _getShippingRates() {
                var _this3 = this;

                this.$shippingButton.val(this.shippingStrings.calculating);

                this.$response = this.$shipping.find('[data-shipping-response]');
                this.$response.empty().append('<p class="shipping-message" data-shipping-message /><ul class="shipping-rates" data-shipping-rates />');

                var shippingAddress = {};
                shippingAddress.zip = this.$shipping.find('[data-shipping-zip]').val() || '';
                shippingAddress.country = this.$shipping.find('[data-shipping-country]').val() || '';
                shippingAddress.province = this.$shipping.find('[data-shipping-province]').val() || '';

                Shopify.getCartShippingRatesForDestination(shippingAddress, function (rates) {
                    var address = undefined;
                    if (shippingAddress.zip.length) address = shippingAddress.zip;
                    if (shippingAddress.province.length) address = address + ', ' + shippingAddress.province;
                    if (shippingAddress.country.length) address = address + ', ' + shippingAddress.country;

                    var response = undefined;
                    if (rates.length > 1) {
                        var firstRate = Shopify.Cart.ShippingCalculator.formatRate(rates[0].price);
                        response = _this3.shippingStrings.rateMultiple.replace('*address*', address).replace('*number_of_rates*', rates.length).replace('*rate*', '<span class="money">' + firstRate + '</span>');
                    } else if (rates.length === 1) {
                        response = _this3.shippingStrings.rate.replace('*address*', address);
                    } else {
                        response = _this3.shippingStrings.rateEmpty;
                    }

                    _this3.$response.find('[data-shipping-message]').html(response);

                    $.each(rates, function (index, rate) {
                        var price = Shopify.Cart.ShippingCalculator.formatRate(rate.price);
                        var rateValues = _this3.shippingStrings.rateValues.replace('*rate_title*', rate.name).replace('*rate*', '<span class="money">' + price + '</span>');
                        _this3.$shipping.find('[data-shipping-rates]').append('<li>' + rateValues + '</li>');
                    });

                    _this3.$shippingButton.val(_this3.shippingStrings.submit);
                });
            };

            Cart.prototype._updateProvince = function _updateProvince(select) {
                var $select = $(select);
                var selectedVariant = $select.find('option:selected').val();
                $select.prev('.selected-text').text(selectedVariant);
            };

            Cart.prototype._handleErrors = function _handleErrors(errors) {
                var $rates = this.$response.find('[data-shipping-rates]');
                $rates.empty();
                errors = $.parseJSON(errors.responseText);

                $.each(errors, function (index, value) {
                    var error = index + ' ' + value;
                    $rates.append('<li>' + error + '</li>');
                });

                this.$shippingButton.val(this.shippingStrings.submit);
            };

            Cart.prototype._toggleModule = function _toggleModule(event) {
                var $target = $(event.currentTarget);

                $target.closest('[data-cart-module]').toggleClass('active').siblings('[data-cart-module]').removeClass('active');
            };

            return Cart;
        })();

        exports['default'] = Cart;
        module.exports = exports['default'];

    }, {"../global/product/RecentlyViewed": 12}],
    33: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {'default': obj};
        }

        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError('Cannot call a class as a function');
            }
        }

        var _collectionFilters = require('../collection/Filters');

        var _collectionFilters2 = _interopRequireDefault(_collectionFilters);

        var Collection = (function () {
            function Collection(el) {
                _classCallCheck(this, Collection);
                this.initCollectionSlider();

                this.$el = $(el);
                this.$collection = this.$el.find('[data-collection]');

                new _collectionFilters2['default']('[data-collection-filters]', this.$collection.data('collection'));

                this._bindEvents();
            }

            Collection.prototype._bindEvents = function _bindEvents() {
                var _this = this;

                $('.collection-sort').on('change', 'select', function (event) {
                    _this._sortProducts(event);
                });
            };
            Collection.prototype.initCollectionSlider = function initCollectionSlider() {
                var $featuredProducts = $('[data-section-child="featured-products"]');
                if ($featuredProducts.length) {
                    $featuredProducts.each(function (i, el) {
                        new window.sectionsFeaturedProducts2['default'](el);
                    });
                }
            };

            Collection.prototype._sortProducts = function _sortProducts(event) {
                var Sorting = {};
                Sorting.sort_by = event.target.value;

                if ($(event.currentTarget).closest('.collection-sort').hasClass('vendor-page')) {
                    (function () {
                        var currentSearch = location.search;
                        var searchParts = currentSearch.split('&');

                        $.each(searchParts, function (index, part) {
                            if (part.indexOf('sort_by') !== -1) {
                                searchParts.splice(index, 1);
                            }
                        });

                        var search = searchParts.join('&');
                        location.search = search + '&' + jQuery.param(Sorting);
                    })();
                } else {
                    location.search = jQuery.param(Sorting);
                }
            };

            return Collection;
        })();

        exports['default'] = Collection;
        module.exports = exports['default'];

    }, {"../collection/Filters": 5}],
    34: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {'default': obj};
        }

        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError('Cannot call a class as a function');
            }
        }

        var _sectionsVideo = require('../sections/Video');

        var _sectionsVideo2 = _interopRequireDefault(_sectionsVideo);

        var _sectionsDepartments = require('../sections/Departments');

        var _sectionsDepartments2 = _interopRequireDefault(_sectionsDepartments);

        var _sectionsFeaturedProducts = require('../sections/FeaturedProducts');

        var _sectionsFeaturedProducts2 = _interopRequireDefault(_sectionsFeaturedProducts);
        window.sectionsFeaturedProducts2 = _sectionsFeaturedProducts2;

        var _sectionsMap = require('../sections/Map');

        var _sectionsMap2 = _interopRequireDefault(_sectionsMap);

        var _globalProductProductUtils = require('../global/product/ProductUtils');

        var _globalProductProductUtils2 = _interopRequireDefault(_globalProductProductUtils);

        var _snippetsInstagram = require('../snippets/instagram');

        var _snippetsInstagram2 = _interopRequireDefault(_snippetsInstagram);

        var Home = (function () {
            function Home() {
                _classCallCheck(this, Home);

                this.initDepartments();
                this.initCollectionSlider();
                this.initInstagram();
                this.initVideo();
                this.initMaps();
                this.initFeaturedProduct();
            }

            Home.prototype.initDepartments = function initDepartments() {
                var $departments = $('[data-departments-slideshow]');
                if ($departments.length) {
                    $departments.each(function (i, el) {
                        new _sectionsDepartments2['default'](el);
                    });
                }
            };

            Home.prototype.initCollectionSlider = function initCollectionSlider() {
                var $featuredProducts = $('[data-section-child="featured-products"]');
                if ($featuredProducts.length) {
                    $featuredProducts.each(function (i, el) {
                        new _sectionsFeaturedProducts2['default'](el);
                    });
                }
            };

            Home.prototype.initInstagram = function initInstagram(sectionId) {
                var $instagram = $('[data-instagram]');
                if ($instagram.length) {
                    if (sectionId) {
                        _snippetsInstagram2['default']('[data-section-id="' + sectionId + '"]');
                    } else {
                        $instagram.each(function (i, el) {
                            _snippetsInstagram2['default'](el);
                        });
                    }
                }
            };

            Home.prototype.initVideo = function initVideo(sectionId) {
                var _this = this;

                if (sectionId) {
                    this.videos[sectionId] = new _sectionsVideo2['default']($('[data-section-id="' + sectionId + '"]'));
                } else {
                    this.videos = this.videos ? this.videos : {};
                    var $video = $('[data-video]');
                    if ($video.length) {
                        $video.each(function (i, el) {
                            var id = $(el).data('section-id');
                            _this.videos[id] = new _sectionsVideo2['default'](el);
                        });
                    }
                }
            };

            Home.prototype.initMaps = function initMaps(sectionId) {
                if (sectionId) {
                    this.maps.buildMap('[data-section-id="' + sectionId + '"]');
                } else {
                    var $map = $('[data-section-child="map"]');
                    if ($map.length) {
                        this.maps = new _sectionsMap2['default']('[data-section-child="map"]');
                    }
                }
            };

            Home.prototype.initFeaturedProduct = function initFeaturedProduct(sectionId) {
                var _this2 = this;

                if (sectionId) {
                    this.products[sectionId] = new _globalProductProductUtils2['default']($('[data-section-id="' + sectionId + '"]'), 'home');
                } else {
                    this.products = this.products ? this.products : {};
                    var $product = $('[data-section-child="featured-product"]');
                    if ($product.length) {
                        $product.each(function (i, el) {
                            var id = $(el).data('section-id');
                            _this2.products[id] = new _globalProductProductUtils2['default'](el, 'home');
                        });
                    }
                }
            };

            Home.prototype.unloadFeaturedProduct = function unloadFeaturedProduct(sectionId) {
                this.products[sectionId].unload();
            };

            return Home;
        })();

        exports['default'] = Home;
        module.exports = exports['default'];

    }, {
        "../global/product/ProductUtils": 11,
        "../sections/Departments": 13,
        "../sections/FeaturedProducts": 14,
        "../sections/Map": 15,
        "../sections/Video": 18,
        "../snippets/instagram": 29
    }],
    35: [function (require, module, exports) {
        'use strict';

        exports.__esModule = true;

        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {'default': obj};
        }

        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError('Cannot call a class as a function');
            }
        }

        var _globalProductProductUtils = require('../global/product/ProductUtils');

        var _globalProductProductUtils2 = _interopRequireDefault(_globalProductProductUtils);

        var _globalProductRecentlyViewed = require('../global/product/RecentlyViewed');

        var _globalProductRecentlyViewed2 = _interopRequireDefault(_globalProductRecentlyViewed);

        var _sectionsProductRecommendations = require('../sections/ProductRecommendations');

        var _sectionsProductRecommendations2 = _interopRequireDefault(_sectionsProductRecommendations);

        var Product = function Product(el) {
            _classCallCheck(this, Product);

            this.ProductUtils = new _globalProductProductUtils2['default'](el);
            this.ProductRecommendations = new _sectionsProductRecommendations2['default']();

            if ($('[data-products-recent-wrapper]').length) {
                new _globalProductRecentlyViewed2['default']('[data-products-recent]');
            }
        };

        exports['default'] = Product;
        module.exports = exports['default'];

    }, {
        "../global/product/ProductUtils": 11,
        "../global/product/RecentlyViewed": 12,
        "../sections/ProductRecommendations": 16
    }]
}, {}, [4]);
